/* 省市区数据 - 地址选择 */
export const regionData = [{
	"id": "110000",
	"pid": "0",
	"name": "北京",
	"y": "b",
	"child": [{
		"id": "110100",
		"pid": "110000",
		"name": "北京",
		"y": "b",
		"child": [{
			"id": "110101",
			"pid": "110100",
			"name": "东城",
			"y": "d"
		}, {
			"id": "110102",
			"pid": "110100",
			"name": "西城",
			"y": "x"
		}, {
			"id": "110105",
			"pid": "110100",
			"name": "朝阳",
			"y": "c"
		}, {
			"id": "110106",
			"pid": "110100",
			"name": "丰台",
			"y": "f"
		}, {
			"id": "110107",
			"pid": "110100",
			"name": "石景山",
			"y": "s"
		}, {
			"id": "110108",
			"pid": "110100",
			"name": "海淀",
			"y": "h"
		}, {
			"id": "110109",
			"pid": "110100",
			"name": "门头沟",
			"y": "m"
		}, {
			"id": "110111",
			"pid": "110100",
			"name": "房山",
			"y": "f"
		}, {
			"id": "110112",
			"pid": "110100",
			"name": "通州",
			"y": "t"
		}, {
			"id": "110113",
			"pid": "110100",
			"name": "顺义",
			"y": "s"
		}, {
			"id": "110114",
			"pid": "110100",
			"name": "昌平",
			"y": "c"
		}, {
			"id": "110115",
			"pid": "110100",
			"name": "大兴",
			"y": "d"
		}, {
			"id": "110116",
			"pid": "110100",
			"name": "怀柔",
			"y": "h"
		}, {
			"id": "110117",
			"pid": "110100",
			"name": "平谷",
			"y": "p"
		}, {
			"id": "110118",
			"pid": "110100",
			"name": "密云",
			"y": "m"
		}, {
			"id": "110119",
			"pid": "110100",
			"name": "延庆",
			"y": "y"
		}]
	}]
}, {
	"id": "120000",
	"pid": "0",
	"name": "天津",
	"y": "t",
	"child": [{
		"id": "120100",
		"pid": "120000",
		"name": "天津",
		"y": "t",
		"child": [{
			"id": "120101",
			"pid": "120100",
			"name": "和平",
			"y": "h"
		}, {
			"id": "120102",
			"pid": "120100",
			"name": "河东",
			"y": "h"
		}, {
			"id": "120103",
			"pid": "120100",
			"name": "河西",
			"y": "h"
		}, {
			"id": "120104",
			"pid": "120100",
			"name": "南开",
			"y": "n"
		}, {
			"id": "120105",
			"pid": "120100",
			"name": "河北",
			"y": "h"
		}, {
			"id": "120106",
			"pid": "120100",
			"name": "红桥",
			"y": "h"
		}, {
			"id": "120110",
			"pid": "120100",
			"name": "东丽",
			"y": "d"
		}, {
			"id": "120111",
			"pid": "120100",
			"name": "西青",
			"y": "x"
		}, {
			"id": "120112",
			"pid": "120100",
			"name": "津南",
			"y": "j"
		}, {
			"id": "120113",
			"pid": "120100",
			"name": "北辰",
			"y": "b"
		}, {
			"id": "120114",
			"pid": "120100",
			"name": "武清",
			"y": "w"
		}, {
			"id": "120115",
			"pid": "120100",
			"name": "宝坻",
			"y": "b"
		}, {
			"id": "120116",
			"pid": "120100",
			"name": "滨海新区",
			"y": "b"
		}, {
			"id": "120117",
			"pid": "120100",
			"name": "宁河",
			"y": "n"
		}, {
			"id": "120118",
			"pid": "120100",
			"name": "静海",
			"y": "j"
		}, {
			"id": "120119",
			"pid": "120100",
			"name": "蓟州",
			"y": "j"
		}]
	}]
}, {
	"id": "130000",
	"pid": "0",
	"name": "河北",
	"y": "h",
	"child": [{
		"id": "130100",
		"pid": "130000",
		"name": "石家庄",
		"y": "s",
		"child": [{
			"id": "130102",
			"pid": "130100",
			"name": "长安",
			"y": "c"
		}, {
			"id": "130104",
			"pid": "130100",
			"name": "桥西",
			"y": "q"
		}, {
			"id": "130105",
			"pid": "130100",
			"name": "新华",
			"y": "x"
		}, {
			"id": "130107",
			"pid": "130100",
			"name": "井陉矿区",
			"y": "j"
		}, {
			"id": "130108",
			"pid": "130100",
			"name": "裕华",
			"y": "y"
		}, {
			"id": "130109",
			"pid": "130100",
			"name": "藁城",
			"y": "g"
		}, {
			"id": "130110",
			"pid": "130100",
			"name": "鹿泉",
			"y": "l"
		}, {
			"id": "130111",
			"pid": "130100",
			"name": "栾城",
			"y": "l"
		}, {
			"id": "130121",
			"pid": "130100",
			"name": "井陉",
			"y": "j"
		}, {
			"id": "130123",
			"pid": "130100",
			"name": "正定",
			"y": "z"
		}, {
			"id": "130125",
			"pid": "130100",
			"name": "行唐",
			"y": "x"
		}, {
			"id": "130126",
			"pid": "130100",
			"name": "灵寿",
			"y": "l"
		}, {
			"id": "130127",
			"pid": "130100",
			"name": "高邑",
			"y": "g"
		}, {
			"id": "130128",
			"pid": "130100",
			"name": "深泽",
			"y": "s"
		}, {
			"id": "130129",
			"pid": "130100",
			"name": "赞皇",
			"y": "z"
		}, {
			"id": "130130",
			"pid": "130100",
			"name": "无极",
			"y": "w"
		}, {
			"id": "130131",
			"pid": "130100",
			"name": "平山",
			"y": "p"
		}, {
			"id": "130132",
			"pid": "130100",
			"name": "元氏",
			"y": "y"
		}, {
			"id": "130133",
			"pid": "130100",
			"name": "赵县",
			"y": "z"
		}, {
			"id": "130181",
			"pid": "130100",
			"name": "辛集",
			"y": "x"
		}, {
			"id": "130183",
			"pid": "130100",
			"name": "晋州",
			"y": "j"
		}, {
			"id": "130184",
			"pid": "130100",
			"name": "新乐",
			"y": "x"
		}]
	}, {
		"id": "130200",
		"pid": "130000",
		"name": "唐山",
		"y": "t",
		"child": [{
			"id": "130202",
			"pid": "130200",
			"name": "路南",
			"y": "l"
		}, {
			"id": "130203",
			"pid": "130200",
			"name": "路北",
			"y": "l"
		}, {
			"id": "130204",
			"pid": "130200",
			"name": "古冶",
			"y": "g"
		}, {
			"id": "130205",
			"pid": "130200",
			"name": "开平",
			"y": "k"
		}, {
			"id": "130207",
			"pid": "130200",
			"name": "丰南",
			"y": "f"
		}, {
			"id": "130208",
			"pid": "130200",
			"name": "丰润",
			"y": "f"
		}, {
			"id": "130209",
			"pid": "130200",
			"name": "曹妃甸",
			"y": "c"
		}, {
			"id": "130224",
			"pid": "130200",
			"name": "滦南",
			"y": "l"
		}, {
			"id": "130225",
			"pid": "130200",
			"name": "乐亭",
			"y": "l"
		}, {
			"id": "130227",
			"pid": "130200",
			"name": "迁西",
			"y": "q"
		}, {
			"id": "130229",
			"pid": "130200",
			"name": "玉田",
			"y": "y"
		}, {
			"id": "130281",
			"pid": "130200",
			"name": "遵化",
			"y": "z"
		}, {
			"id": "130283",
			"pid": "130200",
			"name": "迁安",
			"y": "q"
		}, {
			"id": "130284",
			"pid": "130200",
			"name": "滦州",
			"y": "l"
		}]
	}, {
		"id": "130300",
		"pid": "130000",
		"name": "秦皇岛",
		"y": "q",
		"child": [{
			"id": "130302",
			"pid": "130300",
			"name": "海港",
			"y": "h"
		}, {
			"id": "130303",
			"pid": "130300",
			"name": "山海关",
			"y": "s"
		}, {
			"id": "130304",
			"pid": "130300",
			"name": "北戴河",
			"y": "b"
		}, {
			"id": "130306",
			"pid": "130300",
			"name": "抚宁",
			"y": "f"
		}, {
			"id": "130321",
			"pid": "130300",
			"name": "青龙",
			"y": "q"
		}, {
			"id": "130322",
			"pid": "130300",
			"name": "昌黎",
			"y": "c"
		}, {
			"id": "130324",
			"pid": "130300",
			"name": "卢龙",
			"y": "l"
		}]
	}, {
		"id": "130400",
		"pid": "130000",
		"name": "邯郸",
		"y": "h",
		"child": [{
			"id": "130402",
			"pid": "130400",
			"name": "邯山",
			"y": "h"
		}, {
			"id": "130403",
			"pid": "130400",
			"name": "丛台",
			"y": "c"
		}, {
			"id": "130404",
			"pid": "130400",
			"name": "复兴",
			"y": "f"
		}, {
			"id": "130406",
			"pid": "130400",
			"name": "峰峰矿区",
			"y": "f"
		}, {
			"id": "130407",
			"pid": "130400",
			"name": "肥乡",
			"y": "f"
		}, {
			"id": "130408",
			"pid": "130400",
			"name": "永年",
			"y": "y"
		}, {
			"id": "130423",
			"pid": "130400",
			"name": "临漳",
			"y": "l"
		}, {
			"id": "130424",
			"pid": "130400",
			"name": "成安",
			"y": "c"
		}, {
			"id": "130425",
			"pid": "130400",
			"name": "大名",
			"y": "d"
		}, {
			"id": "130426",
			"pid": "130400",
			"name": "涉县",
			"y": "s"
		}, {
			"id": "130427",
			"pid": "130400",
			"name": "磁县",
			"y": "c"
		}, {
			"id": "130430",
			"pid": "130400",
			"name": "邱县",
			"y": "q"
		}, {
			"id": "130431",
			"pid": "130400",
			"name": "鸡泽",
			"y": "j"
		}, {
			"id": "130432",
			"pid": "130400",
			"name": "广平",
			"y": "g"
		}, {
			"id": "130433",
			"pid": "130400",
			"name": "馆陶",
			"y": "g"
		}, {
			"id": "130434",
			"pid": "130400",
			"name": "魏县",
			"y": "w"
		}, {
			"id": "130435",
			"pid": "130400",
			"name": "曲周",
			"y": "q"
		}, {
			"id": "130481",
			"pid": "130400",
			"name": "武安",
			"y": "w"
		}]
	}, {
		"id": "130500",
		"pid": "130000",
		"name": "邢台",
		"y": "x",
		"child": [{
			"id": "130502",
			"pid": "130500",
			"name": "襄都",
			"y": "x"
		}, {
			"id": "130503",
			"pid": "130500",
			"name": "信都",
			"y": "x"
		}, {
			"id": "130505",
			"pid": "130500",
			"name": "任泽",
			"y": "r"
		}, {
			"id": "130506",
			"pid": "130500",
			"name": "南和",
			"y": "n"
		}, {
			"id": "130522",
			"pid": "130500",
			"name": "临城",
			"y": "l"
		}, {
			"id": "130523",
			"pid": "130500",
			"name": "内丘",
			"y": "n"
		}, {
			"id": "130524",
			"pid": "130500",
			"name": "柏乡",
			"y": "b"
		}, {
			"id": "130525",
			"pid": "130500",
			"name": "隆尧",
			"y": "l"
		}, {
			"id": "130528",
			"pid": "130500",
			"name": "宁晋",
			"y": "n"
		}, {
			"id": "130529",
			"pid": "130500",
			"name": "巨鹿",
			"y": "j"
		}, {
			"id": "130530",
			"pid": "130500",
			"name": "新河",
			"y": "x"
		}, {
			"id": "130531",
			"pid": "130500",
			"name": "广宗",
			"y": "g"
		}, {
			"id": "130532",
			"pid": "130500",
			"name": "平乡",
			"y": "p"
		}, {
			"id": "130533",
			"pid": "130500",
			"name": "威县",
			"y": "w"
		}, {
			"id": "130534",
			"pid": "130500",
			"name": "清河",
			"y": "q"
		}, {
			"id": "130535",
			"pid": "130500",
			"name": "临西",
			"y": "l"
		}, {
			"id": "130581",
			"pid": "130500",
			"name": "南宫",
			"y": "n"
		}, {
			"id": "130582",
			"pid": "130500",
			"name": "沙河",
			"y": "s"
		}]
	}, {
		"id": "130600",
		"pid": "130000",
		"name": "保定",
		"y": "b",
		"child": [{
			"id": "130602",
			"pid": "130600",
			"name": "竞秀",
			"y": "j"
		}, {
			"id": "130606",
			"pid": "130600",
			"name": "莲池",
			"y": "l"
		}, {
			"id": "130607",
			"pid": "130600",
			"name": "满城",
			"y": "m"
		}, {
			"id": "130608",
			"pid": "130600",
			"name": "清苑",
			"y": "q"
		}, {
			"id": "130609",
			"pid": "130600",
			"name": "徐水",
			"y": "x"
		}, {
			"id": "130623",
			"pid": "130600",
			"name": "涞水",
			"y": "l"
		}, {
			"id": "130624",
			"pid": "130600",
			"name": "阜平",
			"y": "f"
		}, {
			"id": "130626",
			"pid": "130600",
			"name": "定兴",
			"y": "d"
		}, {
			"id": "130627",
			"pid": "130600",
			"name": "唐县",
			"y": "t"
		}, {
			"id": "130628",
			"pid": "130600",
			"name": "高阳",
			"y": "g"
		}, {
			"id": "130629",
			"pid": "130600",
			"name": "容城",
			"y": "r"
		}, {
			"id": "130630",
			"pid": "130600",
			"name": "涞源",
			"y": "l"
		}, {
			"id": "130631",
			"pid": "130600",
			"name": "望都",
			"y": "w"
		}, {
			"id": "130632",
			"pid": "130600",
			"name": "安新",
			"y": "a"
		}, {
			"id": "130633",
			"pid": "130600",
			"name": "易县",
			"y": "y"
		}, {
			"id": "130634",
			"pid": "130600",
			"name": "曲阳",
			"y": "q"
		}, {
			"id": "130635",
			"pid": "130600",
			"name": "蠡县",
			"y": "l"
		}, {
			"id": "130636",
			"pid": "130600",
			"name": "顺平",
			"y": "s"
		}, {
			"id": "130637",
			"pid": "130600",
			"name": "博野",
			"y": "b"
		}, {
			"id": "130638",
			"pid": "130600",
			"name": "雄县",
			"y": "x"
		}, {
			"id": "130681",
			"pid": "130600",
			"name": "涿州",
			"y": "z"
		}, {
			"id": "130682",
			"pid": "130600",
			"name": "定州",
			"y": "d"
		}, {
			"id": "130683",
			"pid": "130600",
			"name": "安国",
			"y": "a"
		}, {
			"id": "130684",
			"pid": "130600",
			"name": "高碑店",
			"y": "g"
		}]
	}, {
		"id": "130700",
		"pid": "130000",
		"name": "张家口",
		"y": "z",
		"child": [{
			"id": "130702",
			"pid": "130700",
			"name": "桥东",
			"y": "q"
		}, {
			"id": "130703",
			"pid": "130700",
			"name": "桥西",
			"y": "q"
		}, {
			"id": "130705",
			"pid": "130700",
			"name": "宣化",
			"y": "x"
		}, {
			"id": "130706",
			"pid": "130700",
			"name": "下花园",
			"y": "x"
		}, {
			"id": "130708",
			"pid": "130700",
			"name": "万全",
			"y": "w"
		}, {
			"id": "130709",
			"pid": "130700",
			"name": "崇礼",
			"y": "c"
		}, {
			"id": "130722",
			"pid": "130700",
			"name": "张北",
			"y": "z"
		}, {
			"id": "130723",
			"pid": "130700",
			"name": "康保",
			"y": "k"
		}, {
			"id": "130724",
			"pid": "130700",
			"name": "沽源",
			"y": "g"
		}, {
			"id": "130725",
			"pid": "130700",
			"name": "尚义",
			"y": "s"
		}, {
			"id": "130726",
			"pid": "130700",
			"name": "蔚县",
			"y": "y"
		}, {
			"id": "130727",
			"pid": "130700",
			"name": "阳原",
			"y": "y"
		}, {
			"id": "130728",
			"pid": "130700",
			"name": "怀安",
			"y": "h"
		}, {
			"id": "130730",
			"pid": "130700",
			"name": "怀来",
			"y": "h"
		}, {
			"id": "130731",
			"pid": "130700",
			"name": "涿鹿",
			"y": "z"
		}, {
			"id": "130732",
			"pid": "130700",
			"name": "赤城",
			"y": "c"
		}]
	}, {
		"id": "130800",
		"pid": "130000",
		"name": "承德",
		"y": "c",
		"child": [{
			"id": "130802",
			"pid": "130800",
			"name": "双桥",
			"y": "s"
		}, {
			"id": "130803",
			"pid": "130800",
			"name": "双滦",
			"y": "s"
		}, {
			"id": "130804",
			"pid": "130800",
			"name": "鹰手营子矿区",
			"y": "y"
		}, {
			"id": "130821",
			"pid": "130800",
			"name": "承德县",
			"y": "c"
		}, {
			"id": "130822",
			"pid": "130800",
			"name": "兴隆",
			"y": "x"
		}, {
			"id": "130824",
			"pid": "130800",
			"name": "滦平",
			"y": "l"
		}, {
			"id": "130825",
			"pid": "130800",
			"name": "隆化",
			"y": "l"
		}, {
			"id": "130826",
			"pid": "130800",
			"name": "丰宁",
			"y": "f"
		}, {
			"id": "130827",
			"pid": "130800",
			"name": "宽城",
			"y": "k"
		}, {
			"id": "130828",
			"pid": "130800",
			"name": "围场",
			"y": "w"
		}, {
			"id": "130881",
			"pid": "130800",
			"name": "平泉",
			"y": "p"
		}]
	}, {
		"id": "130900",
		"pid": "130000",
		"name": "沧州",
		"y": "c",
		"child": [{
			"id": "130902",
			"pid": "130900",
			"name": "新华",
			"y": "x"
		}, {
			"id": "130903",
			"pid": "130900",
			"name": "运河",
			"y": "y"
		}, {
			"id": "130921",
			"pid": "130900",
			"name": "沧县",
			"y": "c"
		}, {
			"id": "130922",
			"pid": "130900",
			"name": "青县",
			"y": "q"
		}, {
			"id": "130923",
			"pid": "130900",
			"name": "东光",
			"y": "d"
		}, {
			"id": "130924",
			"pid": "130900",
			"name": "海兴",
			"y": "h"
		}, {
			"id": "130925",
			"pid": "130900",
			"name": "盐山",
			"y": "y"
		}, {
			"id": "130926",
			"pid": "130900",
			"name": "肃宁",
			"y": "s"
		}, {
			"id": "130927",
			"pid": "130900",
			"name": "南皮",
			"y": "n"
		}, {
			"id": "130928",
			"pid": "130900",
			"name": "吴桥",
			"y": "w"
		}, {
			"id": "130929",
			"pid": "130900",
			"name": "献县",
			"y": "x"
		}, {
			"id": "130930",
			"pid": "130900",
			"name": "孟村",
			"y": "m"
		}, {
			"id": "130981",
			"pid": "130900",
			"name": "泊头",
			"y": "b"
		}, {
			"id": "130982",
			"pid": "130900",
			"name": "任丘",
			"y": "r"
		}, {
			"id": "130983",
			"pid": "130900",
			"name": "黄骅",
			"y": "h"
		}, {
			"id": "130984",
			"pid": "130900",
			"name": "河间",
			"y": "h"
		}]
	}, {
		"id": "131000",
		"pid": "130000",
		"name": "廊坊",
		"y": "l",
		"child": [{
			"id": "131002",
			"pid": "131000",
			"name": "安次",
			"y": "a"
		}, {
			"id": "131003",
			"pid": "131000",
			"name": "广阳",
			"y": "g"
		}, {
			"id": "131022",
			"pid": "131000",
			"name": "固安",
			"y": "g"
		}, {
			"id": "131023",
			"pid": "131000",
			"name": "永清",
			"y": "y"
		}, {
			"id": "131024",
			"pid": "131000",
			"name": "香河",
			"y": "x"
		}, {
			"id": "131025",
			"pid": "131000",
			"name": "大城",
			"y": "d"
		}, {
			"id": "131026",
			"pid": "131000",
			"name": "文安",
			"y": "w"
		}, {
			"id": "131028",
			"pid": "131000",
			"name": "大厂",
			"y": "d"
		}, {
			"id": "131081",
			"pid": "131000",
			"name": "霸州",
			"y": "b"
		}, {
			"id": "131082",
			"pid": "131000",
			"name": "三河",
			"y": "s"
		}]
	}, {
		"id": "131100",
		"pid": "130000",
		"name": "衡水",
		"y": "h",
		"child": [{
			"id": "131102",
			"pid": "131100",
			"name": "桃城",
			"y": "t"
		}, {
			"id": "131103",
			"pid": "131100",
			"name": "冀州",
			"y": "j"
		}, {
			"id": "131121",
			"pid": "131100",
			"name": "枣强",
			"y": "z"
		}, {
			"id": "131122",
			"pid": "131100",
			"name": "武邑",
			"y": "w"
		}, {
			"id": "131123",
			"pid": "131100",
			"name": "武强",
			"y": "w"
		}, {
			"id": "131124",
			"pid": "131100",
			"name": "饶阳",
			"y": "r"
		}, {
			"id": "131125",
			"pid": "131100",
			"name": "安平",
			"y": "a"
		}, {
			"id": "131126",
			"pid": "131100",
			"name": "故城",
			"y": "g"
		}, {
			"id": "131127",
			"pid": "131100",
			"name": "景县",
			"y": "j"
		}, {
			"id": "131128",
			"pid": "131100",
			"name": "阜城",
			"y": "f"
		}, {
			"id": "131182",
			"pid": "131100",
			"name": "深州",
			"y": "s"
		}]
	}]
}, {
	"id": "140000",
	"pid": "0",
	"name": "山西",
	"y": "s",
	"child": [{
		"id": "140100",
		"pid": "140000",
		"name": "太原",
		"y": "t",
		"child": [{
			"id": "140105",
			"pid": "140100",
			"name": "小店",
			"y": "x"
		}, {
			"id": "140106",
			"pid": "140100",
			"name": "迎泽",
			"y": "y"
		}, {
			"id": "140107",
			"pid": "140100",
			"name": "杏花岭",
			"y": "x"
		}, {
			"id": "140108",
			"pid": "140100",
			"name": "尖草坪",
			"y": "j"
		}, {
			"id": "140109",
			"pid": "140100",
			"name": "万柏林",
			"y": "w"
		}, {
			"id": "140110",
			"pid": "140100",
			"name": "晋源",
			"y": "j"
		}, {
			"id": "140121",
			"pid": "140100",
			"name": "清徐",
			"y": "q"
		}, {
			"id": "140122",
			"pid": "140100",
			"name": "阳曲",
			"y": "y"
		}, {
			"id": "140123",
			"pid": "140100",
			"name": "娄烦",
			"y": "l"
		}, {
			"id": "140181",
			"pid": "140100",
			"name": "古交",
			"y": "g"
		}]
	}, {
		"id": "140200",
		"pid": "140000",
		"name": "大同",
		"y": "d",
		"child": [{
			"id": "140212",
			"pid": "140200",
			"name": "新荣",
			"y": "x"
		}, {
			"id": "140213",
			"pid": "140200",
			"name": "平城",
			"y": "p"
		}, {
			"id": "140214",
			"pid": "140200",
			"name": "云冈",
			"y": "y"
		}, {
			"id": "140215",
			"pid": "140200",
			"name": "云州",
			"y": "y"
		}, {
			"id": "140221",
			"pid": "140200",
			"name": "阳高",
			"y": "y"
		}, {
			"id": "140222",
			"pid": "140200",
			"name": "天镇",
			"y": "t"
		}, {
			"id": "140223",
			"pid": "140200",
			"name": "广灵",
			"y": "g"
		}, {
			"id": "140224",
			"pid": "140200",
			"name": "灵丘",
			"y": "l"
		}, {
			"id": "140225",
			"pid": "140200",
			"name": "浑源",
			"y": "h"
		}, {
			"id": "140226",
			"pid": "140200",
			"name": "左云",
			"y": "z"
		}]
	}, {
		"id": "140300",
		"pid": "140000",
		"name": "阳泉",
		"y": "y",
		"child": [{
			"id": "140302",
			"pid": "140300",
			"name": "城区",
			"y": "c"
		}, {
			"id": "140303",
			"pid": "140300",
			"name": "矿区",
			"y": "k"
		}, {
			"id": "140311",
			"pid": "140300",
			"name": "郊区",
			"y": "j"
		}, {
			"id": "140321",
			"pid": "140300",
			"name": "平定",
			"y": "p"
		}, {
			"id": "140322",
			"pid": "140300",
			"name": "盂县",
			"y": "y"
		}]
	}, {
		"id": "140400",
		"pid": "140000",
		"name": "长治",
		"y": "c",
		"child": [{
			"id": "140403",
			"pid": "140400",
			"name": "潞州",
			"y": "l"
		}, {
			"id": "140404",
			"pid": "140400",
			"name": "上党",
			"y": "s"
		}, {
			"id": "140405",
			"pid": "140400",
			"name": "屯留",
			"y": "t"
		}, {
			"id": "140406",
			"pid": "140400",
			"name": "潞城",
			"y": "l"
		}, {
			"id": "140423",
			"pid": "140400",
			"name": "襄垣",
			"y": "x"
		}, {
			"id": "140425",
			"pid": "140400",
			"name": "平顺",
			"y": "p"
		}, {
			"id": "140426",
			"pid": "140400",
			"name": "黎城",
			"y": "l"
		}, {
			"id": "140427",
			"pid": "140400",
			"name": "壶关",
			"y": "h"
		}, {
			"id": "140428",
			"pid": "140400",
			"name": "长子",
			"y": "z"
		}, {
			"id": "140429",
			"pid": "140400",
			"name": "武乡",
			"y": "w"
		}, {
			"id": "140430",
			"pid": "140400",
			"name": "沁县",
			"y": "q"
		}, {
			"id": "140431",
			"pid": "140400",
			"name": "沁源",
			"y": "q"
		}]
	}, {
		"id": "140500",
		"pid": "140000",
		"name": "晋城",
		"y": "j",
		"child": [{
			"id": "140502",
			"pid": "140500",
			"name": "城区",
			"y": "c"
		}, {
			"id": "140521",
			"pid": "140500",
			"name": "沁水",
			"y": "q"
		}, {
			"id": "140522",
			"pid": "140500",
			"name": "阳城",
			"y": "y"
		}, {
			"id": "140524",
			"pid": "140500",
			"name": "陵川",
			"y": "l"
		}, {
			"id": "140525",
			"pid": "140500",
			"name": "泽州",
			"y": "z"
		}, {
			"id": "140581",
			"pid": "140500",
			"name": "高平",
			"y": "g"
		}]
	}, {
		"id": "140600",
		"pid": "140000",
		"name": "朔州",
		"y": "s",
		"child": [{
			"id": "140602",
			"pid": "140600",
			"name": "朔城",
			"y": "s"
		}, {
			"id": "140603",
			"pid": "140600",
			"name": "平鲁",
			"y": "p"
		}, {
			"id": "140621",
			"pid": "140600",
			"name": "山阴",
			"y": "s"
		}, {
			"id": "140622",
			"pid": "140600",
			"name": "应县",
			"y": "y"
		}, {
			"id": "140623",
			"pid": "140600",
			"name": "右玉",
			"y": "y"
		}, {
			"id": "140681",
			"pid": "140600",
			"name": "怀仁",
			"y": "h"
		}]
	}, {
		"id": "140700",
		"pid": "140000",
		"name": "晋中",
		"y": "j",
		"child": [{
			"id": "140702",
			"pid": "140700",
			"name": "榆次",
			"y": "y"
		}, {
			"id": "140703",
			"pid": "140700",
			"name": "太谷",
			"y": "t"
		}, {
			"id": "140721",
			"pid": "140700",
			"name": "榆社",
			"y": "y"
		}, {
			"id": "140722",
			"pid": "140700",
			"name": "左权",
			"y": "z"
		}, {
			"id": "140723",
			"pid": "140700",
			"name": "和顺",
			"y": "h"
		}, {
			"id": "140724",
			"pid": "140700",
			"name": "昔阳",
			"y": "x"
		}, {
			"id": "140725",
			"pid": "140700",
			"name": "寿阳",
			"y": "s"
		}, {
			"id": "140727",
			"pid": "140700",
			"name": "祁县",
			"y": "q"
		}, {
			"id": "140728",
			"pid": "140700",
			"name": "平遥",
			"y": "p"
		}, {
			"id": "140729",
			"pid": "140700",
			"name": "灵石",
			"y": "l"
		}, {
			"id": "140781",
			"pid": "140700",
			"name": "介休",
			"y": "j"
		}]
	}, {
		"id": "140800",
		"pid": "140000",
		"name": "运城",
		"y": "y",
		"child": [{
			"id": "140802",
			"pid": "140800",
			"name": "盐湖",
			"y": "y"
		}, {
			"id": "140821",
			"pid": "140800",
			"name": "临猗",
			"y": "l"
		}, {
			"id": "140822",
			"pid": "140800",
			"name": "万荣",
			"y": "w"
		}, {
			"id": "140823",
			"pid": "140800",
			"name": "闻喜",
			"y": "w"
		}, {
			"id": "140824",
			"pid": "140800",
			"name": "稷山",
			"y": "j"
		}, {
			"id": "140825",
			"pid": "140800",
			"name": "新绛",
			"y": "x"
		}, {
			"id": "140826",
			"pid": "140800",
			"name": "绛县",
			"y": "j"
		}, {
			"id": "140827",
			"pid": "140800",
			"name": "垣曲",
			"y": "y"
		}, {
			"id": "140828",
			"pid": "140800",
			"name": "夏县",
			"y": "x"
		}, {
			"id": "140829",
			"pid": "140800",
			"name": "平陆",
			"y": "p"
		}, {
			"id": "140830",
			"pid": "140800",
			"name": "芮城",
			"y": "r"
		}, {
			"id": "140881",
			"pid": "140800",
			"name": "永济",
			"y": "y"
		}, {
			"id": "140882",
			"pid": "140800",
			"name": "河津",
			"y": "h"
		}]
	}, {
		"id": "140900",
		"pid": "140000",
		"name": "忻州",
		"y": "x",
		"child": [{
			"id": "140902",
			"pid": "140900",
			"name": "忻府",
			"y": "x"
		}, {
			"id": "140921",
			"pid": "140900",
			"name": "定襄",
			"y": "d"
		}, {
			"id": "140922",
			"pid": "140900",
			"name": "五台",
			"y": "w"
		}, {
			"id": "140923",
			"pid": "140900",
			"name": "代县",
			"y": "d"
		}, {
			"id": "140924",
			"pid": "140900",
			"name": "繁峙",
			"y": "f"
		}, {
			"id": "140925",
			"pid": "140900",
			"name": "宁武",
			"y": "n"
		}, {
			"id": "140926",
			"pid": "140900",
			"name": "静乐",
			"y": "j"
		}, {
			"id": "140927",
			"pid": "140900",
			"name": "神池",
			"y": "s"
		}, {
			"id": "140928",
			"pid": "140900",
			"name": "五寨",
			"y": "w"
		}, {
			"id": "140929",
			"pid": "140900",
			"name": "岢岚",
			"y": "k"
		}, {
			"id": "140930",
			"pid": "140900",
			"name": "河曲",
			"y": "h"
		}, {
			"id": "140931",
			"pid": "140900",
			"name": "保德",
			"y": "b"
		}, {
			"id": "140932",
			"pid": "140900",
			"name": "偏关",
			"y": "p"
		}, {
			"id": "140981",
			"pid": "140900",
			"name": "原平",
			"y": "y"
		}]
	}, {
		"id": "141000",
		"pid": "140000",
		"name": "临汾",
		"y": "l",
		"child": [{
			"id": "141002",
			"pid": "141000",
			"name": "尧都",
			"y": "y"
		}, {
			"id": "141021",
			"pid": "141000",
			"name": "曲沃",
			"y": "q"
		}, {
			"id": "141022",
			"pid": "141000",
			"name": "翼城",
			"y": "y"
		}, {
			"id": "141023",
			"pid": "141000",
			"name": "襄汾",
			"y": "x"
		}, {
			"id": "141024",
			"pid": "141000",
			"name": "洪洞",
			"y": "h"
		}, {
			"id": "141025",
			"pid": "141000",
			"name": "古县",
			"y": "g"
		}, {
			"id": "141026",
			"pid": "141000",
			"name": "安泽",
			"y": "a"
		}, {
			"id": "141027",
			"pid": "141000",
			"name": "浮山",
			"y": "f"
		}, {
			"id": "141028",
			"pid": "141000",
			"name": "吉县",
			"y": "j"
		}, {
			"id": "141029",
			"pid": "141000",
			"name": "乡宁",
			"y": "x"
		}, {
			"id": "141030",
			"pid": "141000",
			"name": "大宁",
			"y": "d"
		}, {
			"id": "141031",
			"pid": "141000",
			"name": "隰县",
			"y": "x"
		}, {
			"id": "141032",
			"pid": "141000",
			"name": "永和",
			"y": "y"
		}, {
			"id": "141033",
			"pid": "141000",
			"name": "蒲县",
			"y": "p"
		}, {
			"id": "141034",
			"pid": "141000",
			"name": "汾西",
			"y": "f"
		}, {
			"id": "141081",
			"pid": "141000",
			"name": "侯马",
			"y": "h"
		}, {
			"id": "141082",
			"pid": "141000",
			"name": "霍州",
			"y": "h"
		}]
	}, {
		"id": "141100",
		"pid": "140000",
		"name": "吕梁",
		"y": "l",
		"child": [{
			"id": "141102",
			"pid": "141100",
			"name": "离石",
			"y": "l"
		}, {
			"id": "141121",
			"pid": "141100",
			"name": "文水",
			"y": "w"
		}, {
			"id": "141122",
			"pid": "141100",
			"name": "交城",
			"y": "j"
		}, {
			"id": "141123",
			"pid": "141100",
			"name": "兴县",
			"y": "x"
		}, {
			"id": "141124",
			"pid": "141100",
			"name": "临县",
			"y": "l"
		}, {
			"id": "141125",
			"pid": "141100",
			"name": "柳林",
			"y": "l"
		}, {
			"id": "141126",
			"pid": "141100",
			"name": "石楼",
			"y": "s"
		}, {
			"id": "141127",
			"pid": "141100",
			"name": "岚县",
			"y": "l"
		}, {
			"id": "141128",
			"pid": "141100",
			"name": "方山",
			"y": "f"
		}, {
			"id": "141129",
			"pid": "141100",
			"name": "中阳",
			"y": "z"
		}, {
			"id": "141130",
			"pid": "141100",
			"name": "交口",
			"y": "j"
		}, {
			"id": "141181",
			"pid": "141100",
			"name": "孝义",
			"y": "x"
		}, {
			"id": "141182",
			"pid": "141100",
			"name": "汾阳",
			"y": "f"
		}]
	}]
}, {
	"id": "150000",
	"pid": "0",
	"name": "内蒙古",
	"y": "n",
	"child": [{
		"id": "150100",
		"pid": "150000",
		"name": "呼和浩特",
		"y": "h",
		"child": [{
			"id": "150102",
			"pid": "150100",
			"name": "新城",
			"y": "x"
		}, {
			"id": "150103",
			"pid": "150100",
			"name": "回民",
			"y": "h"
		}, {
			"id": "150104",
			"pid": "150100",
			"name": "玉泉",
			"y": "y"
		}, {
			"id": "150105",
			"pid": "150100",
			"name": "赛罕",
			"y": "s"
		}, {
			"id": "150121",
			"pid": "150100",
			"name": "土默特左旗",
			"y": "t"
		}, {
			"id": "150122",
			"pid": "150100",
			"name": "托克托",
			"y": "t"
		}, {
			"id": "150123",
			"pid": "150100",
			"name": "和林格尔",
			"y": "h"
		}, {
			"id": "150124",
			"pid": "150100",
			"name": "清水河",
			"y": "q"
		}, {
			"id": "150125",
			"pid": "150100",
			"name": "武川",
			"y": "w"
		}]
	}, {
		"id": "150200",
		"pid": "150000",
		"name": "包头",
		"y": "b",
		"child": [{
			"id": "150202",
			"pid": "150200",
			"name": "东河",
			"y": "d"
		}, {
			"id": "150203",
			"pid": "150200",
			"name": "昆都仑",
			"y": "k"
		}, {
			"id": "150204",
			"pid": "150200",
			"name": "青山",
			"y": "q"
		}, {
			"id": "150205",
			"pid": "150200",
			"name": "石拐",
			"y": "s"
		}, {
			"id": "150206",
			"pid": "150200",
			"name": "白云鄂博矿区",
			"y": "b"
		}, {
			"id": "150207",
			"pid": "150200",
			"name": "九原",
			"y": "j"
		}, {
			"id": "150221",
			"pid": "150200",
			"name": "土默特右旗",
			"y": "t"
		}, {
			"id": "150222",
			"pid": "150200",
			"name": "固阳",
			"y": "g"
		}, {
			"id": "150223",
			"pid": "150200",
			"name": "达尔罕茂明安联合旗",
			"y": "d"
		}]
	}, {
		"id": "150300",
		"pid": "150000",
		"name": "乌海",
		"y": "w",
		"child": [{
			"id": "150302",
			"pid": "150300",
			"name": "海勃湾",
			"y": "h"
		}, {
			"id": "150303",
			"pid": "150300",
			"name": "海南",
			"y": "h"
		}, {
			"id": "150304",
			"pid": "150300",
			"name": "乌达",
			"y": "w"
		}]
	}, {
		"id": "150400",
		"pid": "150000",
		"name": "赤峰",
		"y": "c",
		"child": [{
			"id": "150402",
			"pid": "150400",
			"name": "红山",
			"y": "h"
		}, {
			"id": "150403",
			"pid": "150400",
			"name": "元宝山",
			"y": "y"
		}, {
			"id": "150404",
			"pid": "150400",
			"name": "松山",
			"y": "s"
		}, {
			"id": "150421",
			"pid": "150400",
			"name": "阿鲁科尔沁旗",
			"y": "a"
		}, {
			"id": "150422",
			"pid": "150400",
			"name": "巴林左旗",
			"y": "b"
		}, {
			"id": "150423",
			"pid": "150400",
			"name": "巴林右旗",
			"y": "b"
		}, {
			"id": "150424",
			"pid": "150400",
			"name": "林西",
			"y": "l"
		}, {
			"id": "150425",
			"pid": "150400",
			"name": "克什克腾旗",
			"y": "k"
		}, {
			"id": "150426",
			"pid": "150400",
			"name": "翁牛特旗",
			"y": "w"
		}, {
			"id": "150428",
			"pid": "150400",
			"name": "喀喇沁旗",
			"y": "k"
		}, {
			"id": "150429",
			"pid": "150400",
			"name": "宁城",
			"y": "n"
		}, {
			"id": "150430",
			"pid": "150400",
			"name": "敖汉旗",
			"y": "a"
		}]
	}, {
		"id": "150500",
		"pid": "150000",
		"name": "通辽",
		"y": "t",
		"child": [{
			"id": "150502",
			"pid": "150500",
			"name": "科尔沁",
			"y": "k"
		}, {
			"id": "150521",
			"pid": "150500",
			"name": "科尔沁左翼中旗",
			"y": "k"
		}, {
			"id": "150522",
			"pid": "150500",
			"name": "科尔沁左翼后旗",
			"y": "k"
		}, {
			"id": "150523",
			"pid": "150500",
			"name": "开鲁",
			"y": "k"
		}, {
			"id": "150524",
			"pid": "150500",
			"name": "库伦旗",
			"y": "k"
		}, {
			"id": "150525",
			"pid": "150500",
			"name": "奈曼旗",
			"y": "n"
		}, {
			"id": "150526",
			"pid": "150500",
			"name": "扎鲁特旗",
			"y": "z"
		}, {
			"id": "150581",
			"pid": "150500",
			"name": "霍林郭勒",
			"y": "h"
		}]
	}, {
		"id": "150600",
		"pid": "150000",
		"name": "鄂尔多斯",
		"y": "e",
		"child": [{
			"id": "150602",
			"pid": "150600",
			"name": "东胜",
			"y": "d"
		}, {
			"id": "150603",
			"pid": "150600",
			"name": "康巴什",
			"y": "k"
		}, {
			"id": "150621",
			"pid": "150600",
			"name": "达拉特旗",
			"y": "d"
		}, {
			"id": "150622",
			"pid": "150600",
			"name": "准格尔旗",
			"y": "z"
		}, {
			"id": "150623",
			"pid": "150600",
			"name": "鄂托克前旗",
			"y": "e"
		}, {
			"id": "150624",
			"pid": "150600",
			"name": "鄂托克旗",
			"y": "e"
		}, {
			"id": "150625",
			"pid": "150600",
			"name": "杭锦旗",
			"y": "h"
		}, {
			"id": "150626",
			"pid": "150600",
			"name": "乌审旗",
			"y": "w"
		}, {
			"id": "150627",
			"pid": "150600",
			"name": "伊金霍洛旗",
			"y": "y"
		}]
	}, {
		"id": "150700",
		"pid": "150000",
		"name": "呼伦贝尔",
		"y": "h",
		"child": [{
			"id": "150702",
			"pid": "150700",
			"name": "海拉尔",
			"y": "h"
		}, {
			"id": "150703",
			"pid": "150700",
			"name": "扎赉诺尔区",
			"y": "z"
		}, {
			"id": "150721",
			"pid": "150700",
			"name": "阿荣旗",
			"y": "a"
		}, {
			"id": "150722",
			"pid": "150700",
			"name": "莫力达瓦",
			"y": "m"
		}, {
			"id": "150723",
			"pid": "150700",
			"name": "鄂伦春自治旗",
			"y": "e"
		}, {
			"id": "150724",
			"pid": "150700",
			"name": "鄂温克族自治旗",
			"y": "e"
		}, {
			"id": "150725",
			"pid": "150700",
			"name": "陈巴尔虎旗",
			"y": "c"
		}, {
			"id": "150726",
			"pid": "150700",
			"name": "新巴尔虎左旗",
			"y": "x"
		}, {
			"id": "150727",
			"pid": "150700",
			"name": "新巴尔虎右旗",
			"y": "x"
		}, {
			"id": "150781",
			"pid": "150700",
			"name": "满洲里",
			"y": "m"
		}, {
			"id": "150782",
			"pid": "150700",
			"name": "牙克石",
			"y": "y"
		}, {
			"id": "150783",
			"pid": "150700",
			"name": "扎兰屯",
			"y": "z"
		}, {
			"id": "150784",
			"pid": "150700",
			"name": "额尔古纳",
			"y": "e"
		}, {
			"id": "150785",
			"pid": "150700",
			"name": "根河",
			"y": "g"
		}]
	}, {
		"id": "150800",
		"pid": "150000",
		"name": "巴彦淖尔",
		"y": "b",
		"child": [{
			"id": "150802",
			"pid": "150800",
			"name": "临河",
			"y": "l"
		}, {
			"id": "150821",
			"pid": "150800",
			"name": "五原",
			"y": "w"
		}, {
			"id": "150822",
			"pid": "150800",
			"name": "磴口",
			"y": "d"
		}, {
			"id": "150823",
			"pid": "150800",
			"name": "乌拉特前旗",
			"y": "w"
		}, {
			"id": "150824",
			"pid": "150800",
			"name": "乌拉特中旗",
			"y": "w"
		}, {
			"id": "150825",
			"pid": "150800",
			"name": "乌拉特后旗",
			"y": "w"
		}, {
			"id": "150826",
			"pid": "150800",
			"name": "杭锦后旗",
			"y": "h"
		}]
	}, {
		"id": "150900",
		"pid": "150000",
		"name": "乌兰察布",
		"y": "w",
		"child": [{
			"id": "150902",
			"pid": "150900",
			"name": "集宁",
			"y": "j"
		}, {
			"id": "150921",
			"pid": "150900",
			"name": "卓资",
			"y": "z"
		}, {
			"id": "150922",
			"pid": "150900",
			"name": "化德",
			"y": "h"
		}, {
			"id": "150923",
			"pid": "150900",
			"name": "商都",
			"y": "s"
		}, {
			"id": "150924",
			"pid": "150900",
			"name": "兴和",
			"y": "x"
		}, {
			"id": "150925",
			"pid": "150900",
			"name": "凉城",
			"y": "l"
		}, {
			"id": "150926",
			"pid": "150900",
			"name": "察哈尔右翼前旗",
			"y": "c"
		}, {
			"id": "150927",
			"pid": "150900",
			"name": "察哈尔右翼中旗",
			"y": "c"
		}, {
			"id": "150928",
			"pid": "150900",
			"name": "察哈尔右翼后旗",
			"y": "c"
		}, {
			"id": "150929",
			"pid": "150900",
			"name": "四子王旗",
			"y": "s"
		}, {
			"id": "150981",
			"pid": "150900",
			"name": "丰镇",
			"y": "f"
		}]
	}, {
		"id": "152200",
		"pid": "150000",
		"name": "兴安",
		"y": "x",
		"child": [{
			"id": "152201",
			"pid": "152200",
			"name": "乌兰浩特",
			"y": "w"
		}, {
			"id": "152202",
			"pid": "152200",
			"name": "阿尔山",
			"y": "a"
		}, {
			"id": "152221",
			"pid": "152200",
			"name": "科尔沁右翼前旗",
			"y": "k"
		}, {
			"id": "152222",
			"pid": "152200",
			"name": "科尔沁右翼中旗",
			"y": "k"
		}, {
			"id": "152223",
			"pid": "152200",
			"name": "扎赉特旗",
			"y": "z"
		}, {
			"id": "152224",
			"pid": "152200",
			"name": "突泉",
			"y": "t"
		}]
	}, {
		"id": "152500",
		"pid": "150000",
		"name": "锡林郭勒",
		"y": "x",
		"child": [{
			"id": "152501",
			"pid": "152500",
			"name": "二连浩特",
			"y": "e"
		}, {
			"id": "152502",
			"pid": "152500",
			"name": "锡林浩特",
			"y": "x"
		}, {
			"id": "152522",
			"pid": "152500",
			"name": "阿巴嘎旗",
			"y": "a"
		}, {
			"id": "152523",
			"pid": "152500",
			"name": "苏尼特左旗",
			"y": "s"
		}, {
			"id": "152524",
			"pid": "152500",
			"name": "苏尼特右旗",
			"y": "s"
		}, {
			"id": "152525",
			"pid": "152500",
			"name": "东乌珠穆沁旗",
			"y": "d"
		}, {
			"id": "152526",
			"pid": "152500",
			"name": "西乌珠穆沁旗",
			"y": "x"
		}, {
			"id": "152527",
			"pid": "152500",
			"name": "太仆寺旗",
			"y": "t"
		}, {
			"id": "152528",
			"pid": "152500",
			"name": "镶黄旗",
			"y": "x"
		}, {
			"id": "152529",
			"pid": "152500",
			"name": "正镶白旗",
			"y": "z"
		}, {
			"id": "152530",
			"pid": "152500",
			"name": "正蓝旗",
			"y": "z"
		}, {
			"id": "152531",
			"pid": "152500",
			"name": "多伦",
			"y": "d"
		}]
	}, {
		"id": "152900",
		"pid": "150000",
		"name": "阿拉善",
		"y": "a",
		"child": [{
			"id": "152921",
			"pid": "152900",
			"name": "阿拉善左旗",
			"y": "a"
		}, {
			"id": "152922",
			"pid": "152900",
			"name": "阿拉善右旗",
			"y": "a"
		}, {
			"id": "152923",
			"pid": "152900",
			"name": "额济纳旗",
			"y": "e"
		}]
	}]
}, {
	"id": "210000",
	"pid": "0",
	"name": "辽宁",
	"y": "l",
	"child": [{
		"id": "210100",
		"pid": "210000",
		"name": "沈阳",
		"y": "s",
		"child": [{
			"id": "210102",
			"pid": "210100",
			"name": "和平",
			"y": "h"
		}, {
			"id": "210103",
			"pid": "210100",
			"name": "沈河",
			"y": "s"
		}, {
			"id": "210104",
			"pid": "210100",
			"name": "大东",
			"y": "d"
		}, {
			"id": "210105",
			"pid": "210100",
			"name": "皇姑",
			"y": "h"
		}, {
			"id": "210106",
			"pid": "210100",
			"name": "铁西",
			"y": "t"
		}, {
			"id": "210111",
			"pid": "210100",
			"name": "苏家屯",
			"y": "s"
		}, {
			"id": "210112",
			"pid": "210100",
			"name": "浑南",
			"y": "h"
		}, {
			"id": "210113",
			"pid": "210100",
			"name": "沈北新区",
			"y": "s"
		}, {
			"id": "210114",
			"pid": "210100",
			"name": "于洪",
			"y": "y"
		}, {
			"id": "210115",
			"pid": "210100",
			"name": "辽中",
			"y": "l"
		}, {
			"id": "210123",
			"pid": "210100",
			"name": "康平",
			"y": "k"
		}, {
			"id": "210124",
			"pid": "210100",
			"name": "法库",
			"y": "f"
		}, {
			"id": "210181",
			"pid": "210100",
			"name": "新民",
			"y": "x"
		}]
	}, {
		"id": "210200",
		"pid": "210000",
		"name": "大连",
		"y": "d",
		"child": [{
			"id": "210202",
			"pid": "210200",
			"name": "中山",
			"y": "z"
		}, {
			"id": "210203",
			"pid": "210200",
			"name": "西岗",
			"y": "x"
		}, {
			"id": "210204",
			"pid": "210200",
			"name": "沙河口",
			"y": "s"
		}, {
			"id": "210211",
			"pid": "210200",
			"name": "甘井子",
			"y": "g"
		}, {
			"id": "210212",
			"pid": "210200",
			"name": "旅顺口",
			"y": "l"
		}, {
			"id": "210213",
			"pid": "210200",
			"name": "金州",
			"y": "j"
		}, {
			"id": "210214",
			"pid": "210200",
			"name": "普兰店",
			"y": "p"
		}, {
			"id": "210224",
			"pid": "210200",
			"name": "长海",
			"y": "c"
		}, {
			"id": "210281",
			"pid": "210200",
			"name": "瓦房店",
			"y": "w"
		}, {
			"id": "210283",
			"pid": "210200",
			"name": "庄河",
			"y": "z"
		}]
	}, {
		"id": "210300",
		"pid": "210000",
		"name": "鞍山",
		"y": "a",
		"child": [{
			"id": "210302",
			"pid": "210300",
			"name": "铁东",
			"y": "t"
		}, {
			"id": "210303",
			"pid": "210300",
			"name": "铁西",
			"y": "t"
		}, {
			"id": "210304",
			"pid": "210300",
			"name": "立山",
			"y": "l"
		}, {
			"id": "210311",
			"pid": "210300",
			"name": "千山",
			"y": "q"
		}, {
			"id": "210321",
			"pid": "210300",
			"name": "台安",
			"y": "t"
		}, {
			"id": "210323",
			"pid": "210300",
			"name": "岫岩",
			"y": "x"
		}, {
			"id": "210381",
			"pid": "210300",
			"name": "海城",
			"y": "h"
		}]
	}, {
		"id": "210400",
		"pid": "210000",
		"name": "抚顺",
		"y": "f",
		"child": [{
			"id": "210402",
			"pid": "210400",
			"name": "新抚",
			"y": "x"
		}, {
			"id": "210403",
			"pid": "210400",
			"name": "东洲",
			"y": "d"
		}, {
			"id": "210404",
			"pid": "210400",
			"name": "望花",
			"y": "w"
		}, {
			"id": "210411",
			"pid": "210400",
			"name": "顺城",
			"y": "s"
		}, {
			"id": "210421",
			"pid": "210400",
			"name": "抚顺县",
			"y": "f"
		}, {
			"id": "210422",
			"pid": "210400",
			"name": "新宾",
			"y": "x"
		}, {
			"id": "210423",
			"pid": "210400",
			"name": "清原",
			"y": "q"
		}]
	}, {
		"id": "210500",
		"pid": "210000",
		"name": "本溪",
		"y": "b",
		"child": [{
			"id": "210502",
			"pid": "210500",
			"name": "平山",
			"y": "p"
		}, {
			"id": "210503",
			"pid": "210500",
			"name": "溪湖",
			"y": "x"
		}, {
			"id": "210504",
			"pid": "210500",
			"name": "明山",
			"y": "m"
		}, {
			"id": "210505",
			"pid": "210500",
			"name": "南芬",
			"y": "n"
		}, {
			"id": "210521",
			"pid": "210500",
			"name": "本溪满族自治县",
			"y": "b"
		}, {
			"id": "210522",
			"pid": "210500",
			"name": "桓仁",
			"y": "h"
		}]
	}, {
		"id": "210600",
		"pid": "210000",
		"name": "丹东",
		"y": "d",
		"child": [{
			"id": "210602",
			"pid": "210600",
			"name": "元宝",
			"y": "y"
		}, {
			"id": "210603",
			"pid": "210600",
			"name": "振兴",
			"y": "z"
		}, {
			"id": "210604",
			"pid": "210600",
			"name": "振安",
			"y": "z"
		}, {
			"id": "210624",
			"pid": "210600",
			"name": "宽甸",
			"y": "k"
		}, {
			"id": "210681",
			"pid": "210600",
			"name": "东港",
			"y": "d"
		}, {
			"id": "210682",
			"pid": "210600",
			"name": "凤城",
			"y": "f"
		}]
	}, {
		"id": "210700",
		"pid": "210000",
		"name": "锦州",
		"y": "j",
		"child": [{
			"id": "210702",
			"pid": "210700",
			"name": "古塔",
			"y": "g"
		}, {
			"id": "210703",
			"pid": "210700",
			"name": "凌河",
			"y": "l"
		}, {
			"id": "210711",
			"pid": "210700",
			"name": "太和",
			"y": "t"
		}, {
			"id": "210726",
			"pid": "210700",
			"name": "黑山",
			"y": "h"
		}, {
			"id": "210727",
			"pid": "210700",
			"name": "义县",
			"y": "y"
		}, {
			"id": "210781",
			"pid": "210700",
			"name": "凌海",
			"y": "l"
		}, {
			"id": "210782",
			"pid": "210700",
			"name": "北镇",
			"y": "b"
		}]
	}, {
		"id": "210800",
		"pid": "210000",
		"name": "营口",
		"y": "y",
		"child": [{
			"id": "210802",
			"pid": "210800",
			"name": "站前",
			"y": "z"
		}, {
			"id": "210803",
			"pid": "210800",
			"name": "西市",
			"y": "x"
		}, {
			"id": "210804",
			"pid": "210800",
			"name": "鲅鱼圈",
			"y": "b"
		}, {
			"id": "210811",
			"pid": "210800",
			"name": "老边",
			"y": "l"
		}, {
			"id": "210881",
			"pid": "210800",
			"name": "盖州",
			"y": "g"
		}, {
			"id": "210882",
			"pid": "210800",
			"name": "大石桥",
			"y": "d"
		}]
	}, {
		"id": "210900",
		"pid": "210000",
		"name": "阜新",
		"y": "f",
		"child": [{
			"id": "210902",
			"pid": "210900",
			"name": "海州",
			"y": "h"
		}, {
			"id": "210903",
			"pid": "210900",
			"name": "新邱",
			"y": "x"
		}, {
			"id": "210904",
			"pid": "210900",
			"name": "太平",
			"y": "t"
		}, {
			"id": "210905",
			"pid": "210900",
			"name": "清河门",
			"y": "q"
		}, {
			"id": "210911",
			"pid": "210900",
			"name": "细河",
			"y": "x"
		}, {
			"id": "210921",
			"pid": "210900",
			"name": "阜新蒙古族自治县",
			"y": "f"
		}, {
			"id": "210922",
			"pid": "210900",
			"name": "彰武",
			"y": "z"
		}]
	}, {
		"id": "211000",
		"pid": "210000",
		"name": "辽阳",
		"y": "l",
		"child": [{
			"id": "211002",
			"pid": "211000",
			"name": "白塔",
			"y": "b"
		}, {
			"id": "211003",
			"pid": "211000",
			"name": "文圣",
			"y": "w"
		}, {
			"id": "211004",
			"pid": "211000",
			"name": "宏伟",
			"y": "h"
		}, {
			"id": "211005",
			"pid": "211000",
			"name": "弓长岭",
			"y": "g"
		}, {
			"id": "211011",
			"pid": "211000",
			"name": "太子河",
			"y": "t"
		}, {
			"id": "211021",
			"pid": "211000",
			"name": "辽阳县",
			"y": "l"
		}, {
			"id": "211081",
			"pid": "211000",
			"name": "灯塔",
			"y": "d"
		}]
	}, {
		"id": "211100",
		"pid": "210000",
		"name": "盘锦",
		"y": "p",
		"child": [{
			"id": "211102",
			"pid": "211100",
			"name": "双台子",
			"y": "s"
		}, {
			"id": "211103",
			"pid": "211100",
			"name": "兴隆台",
			"y": "x"
		}, {
			"id": "211104",
			"pid": "211100",
			"name": "大洼",
			"y": "d"
		}, {
			"id": "211122",
			"pid": "211100",
			"name": "盘山",
			"y": "p"
		}]
	}, {
		"id": "211200",
		"pid": "210000",
		"name": "铁岭",
		"y": "t",
		"child": [{
			"id": "211202",
			"pid": "211200",
			"name": "银州",
			"y": "y"
		}, {
			"id": "211204",
			"pid": "211200",
			"name": "清河",
			"y": "q"
		}, {
			"id": "211221",
			"pid": "211200",
			"name": "铁岭县",
			"y": "t"
		}, {
			"id": "211223",
			"pid": "211200",
			"name": "西丰",
			"y": "x"
		}, {
			"id": "211224",
			"pid": "211200",
			"name": "昌图",
			"y": "c"
		}, {
			"id": "211281",
			"pid": "211200",
			"name": "调兵山",
			"y": "d"
		}, {
			"id": "211282",
			"pid": "211200",
			"name": "开原",
			"y": "k"
		}]
	}, {
		"id": "211300",
		"pid": "210000",
		"name": "朝阳",
		"y": "c",
		"child": [{
			"id": "211302",
			"pid": "211300",
			"name": "双塔",
			"y": "s"
		}, {
			"id": "211303",
			"pid": "211300",
			"name": "龙城",
			"y": "l"
		}, {
			"id": "211321",
			"pid": "211300",
			"name": "朝阳县",
			"y": "c"
		}, {
			"id": "211322",
			"pid": "211300",
			"name": "建平",
			"y": "j"
		}, {
			"id": "211324",
			"pid": "211300",
			"name": "喀喇沁左翼",
			"y": "k"
		}, {
			"id": "211381",
			"pid": "211300",
			"name": "北票",
			"y": "b"
		}, {
			"id": "211382",
			"pid": "211300",
			"name": "凌源",
			"y": "l"
		}]
	}, {
		"id": "211400",
		"pid": "210000",
		"name": "葫芦岛",
		"y": "h",
		"child": [{
			"id": "211402",
			"pid": "211400",
			"name": "连山",
			"y": "l"
		}, {
			"id": "211403",
			"pid": "211400",
			"name": "龙港",
			"y": "l"
		}, {
			"id": "211404",
			"pid": "211400",
			"name": "南票",
			"y": "n"
		}, {
			"id": "211421",
			"pid": "211400",
			"name": "绥中",
			"y": "s"
		}, {
			"id": "211422",
			"pid": "211400",
			"name": "建昌",
			"y": "j"
		}, {
			"id": "211481",
			"pid": "211400",
			"name": "兴城",
			"y": "x"
		}]
	}]
}, {
	"id": "220000",
	"pid": "0",
	"name": "吉林",
	"y": "j",
	"child": [{
		"id": "220100",
		"pid": "220000",
		"name": "长春",
		"y": "c",
		"child": [{
			"id": "220102",
			"pid": "220100",
			"name": "南关",
			"y": "n"
		}, {
			"id": "220103",
			"pid": "220100",
			"name": "宽城",
			"y": "k"
		}, {
			"id": "220104",
			"pid": "220100",
			"name": "朝阳",
			"y": "c"
		}, {
			"id": "220105",
			"pid": "220100",
			"name": "二道",
			"y": "e"
		}, {
			"id": "220106",
			"pid": "220100",
			"name": "绿园",
			"y": "l"
		}, {
			"id": "220112",
			"pid": "220100",
			"name": "双阳",
			"y": "s"
		}, {
			"id": "220113",
			"pid": "220100",
			"name": "九台",
			"y": "j"
		}, {
			"id": "220122",
			"pid": "220100",
			"name": "农安",
			"y": "n"
		}, {
			"id": "220182",
			"pid": "220100",
			"name": "榆树",
			"y": "y"
		}, {
			"id": "220183",
			"pid": "220100",
			"name": "德惠",
			"y": "d"
		}, {
			"id": "220184",
			"pid": "220100",
			"name": "公主岭",
			"y": "g"
		}]
	}, {
		"id": "220200",
		"pid": "220000",
		"name": "吉林市",
		"y": "j",
		"child": [{
			"id": "220202",
			"pid": "220200",
			"name": "昌邑",
			"y": "c"
		}, {
			"id": "220203",
			"pid": "220200",
			"name": "龙潭",
			"y": "l"
		}, {
			"id": "220204",
			"pid": "220200",
			"name": "船营",
			"y": "c"
		}, {
			"id": "220211",
			"pid": "220200",
			"name": "丰满",
			"y": "f"
		}, {
			"id": "220221",
			"pid": "220200",
			"name": "永吉",
			"y": "y"
		}, {
			"id": "220281",
			"pid": "220200",
			"name": "蛟河",
			"y": "j"
		}, {
			"id": "220282",
			"pid": "220200",
			"name": "桦甸",
			"y": "h"
		}, {
			"id": "220283",
			"pid": "220200",
			"name": "舒兰",
			"y": "s"
		}, {
			"id": "220284",
			"pid": "220200",
			"name": "磐石",
			"y": "p"
		}]
	}, {
		"id": "220300",
		"pid": "220000",
		"name": "四平",
		"y": "s",
		"child": [{
			"id": "220302",
			"pid": "220300",
			"name": "铁西",
			"y": "t"
		}, {
			"id": "220303",
			"pid": "220300",
			"name": "铁东",
			"y": "t"
		}, {
			"id": "220322",
			"pid": "220300",
			"name": "梨树",
			"y": "l"
		}, {
			"id": "220323",
			"pid": "220300",
			"name": "伊通",
			"y": "y"
		}, {
			"id": "220382",
			"pid": "220300",
			"name": "双辽",
			"y": "s"
		}]
	}, {
		"id": "220400",
		"pid": "220000",
		"name": "辽源",
		"y": "l",
		"child": [{
			"id": "220402",
			"pid": "220400",
			"name": "龙山",
			"y": "l"
		}, {
			"id": "220403",
			"pid": "220400",
			"name": "西安",
			"y": "x"
		}, {
			"id": "220421",
			"pid": "220400",
			"name": "东丰",
			"y": "d"
		}, {
			"id": "220422",
			"pid": "220400",
			"name": "东辽",
			"y": "d"
		}]
	}, {
		"id": "220500",
		"pid": "220000",
		"name": "通化",
		"y": "t",
		"child": [{
			"id": "220502",
			"pid": "220500",
			"name": "东昌",
			"y": "d"
		}, {
			"id": "220503",
			"pid": "220500",
			"name": "二道江",
			"y": "e"
		}, {
			"id": "220521",
			"pid": "220500",
			"name": "通化县",
			"y": "t"
		}, {
			"id": "220523",
			"pid": "220500",
			"name": "辉南",
			"y": "h"
		}, {
			"id": "220524",
			"pid": "220500",
			"name": "柳河",
			"y": "l"
		}, {
			"id": "220581",
			"pid": "220500",
			"name": "梅河口",
			"y": "m"
		}, {
			"id": "220582",
			"pid": "220500",
			"name": "集安",
			"y": "j"
		}]
	}, {
		"id": "220600",
		"pid": "220000",
		"name": "白山",
		"y": "b",
		"child": [{
			"id": "220602",
			"pid": "220600",
			"name": "浑江",
			"y": "h"
		}, {
			"id": "220605",
			"pid": "220600",
			"name": "江源",
			"y": "j"
		}, {
			"id": "220621",
			"pid": "220600",
			"name": "抚松",
			"y": "f"
		}, {
			"id": "220622",
			"pid": "220600",
			"name": "靖宇",
			"y": "j"
		}, {
			"id": "220623",
			"pid": "220600",
			"name": "长白",
			"y": "c"
		}, {
			"id": "220681",
			"pid": "220600",
			"name": "临江",
			"y": "l"
		}]
	}, {
		"id": "220700",
		"pid": "220000",
		"name": "松原",
		"y": "s",
		"child": [{
			"id": "220702",
			"pid": "220700",
			"name": "宁江",
			"y": "n"
		}, {
			"id": "220721",
			"pid": "220700",
			"name": "前郭尔罗斯",
			"y": "q"
		}, {
			"id": "220722",
			"pid": "220700",
			"name": "长岭",
			"y": "c"
		}, {
			"id": "220723",
			"pid": "220700",
			"name": "乾安",
			"y": "q"
		}, {
			"id": "220781",
			"pid": "220700",
			"name": "扶余",
			"y": "f"
		}]
	}, {
		"id": "220800",
		"pid": "220000",
		"name": "白城",
		"y": "b",
		"child": [{
			"id": "220802",
			"pid": "220800",
			"name": "洮北",
			"y": "t"
		}, {
			"id": "220821",
			"pid": "220800",
			"name": "镇赉",
			"y": "z"
		}, {
			"id": "220822",
			"pid": "220800",
			"name": "通榆",
			"y": "t"
		}, {
			"id": "220881",
			"pid": "220800",
			"name": "洮南",
			"y": "t"
		}, {
			"id": "220882",
			"pid": "220800",
			"name": "大安",
			"y": "d"
		}]
	}, {
		"id": "222400",
		"pid": "220000",
		"name": "延边",
		"y": "y",
		"child": [{
			"id": "222401",
			"pid": "222400",
			"name": "延吉",
			"y": "y"
		}, {
			"id": "222402",
			"pid": "222400",
			"name": "图们",
			"y": "t"
		}, {
			"id": "222403",
			"pid": "222400",
			"name": "敦化",
			"y": "d"
		}, {
			"id": "222404",
			"pid": "222400",
			"name": "珲春",
			"y": "h"
		}, {
			"id": "222405",
			"pid": "222400",
			"name": "龙井",
			"y": "l"
		}, {
			"id": "222406",
			"pid": "222400",
			"name": "和龙",
			"y": "h"
		}, {
			"id": "222424",
			"pid": "222400",
			"name": "汪清",
			"y": "w"
		}, {
			"id": "222426",
			"pid": "222400",
			"name": "安图",
			"y": "a"
		}]
	}]
}, {
	"id": "230000",
	"pid": "0",
	"name": "黑龙江",
	"y": "h",
	"child": [{
		"id": "230100",
		"pid": "230000",
		"name": "哈尔滨",
		"y": "h",
		"child": [{
			"id": "230102",
			"pid": "230100",
			"name": "道里",
			"y": "d"
		}, {
			"id": "230103",
			"pid": "230100",
			"name": "南岗",
			"y": "n"
		}, {
			"id": "230104",
			"pid": "230100",
			"name": "道外",
			"y": "d"
		}, {
			"id": "230108",
			"pid": "230100",
			"name": "平房",
			"y": "p"
		}, {
			"id": "230109",
			"pid": "230100",
			"name": "松北",
			"y": "s"
		}, {
			"id": "230110",
			"pid": "230100",
			"name": "香坊",
			"y": "x"
		}, {
			"id": "230111",
			"pid": "230100",
			"name": "呼兰",
			"y": "h"
		}, {
			"id": "230112",
			"pid": "230100",
			"name": "阿城",
			"y": "a"
		}, {
			"id": "230113",
			"pid": "230100",
			"name": "双城",
			"y": "s"
		}, {
			"id": "230123",
			"pid": "230100",
			"name": "依兰",
			"y": "y"
		}, {
			"id": "230124",
			"pid": "230100",
			"name": "方正",
			"y": "f"
		}, {
			"id": "230125",
			"pid": "230100",
			"name": "宾县",
			"y": "b"
		}, {
			"id": "230126",
			"pid": "230100",
			"name": "巴彦",
			"y": "b"
		}, {
			"id": "230127",
			"pid": "230100",
			"name": "木兰",
			"y": "m"
		}, {
			"id": "230128",
			"pid": "230100",
			"name": "通河",
			"y": "t"
		}, {
			"id": "230129",
			"pid": "230100",
			"name": "延寿",
			"y": "y"
		}, {
			"id": "230183",
			"pid": "230100",
			"name": "尚志",
			"y": "s"
		}, {
			"id": "230184",
			"pid": "230100",
			"name": "五常",
			"y": "w"
		}]
	}, {
		"id": "230200",
		"pid": "230000",
		"name": "齐齐哈尔",
		"y": "q",
		"child": [{
			"id": "230202",
			"pid": "230200",
			"name": "龙沙",
			"y": "l"
		}, {
			"id": "230203",
			"pid": "230200",
			"name": "建华",
			"y": "j"
		}, {
			"id": "230204",
			"pid": "230200",
			"name": "铁锋",
			"y": "t"
		}, {
			"id": "230205",
			"pid": "230200",
			"name": "昂昂溪",
			"y": "a"
		}, {
			"id": "230206",
			"pid": "230200",
			"name": "富拉尔基区",
			"y": "f"
		}, {
			"id": "230207",
			"pid": "230200",
			"name": "碾子山",
			"y": "n"
		}, {
			"id": "230208",
			"pid": "230200",
			"name": "梅里斯达斡尔族区",
			"y": "m"
		}, {
			"id": "230221",
			"pid": "230200",
			"name": "龙江",
			"y": "l"
		}, {
			"id": "230223",
			"pid": "230200",
			"name": "依安",
			"y": "y"
		}, {
			"id": "230224",
			"pid": "230200",
			"name": "泰来",
			"y": "t"
		}, {
			"id": "230225",
			"pid": "230200",
			"name": "甘南",
			"y": "g"
		}, {
			"id": "230227",
			"pid": "230200",
			"name": "富裕",
			"y": "f"
		}, {
			"id": "230229",
			"pid": "230200",
			"name": "克山",
			"y": "k"
		}, {
			"id": "230230",
			"pid": "230200",
			"name": "克东",
			"y": "k"
		}, {
			"id": "230231",
			"pid": "230200",
			"name": "拜泉",
			"y": "b"
		}, {
			"id": "230281",
			"pid": "230200",
			"name": "讷河",
			"y": "n"
		}]
	}, {
		"id": "230300",
		"pid": "230000",
		"name": "鸡西",
		"y": "j",
		"child": [{
			"id": "230302",
			"pid": "230300",
			"name": "鸡冠",
			"y": "j"
		}, {
			"id": "230303",
			"pid": "230300",
			"name": "恒山",
			"y": "h"
		}, {
			"id": "230304",
			"pid": "230300",
			"name": "滴道",
			"y": "d"
		}, {
			"id": "230305",
			"pid": "230300",
			"name": "梨树",
			"y": "l"
		}, {
			"id": "230306",
			"pid": "230300",
			"name": "城子河",
			"y": "c"
		}, {
			"id": "230307",
			"pid": "230300",
			"name": "麻山",
			"y": "m"
		}, {
			"id": "230321",
			"pid": "230300",
			"name": "鸡东",
			"y": "j"
		}, {
			"id": "230381",
			"pid": "230300",
			"name": "虎林",
			"y": "h"
		}, {
			"id": "230382",
			"pid": "230300",
			"name": "密山",
			"y": "m"
		}]
	}, {
		"id": "230400",
		"pid": "230000",
		"name": "鹤岗",
		"y": "h",
		"child": [{
			"id": "230402",
			"pid": "230400",
			"name": "向阳",
			"y": "x"
		}, {
			"id": "230403",
			"pid": "230400",
			"name": "工农",
			"y": "g"
		}, {
			"id": "230404",
			"pid": "230400",
			"name": "南山",
			"y": "n"
		}, {
			"id": "230405",
			"pid": "230400",
			"name": "兴安",
			"y": "x"
		}, {
			"id": "230406",
			"pid": "230400",
			"name": "东山",
			"y": "d"
		}, {
			"id": "230407",
			"pid": "230400",
			"name": "兴山",
			"y": "x"
		}, {
			"id": "230421",
			"pid": "230400",
			"name": "萝北",
			"y": "l"
		}, {
			"id": "230422",
			"pid": "230400",
			"name": "绥滨",
			"y": "s"
		}]
	}, {
		"id": "230500",
		"pid": "230000",
		"name": "双鸭山",
		"y": "s",
		"child": [{
			"id": "230502",
			"pid": "230500",
			"name": "尖山",
			"y": "j"
		}, {
			"id": "230503",
			"pid": "230500",
			"name": "岭东",
			"y": "l"
		}, {
			"id": "230505",
			"pid": "230500",
			"name": "四方台",
			"y": "s"
		}, {
			"id": "230506",
			"pid": "230500",
			"name": "宝山",
			"y": "b"
		}, {
			"id": "230521",
			"pid": "230500",
			"name": "集贤",
			"y": "j"
		}, {
			"id": "230522",
			"pid": "230500",
			"name": "友谊",
			"y": "y"
		}, {
			"id": "230523",
			"pid": "230500",
			"name": "宝清",
			"y": "b"
		}, {
			"id": "230524",
			"pid": "230500",
			"name": "饶河",
			"y": "r"
		}]
	}, {
		"id": "230600",
		"pid": "230000",
		"name": "大庆",
		"y": "d",
		"child": [{
			"id": "230602",
			"pid": "230600",
			"name": "萨尔图",
			"y": "s"
		}, {
			"id": "230603",
			"pid": "230600",
			"name": "龙凤",
			"y": "l"
		}, {
			"id": "230604",
			"pid": "230600",
			"name": "让胡路",
			"y": "r"
		}, {
			"id": "230605",
			"pid": "230600",
			"name": "红岗",
			"y": "h"
		}, {
			"id": "230606",
			"pid": "230600",
			"name": "大同",
			"y": "d"
		}, {
			"id": "230621",
			"pid": "230600",
			"name": "肇州",
			"y": "z"
		}, {
			"id": "230622",
			"pid": "230600",
			"name": "肇源",
			"y": "z"
		}, {
			"id": "230623",
			"pid": "230600",
			"name": "林甸",
			"y": "l"
		}, {
			"id": "230624",
			"pid": "230600",
			"name": "杜尔伯特",
			"y": "d"
		}]
	}, {
		"id": "230700",
		"pid": "230000",
		"name": "伊春",
		"y": "y",
		"child": [{
			"id": "230717",
			"pid": "230700",
			"name": "伊美",
			"y": "y"
		}, {
			"id": "230718",
			"pid": "230700",
			"name": "乌翠",
			"y": "w"
		}, {
			"id": "230719",
			"pid": "230700",
			"name": "友好",
			"y": "y"
		}, {
			"id": "230722",
			"pid": "230700",
			"name": "嘉荫",
			"y": "j"
		}, {
			"id": "230723",
			"pid": "230700",
			"name": "汤旺",
			"y": "t"
		}, {
			"id": "230724",
			"pid": "230700",
			"name": "丰林",
			"y": "f"
		}, {
			"id": "230725",
			"pid": "230700",
			"name": "大箐山",
			"y": "d"
		}, {
			"id": "230726",
			"pid": "230700",
			"name": "南岔",
			"y": "n"
		}, {
			"id": "230751",
			"pid": "230700",
			"name": "金林",
			"y": "j"
		}, {
			"id": "230781",
			"pid": "230700",
			"name": "铁力",
			"y": "t"
		}]
	}, {
		"id": "230800",
		"pid": "230000",
		"name": "佳木斯",
		"y": "j",
		"child": [{
			"id": "230803",
			"pid": "230800",
			"name": "向阳",
			"y": "x"
		}, {
			"id": "230804",
			"pid": "230800",
			"name": "前进",
			"y": "q"
		}, {
			"id": "230805",
			"pid": "230800",
			"name": "东风",
			"y": "d"
		}, {
			"id": "230811",
			"pid": "230800",
			"name": "郊区",
			"y": "j"
		}, {
			"id": "230822",
			"pid": "230800",
			"name": "桦南",
			"y": "h"
		}, {
			"id": "230826",
			"pid": "230800",
			"name": "桦川",
			"y": "h"
		}, {
			"id": "230828",
			"pid": "230800",
			"name": "汤原",
			"y": "t"
		}, {
			"id": "230881",
			"pid": "230800",
			"name": "同江",
			"y": "t"
		}, {
			"id": "230882",
			"pid": "230800",
			"name": "富锦",
			"y": "f"
		}, {
			"id": "230883",
			"pid": "230800",
			"name": "抚远",
			"y": "f"
		}]
	}, {
		"id": "230900",
		"pid": "230000",
		"name": "七台河",
		"y": "q",
		"child": [{
			"id": "230902",
			"pid": "230900",
			"name": "新兴",
			"y": "x"
		}, {
			"id": "230903",
			"pid": "230900",
			"name": "桃山",
			"y": "t"
		}, {
			"id": "230904",
			"pid": "230900",
			"name": "茄子河",
			"y": "q"
		}, {
			"id": "230921",
			"pid": "230900",
			"name": "勃利",
			"y": "b"
		}]
	}, {
		"id": "231000",
		"pid": "230000",
		"name": "牡丹江",
		"y": "m",
		"child": [{
			"id": "231002",
			"pid": "231000",
			"name": "东安",
			"y": "d"
		}, {
			"id": "231003",
			"pid": "231000",
			"name": "阳明",
			"y": "y"
		}, {
			"id": "231004",
			"pid": "231000",
			"name": "爱民",
			"y": "a"
		}, {
			"id": "231005",
			"pid": "231000",
			"name": "西安",
			"y": "x"
		}, {
			"id": "231025",
			"pid": "231000",
			"name": "林口",
			"y": "l"
		}, {
			"id": "231081",
			"pid": "231000",
			"name": "绥芬河",
			"y": "s"
		}, {
			"id": "231083",
			"pid": "231000",
			"name": "海林",
			"y": "h"
		}, {
			"id": "231084",
			"pid": "231000",
			"name": "宁安",
			"y": "n"
		}, {
			"id": "231085",
			"pid": "231000",
			"name": "穆棱",
			"y": "m"
		}, {
			"id": "231086",
			"pid": "231000",
			"name": "东宁",
			"y": "d"
		}]
	}, {
		"id": "231100",
		"pid": "230000",
		"name": "黑河",
		"y": "h",
		"child": [{
			"id": "231102",
			"pid": "231100",
			"name": "爱辉",
			"y": "a"
		}, {
			"id": "231123",
			"pid": "231100",
			"name": "逊克",
			"y": "x"
		}, {
			"id": "231124",
			"pid": "231100",
			"name": "孙吴",
			"y": "s"
		}, {
			"id": "231181",
			"pid": "231100",
			"name": "北安",
			"y": "b"
		}, {
			"id": "231182",
			"pid": "231100",
			"name": "五大连池",
			"y": "w"
		}, {
			"id": "231183",
			"pid": "231100",
			"name": "嫩江",
			"y": "n"
		}]
	}, {
		"id": "231200",
		"pid": "230000",
		"name": "绥化",
		"y": "s",
		"child": [{
			"id": "231202",
			"pid": "231200",
			"name": "北林",
			"y": "b"
		}, {
			"id": "231221",
			"pid": "231200",
			"name": "望奎",
			"y": "w"
		}, {
			"id": "231222",
			"pid": "231200",
			"name": "兰西",
			"y": "l"
		}, {
			"id": "231223",
			"pid": "231200",
			"name": "青冈",
			"y": "q"
		}, {
			"id": "231224",
			"pid": "231200",
			"name": "庆安",
			"y": "q"
		}, {
			"id": "231225",
			"pid": "231200",
			"name": "明水",
			"y": "m"
		}, {
			"id": "231226",
			"pid": "231200",
			"name": "绥棱",
			"y": "s"
		}, {
			"id": "231281",
			"pid": "231200",
			"name": "安达",
			"y": "a"
		}, {
			"id": "231282",
			"pid": "231200",
			"name": "肇东",
			"y": "z"
		}, {
			"id": "231283",
			"pid": "231200",
			"name": "海伦",
			"y": "h"
		}]
	}, {
		"id": "232700",
		"pid": "230000",
		"name": "大兴安岭",
		"y": "d",
		"child": [{
			"id": "232701",
			"pid": "232700",
			"name": "漠河",
			"y": "m"
		}, {
			"id": "232721",
			"pid": "232700",
			"name": "呼玛",
			"y": "h"
		}, {
			"id": "232722",
			"pid": "232700",
			"name": "塔河",
			"y": "t"
		}, {
			"id": "232761",
			"pid": "232700",
			"name": "加格达奇区",
			"y": "j"
		}]
	}]
}, {
	"id": "310000",
	"pid": "0",
	"name": "上海",
	"y": "s",
	"child": [{
		"id": "310100",
		"pid": "310000",
		"name": "上海",
		"y": "s",
		"child": [{
			"id": "310101",
			"pid": "310100",
			"name": "黄浦",
			"y": "h"
		}, {
			"id": "310104",
			"pid": "310100",
			"name": "徐汇",
			"y": "x"
		}, {
			"id": "310105",
			"pid": "310100",
			"name": "长宁",
			"y": "c"
		}, {
			"id": "310106",
			"pid": "310100",
			"name": "静安",
			"y": "j"
		}, {
			"id": "310107",
			"pid": "310100",
			"name": "普陀",
			"y": "p"
		}, {
			"id": "310109",
			"pid": "310100",
			"name": "虹口",
			"y": "h"
		}, {
			"id": "310110",
			"pid": "310100",
			"name": "杨浦",
			"y": "y"
		}, {
			"id": "310112",
			"pid": "310100",
			"name": "闵行",
			"y": "m"
		}, {
			"id": "310113",
			"pid": "310100",
			"name": "宝山",
			"y": "b"
		}, {
			"id": "310114",
			"pid": "310100",
			"name": "嘉定",
			"y": "j"
		}, {
			"id": "310115",
			"pid": "310100",
			"name": "浦东新区",
			"y": "p"
		}, {
			"id": "310116",
			"pid": "310100",
			"name": "金山",
			"y": "j"
		}, {
			"id": "310117",
			"pid": "310100",
			"name": "松江",
			"y": "s"
		}, {
			"id": "310118",
			"pid": "310100",
			"name": "青浦",
			"y": "q"
		}, {
			"id": "310120",
			"pid": "310100",
			"name": "奉贤",
			"y": "f"
		}, {
			"id": "310151",
			"pid": "310100",
			"name": "崇明",
			"y": "c"
		}]
	}]
}, {
	"id": "320000",
	"pid": "0",
	"name": "江苏",
	"y": "j",
	"child": [{
		"id": "320100",
		"pid": "320000",
		"name": "南京",
		"y": "n",
		"child": [{
			"id": "320102",
			"pid": "320100",
			"name": "玄武",
			"y": "x"
		}, {
			"id": "320104",
			"pid": "320100",
			"name": "秦淮",
			"y": "q"
		}, {
			"id": "320105",
			"pid": "320100",
			"name": "建邺",
			"y": "j"
		}, {
			"id": "320106",
			"pid": "320100",
			"name": "鼓楼",
			"y": "g"
		}, {
			"id": "320111",
			"pid": "320100",
			"name": "浦口",
			"y": "p"
		}, {
			"id": "320113",
			"pid": "320100",
			"name": "栖霞",
			"y": "q"
		}, {
			"id": "320114",
			"pid": "320100",
			"name": "雨花台",
			"y": "y"
		}, {
			"id": "320115",
			"pid": "320100",
			"name": "江宁",
			"y": "j"
		}, {
			"id": "320116",
			"pid": "320100",
			"name": "六合",
			"y": "l"
		}, {
			"id": "320117",
			"pid": "320100",
			"name": "溧水",
			"y": "l"
		}, {
			"id": "320118",
			"pid": "320100",
			"name": "高淳",
			"y": "g"
		}]
	}, {
		"id": "320200",
		"pid": "320000",
		"name": "无锡",
		"y": "w",
		"child": [{
			"id": "320205",
			"pid": "320200",
			"name": "锡山",
			"y": "x"
		}, {
			"id": "320206",
			"pid": "320200",
			"name": "惠山",
			"y": "h"
		}, {
			"id": "320211",
			"pid": "320200",
			"name": "滨湖",
			"y": "b"
		}, {
			"id": "320213",
			"pid": "320200",
			"name": "梁溪",
			"y": "l"
		}, {
			"id": "320214",
			"pid": "320200",
			"name": "新吴",
			"y": "x"
		}, {
			"id": "320281",
			"pid": "320200",
			"name": "江阴",
			"y": "j"
		}, {
			"id": "320282",
			"pid": "320200",
			"name": "宜兴",
			"y": "y"
		}]
	}, {
		"id": "320300",
		"pid": "320000",
		"name": "徐州",
		"y": "x",
		"child": [{
			"id": "320302",
			"pid": "320300",
			"name": "鼓楼",
			"y": "g"
		}, {
			"id": "320303",
			"pid": "320300",
			"name": "云龙",
			"y": "y"
		}, {
			"id": "320305",
			"pid": "320300",
			"name": "贾汪",
			"y": "j"
		}, {
			"id": "320311",
			"pid": "320300",
			"name": "泉山",
			"y": "q"
		}, {
			"id": "320312",
			"pid": "320300",
			"name": "铜山",
			"y": "t"
		}, {
			"id": "320321",
			"pid": "320300",
			"name": "丰县",
			"y": "f"
		}, {
			"id": "320322",
			"pid": "320300",
			"name": "沛县",
			"y": "p"
		}, {
			"id": "320324",
			"pid": "320300",
			"name": "睢宁",
			"y": "s"
		}, {
			"id": "320381",
			"pid": "320300",
			"name": "新沂",
			"y": "x"
		}, {
			"id": "320382",
			"pid": "320300",
			"name": "邳州",
			"y": "p"
		}]
	}, {
		"id": "320400",
		"pid": "320000",
		"name": "常州",
		"y": "c",
		"child": [{
			"id": "320402",
			"pid": "320400",
			"name": "天宁",
			"y": "t"
		}, {
			"id": "320404",
			"pid": "320400",
			"name": "钟楼",
			"y": "z"
		}, {
			"id": "320411",
			"pid": "320400",
			"name": "新北",
			"y": "x"
		}, {
			"id": "320412",
			"pid": "320400",
			"name": "武进",
			"y": "w"
		}, {
			"id": "320413",
			"pid": "320400",
			"name": "金坛",
			"y": "j"
		}, {
			"id": "320481",
			"pid": "320400",
			"name": "溧阳",
			"y": "l"
		}]
	}, {
		"id": "320500",
		"pid": "320000",
		"name": "苏州",
		"y": "s",
		"child": [{
			"id": "320505",
			"pid": "320500",
			"name": "虎丘",
			"y": "h"
		}, {
			"id": "320506",
			"pid": "320500",
			"name": "吴中",
			"y": "w"
		}, {
			"id": "320507",
			"pid": "320500",
			"name": "相城",
			"y": "x"
		}, {
			"id": "320508",
			"pid": "320500",
			"name": "姑苏",
			"y": "g"
		}, {
			"id": "320509",
			"pid": "320500",
			"name": "吴江",
			"y": "w"
		}, {
			"id": "320581",
			"pid": "320500",
			"name": "常熟",
			"y": "c"
		}, {
			"id": "320582",
			"pid": "320500",
			"name": "张家港",
			"y": "z"
		}, {
			"id": "320583",
			"pid": "320500",
			"name": "昆山",
			"y": "k"
		}, {
			"id": "320585",
			"pid": "320500",
			"name": "太仓",
			"y": "t"
		}]
	}, {
		"id": "320600",
		"pid": "320000",
		"name": "南通",
		"y": "n",
		"child": [{
			"id": "320612",
			"pid": "320600",
			"name": "通州",
			"y": "t"
		}, {
			"id": "320613",
			"pid": "320600",
			"name": "崇川",
			"y": "c"
		}, {
			"id": "320614",
			"pid": "320600",
			"name": "海门",
			"y": "h"
		}, {
			"id": "320623",
			"pid": "320600",
			"name": "如东",
			"y": "r"
		}, {
			"id": "320681",
			"pid": "320600",
			"name": "启东",
			"y": "q"
		}, {
			"id": "320682",
			"pid": "320600",
			"name": "如皋",
			"y": "r"
		}, {
			"id": "320685",
			"pid": "320600",
			"name": "海安",
			"y": "h"
		}]
	}, {
		"id": "320700",
		"pid": "320000",
		"name": "连云港",
		"y": "l",
		"child": [{
			"id": "320703",
			"pid": "320700",
			"name": "连云",
			"y": "l"
		}, {
			"id": "320706",
			"pid": "320700",
			"name": "海州",
			"y": "h"
		}, {
			"id": "320707",
			"pid": "320700",
			"name": "赣榆",
			"y": "g"
		}, {
			"id": "320722",
			"pid": "320700",
			"name": "东海",
			"y": "d"
		}, {
			"id": "320723",
			"pid": "320700",
			"name": "灌云",
			"y": "g"
		}, {
			"id": "320724",
			"pid": "320700",
			"name": "灌南",
			"y": "g"
		}]
	}, {
		"id": "320800",
		"pid": "320000",
		"name": "淮安",
		"y": "h",
		"child": [{
			"id": "320803",
			"pid": "320800",
			"name": "淮安区",
			"y": "h"
		}, {
			"id": "320804",
			"pid": "320800",
			"name": "淮阴",
			"y": "h"
		}, {
			"id": "320812",
			"pid": "320800",
			"name": "清江浦",
			"y": "q"
		}, {
			"id": "320813",
			"pid": "320800",
			"name": "洪泽",
			"y": "h"
		}, {
			"id": "320826",
			"pid": "320800",
			"name": "涟水",
			"y": "l"
		}, {
			"id": "320830",
			"pid": "320800",
			"name": "盱眙",
			"y": "x"
		}, {
			"id": "320831",
			"pid": "320800",
			"name": "金湖",
			"y": "j"
		}]
	}, {
		"id": "320900",
		"pid": "320000",
		"name": "盐城",
		"y": "y",
		"child": [{
			"id": "320902",
			"pid": "320900",
			"name": "亭湖",
			"y": "t"
		}, {
			"id": "320903",
			"pid": "320900",
			"name": "盐都",
			"y": "y"
		}, {
			"id": "320904",
			"pid": "320900",
			"name": "大丰",
			"y": "d"
		}, {
			"id": "320921",
			"pid": "320900",
			"name": "响水",
			"y": "x"
		}, {
			"id": "320922",
			"pid": "320900",
			"name": "滨海",
			"y": "b"
		}, {
			"id": "320923",
			"pid": "320900",
			"name": "阜宁",
			"y": "f"
		}, {
			"id": "320924",
			"pid": "320900",
			"name": "射阳",
			"y": "s"
		}, {
			"id": "320925",
			"pid": "320900",
			"name": "建湖",
			"y": "j"
		}, {
			"id": "320981",
			"pid": "320900",
			"name": "东台",
			"y": "d"
		}]
	}, {
		"id": "321000",
		"pid": "320000",
		"name": "扬州",
		"y": "y",
		"child": [{
			"id": "321002",
			"pid": "321000",
			"name": "广陵",
			"y": "g"
		}, {
			"id": "321003",
			"pid": "321000",
			"name": "邗江",
			"y": "h"
		}, {
			"id": "321012",
			"pid": "321000",
			"name": "江都",
			"y": "j"
		}, {
			"id": "321023",
			"pid": "321000",
			"name": "宝应",
			"y": "b"
		}, {
			"id": "321081",
			"pid": "321000",
			"name": "仪征",
			"y": "y"
		}, {
			"id": "321084",
			"pid": "321000",
			"name": "高邮",
			"y": "g"
		}]
	}, {
		"id": "321100",
		"pid": "320000",
		"name": "镇江",
		"y": "z",
		"child": [{
			"id": "321102",
			"pid": "321100",
			"name": "京口",
			"y": "j"
		}, {
			"id": "321111",
			"pid": "321100",
			"name": "润州",
			"y": "r"
		}, {
			"id": "321112",
			"pid": "321100",
			"name": "丹徒",
			"y": "d"
		}, {
			"id": "321181",
			"pid": "321100",
			"name": "丹阳",
			"y": "d"
		}, {
			"id": "321182",
			"pid": "321100",
			"name": "扬中",
			"y": "y"
		}, {
			"id": "321183",
			"pid": "321100",
			"name": "句容",
			"y": "j"
		}]
	}, {
		"id": "321200",
		"pid": "320000",
		"name": "泰州",
		"y": "t",
		"child": [{
			"id": "321202",
			"pid": "321200",
			"name": "海陵",
			"y": "h"
		}, {
			"id": "321203",
			"pid": "321200",
			"name": "高港",
			"y": "g"
		}, {
			"id": "321204",
			"pid": "321200",
			"name": "姜堰",
			"y": "j"
		}, {
			"id": "321281",
			"pid": "321200",
			"name": "兴化",
			"y": "x"
		}, {
			"id": "321282",
			"pid": "321200",
			"name": "靖江",
			"y": "j"
		}, {
			"id": "321283",
			"pid": "321200",
			"name": "泰兴",
			"y": "t"
		}]
	}, {
		"id": "321300",
		"pid": "320000",
		"name": "宿迁",
		"y": "s",
		"child": [{
			"id": "321302",
			"pid": "321300",
			"name": "宿城",
			"y": "s"
		}, {
			"id": "321311",
			"pid": "321300",
			"name": "宿豫",
			"y": "s"
		}, {
			"id": "321322",
			"pid": "321300",
			"name": "沭阳",
			"y": "s"
		}, {
			"id": "321323",
			"pid": "321300",
			"name": "泗阳",
			"y": "s"
		}, {
			"id": "321324",
			"pid": "321300",
			"name": "泗洪",
			"y": "s"
		}]
	}]
}, {
	"id": "330000",
	"pid": "0",
	"name": "浙江",
	"y": "z",
	"child": [{
		"id": "330100",
		"pid": "330000",
		"name": "杭州",
		"y": "h",
		"child": [{
			"id": "330102",
			"pid": "330100",
			"name": "上城",
			"y": "s"
		}, {
			"id": "330105",
			"pid": "330100",
			"name": "拱墅",
			"y": "g"
		}, {
			"id": "330106",
			"pid": "330100",
			"name": "西湖",
			"y": "x"
		}, {
			"id": "330108",
			"pid": "330100",
			"name": "滨江",
			"y": "b"
		}, {
			"id": "330109",
			"pid": "330100",
			"name": "萧山",
			"y": "x"
		}, {
			"id": "330110",
			"pid": "330100",
			"name": "余杭",
			"y": "y"
		}, {
			"id": "330111",
			"pid": "330100",
			"name": "富阳",
			"y": "f"
		}, {
			"id": "330112",
			"pid": "330100",
			"name": "临安",
			"y": "l"
		}, {
			"id": "330113",
			"pid": "330100",
			"name": "钱塘",
			"y": "q"
		}, {
			"id": "330114",
			"pid": "330100",
			"name": "临平",
			"y": "l"
		}, {
			"id": "330122",
			"pid": "330100",
			"name": "桐庐",
			"y": "t"
		}, {
			"id": "330127",
			"pid": "330100",
			"name": "淳安",
			"y": "c"
		}, {
			"id": "330182",
			"pid": "330100",
			"name": "建德",
			"y": "j"
		}]
	}, {
		"id": "330200",
		"pid": "330000",
		"name": "宁波",
		"y": "n",
		"child": [{
			"id": "330203",
			"pid": "330200",
			"name": "海曙",
			"y": "h"
		}, {
			"id": "330205",
			"pid": "330200",
			"name": "江北",
			"y": "j"
		}, {
			"id": "330206",
			"pid": "330200",
			"name": "北仑",
			"y": "b"
		}, {
			"id": "330211",
			"pid": "330200",
			"name": "镇海",
			"y": "z"
		}, {
			"id": "330212",
			"pid": "330200",
			"name": "鄞州",
			"y": "y"
		}, {
			"id": "330213",
			"pid": "330200",
			"name": "奉化",
			"y": "f"
		}, {
			"id": "330225",
			"pid": "330200",
			"name": "象山",
			"y": "x"
		}, {
			"id": "330226",
			"pid": "330200",
			"name": "宁海",
			"y": "n"
		}, {
			"id": "330281",
			"pid": "330200",
			"name": "余姚",
			"y": "y"
		}, {
			"id": "330282",
			"pid": "330200",
			"name": "慈溪",
			"y": "c"
		}]
	}, {
		"id": "330300",
		"pid": "330000",
		"name": "温州",
		"y": "w",
		"child": [{
			"id": "330302",
			"pid": "330300",
			"name": "鹿城",
			"y": "l"
		}, {
			"id": "330303",
			"pid": "330300",
			"name": "龙湾",
			"y": "l"
		}, {
			"id": "330304",
			"pid": "330300",
			"name": "瓯海",
			"y": "o"
		}, {
			"id": "330305",
			"pid": "330300",
			"name": "洞头",
			"y": "d"
		}, {
			"id": "330324",
			"pid": "330300",
			"name": "永嘉",
			"y": "y"
		}, {
			"id": "330326",
			"pid": "330300",
			"name": "平阳",
			"y": "p"
		}, {
			"id": "330327",
			"pid": "330300",
			"name": "苍南",
			"y": "c"
		}, {
			"id": "330328",
			"pid": "330300",
			"name": "文成",
			"y": "w"
		}, {
			"id": "330329",
			"pid": "330300",
			"name": "泰顺",
			"y": "t"
		}, {
			"id": "330381",
			"pid": "330300",
			"name": "瑞安",
			"y": "r"
		}, {
			"id": "330382",
			"pid": "330300",
			"name": "乐清",
			"y": "y"
		}, {
			"id": "330383",
			"pid": "330300",
			"name": "龙港",
			"y": "l"
		}]
	}, {
		"id": "330400",
		"pid": "330000",
		"name": "嘉兴",
		"y": "j",
		"child": [{
			"id": "330402",
			"pid": "330400",
			"name": "南湖",
			"y": "n"
		}, {
			"id": "330411",
			"pid": "330400",
			"name": "秀洲",
			"y": "x"
		}, {
			"id": "330421",
			"pid": "330400",
			"name": "嘉善",
			"y": "j"
		}, {
			"id": "330424",
			"pid": "330400",
			"name": "海盐",
			"y": "h"
		}, {
			"id": "330481",
			"pid": "330400",
			"name": "海宁",
			"y": "h"
		}, {
			"id": "330482",
			"pid": "330400",
			"name": "平湖",
			"y": "p"
		}, {
			"id": "330483",
			"pid": "330400",
			"name": "桐乡",
			"y": "t"
		}]
	}, {
		"id": "330500",
		"pid": "330000",
		"name": "湖州",
		"y": "h",
		"child": [{
			"id": "330502",
			"pid": "330500",
			"name": "吴兴",
			"y": "w"
		}, {
			"id": "330503",
			"pid": "330500",
			"name": "南浔",
			"y": "n"
		}, {
			"id": "330521",
			"pid": "330500",
			"name": "德清",
			"y": "d"
		}, {
			"id": "330522",
			"pid": "330500",
			"name": "长兴",
			"y": "c"
		}, {
			"id": "330523",
			"pid": "330500",
			"name": "安吉",
			"y": "a"
		}]
	}, {
		"id": "330600",
		"pid": "330000",
		"name": "绍兴",
		"y": "s",
		"child": [{
			"id": "330602",
			"pid": "330600",
			"name": "越城",
			"y": "y"
		}, {
			"id": "330603",
			"pid": "330600",
			"name": "柯桥",
			"y": "k"
		}, {
			"id": "330604",
			"pid": "330600",
			"name": "上虞",
			"y": "s"
		}, {
			"id": "330624",
			"pid": "330600",
			"name": "新昌",
			"y": "x"
		}, {
			"id": "330681",
			"pid": "330600",
			"name": "诸暨",
			"y": "z"
		}, {
			"id": "330683",
			"pid": "330600",
			"name": "嵊州",
			"y": "s"
		}]
	}, {
		"id": "330700",
		"pid": "330000",
		"name": "金华",
		"y": "j",
		"child": [{
			"id": "330702",
			"pid": "330700",
			"name": "婺城",
			"y": "w"
		}, {
			"id": "330703",
			"pid": "330700",
			"name": "金东",
			"y": "j"
		}, {
			"id": "330723",
			"pid": "330700",
			"name": "武义",
			"y": "w"
		}, {
			"id": "330726",
			"pid": "330700",
			"name": "浦江",
			"y": "p"
		}, {
			"id": "330727",
			"pid": "330700",
			"name": "磐安",
			"y": "p"
		}, {
			"id": "330781",
			"pid": "330700",
			"name": "兰溪",
			"y": "l"
		}, {
			"id": "330782",
			"pid": "330700",
			"name": "义乌",
			"y": "y"
		}, {
			"id": "330783",
			"pid": "330700",
			"name": "东阳",
			"y": "d"
		}, {
			"id": "330784",
			"pid": "330700",
			"name": "永康",
			"y": "y"
		}]
	}, {
		"id": "330800",
		"pid": "330000",
		"name": "衢州",
		"y": "q",
		"child": [{
			"id": "330802",
			"pid": "330800",
			"name": "柯城",
			"y": "k"
		}, {
			"id": "330803",
			"pid": "330800",
			"name": "衢江",
			"y": "q"
		}, {
			"id": "330822",
			"pid": "330800",
			"name": "常山",
			"y": "c"
		}, {
			"id": "330824",
			"pid": "330800",
			"name": "开化",
			"y": "k"
		}, {
			"id": "330825",
			"pid": "330800",
			"name": "龙游",
			"y": "l"
		}, {
			"id": "330881",
			"pid": "330800",
			"name": "江山",
			"y": "j"
		}]
	}, {
		"id": "330900",
		"pid": "330000",
		"name": "舟山",
		"y": "z",
		"child": [{
			"id": "330902",
			"pid": "330900",
			"name": "定海",
			"y": "d"
		}, {
			"id": "330903",
			"pid": "330900",
			"name": "普陀",
			"y": "p"
		}, {
			"id": "330921",
			"pid": "330900",
			"name": "岱山",
			"y": "d"
		}, {
			"id": "330922",
			"pid": "330900",
			"name": "嵊泗",
			"y": "s"
		}]
	}, {
		"id": "331000",
		"pid": "330000",
		"name": "台州",
		"y": "t",
		"child": [{
			"id": "331002",
			"pid": "331000",
			"name": "椒江",
			"y": "j"
		}, {
			"id": "331003",
			"pid": "331000",
			"name": "黄岩",
			"y": "h"
		}, {
			"id": "331004",
			"pid": "331000",
			"name": "路桥",
			"y": "l"
		}, {
			"id": "331022",
			"pid": "331000",
			"name": "三门",
			"y": "s"
		}, {
			"id": "331023",
			"pid": "331000",
			"name": "天台",
			"y": "t"
		}, {
			"id": "331024",
			"pid": "331000",
			"name": "仙居",
			"y": "x"
		}, {
			"id": "331081",
			"pid": "331000",
			"name": "温岭",
			"y": "w"
		}, {
			"id": "331082",
			"pid": "331000",
			"name": "临海",
			"y": "l"
		}, {
			"id": "331083",
			"pid": "331000",
			"name": "玉环",
			"y": "y"
		}]
	}, {
		"id": "331100",
		"pid": "330000",
		"name": "丽水",
		"y": "l",
		"child": [{
			"id": "331102",
			"pid": "331100",
			"name": "莲都",
			"y": "l"
		}, {
			"id": "331121",
			"pid": "331100",
			"name": "青田",
			"y": "q"
		}, {
			"id": "331122",
			"pid": "331100",
			"name": "缙云",
			"y": "j"
		}, {
			"id": "331123",
			"pid": "331100",
			"name": "遂昌",
			"y": "s"
		}, {
			"id": "331124",
			"pid": "331100",
			"name": "松阳",
			"y": "s"
		}, {
			"id": "331125",
			"pid": "331100",
			"name": "云和",
			"y": "y"
		}, {
			"id": "331126",
			"pid": "331100",
			"name": "庆元",
			"y": "q"
		}, {
			"id": "331127",
			"pid": "331100",
			"name": "景宁",
			"y": "j"
		}, {
			"id": "331181",
			"pid": "331100",
			"name": "龙泉",
			"y": "l"
		}]
	}]
}, {
	"id": "340000",
	"pid": "0",
	"name": "安徽",
	"y": "a",
	"child": [{
		"id": "340100",
		"pid": "340000",
		"name": "合肥",
		"y": "h",
		"child": [{
			"id": "340102",
			"pid": "340100",
			"name": "瑶海",
			"y": "y"
		}, {
			"id": "340103",
			"pid": "340100",
			"name": "庐阳",
			"y": "l"
		}, {
			"id": "340104",
			"pid": "340100",
			"name": "蜀山",
			"y": "s"
		}, {
			"id": "340111",
			"pid": "340100",
			"name": "包河",
			"y": "b"
		}, {
			"id": "340121",
			"pid": "340100",
			"name": "长丰",
			"y": "c"
		}, {
			"id": "340122",
			"pid": "340100",
			"name": "肥东",
			"y": "f"
		}, {
			"id": "340123",
			"pid": "340100",
			"name": "肥西",
			"y": "f"
		}, {
			"id": "340124",
			"pid": "340100",
			"name": "庐江",
			"y": "l"
		}, {
			"id": "340181",
			"pid": "340100",
			"name": "巢湖",
			"y": "c"
		}]
	}, {
		"id": "340200",
		"pid": "340000",
		"name": "芜湖",
		"y": "w",
		"child": [{
			"id": "340202",
			"pid": "340200",
			"name": "镜湖",
			"y": "j"
		}, {
			"id": "340207",
			"pid": "340200",
			"name": "鸠江",
			"y": "j"
		}, {
			"id": "340209",
			"pid": "340200",
			"name": "弋江",
			"y": "y"
		}, {
			"id": "340210",
			"pid": "340200",
			"name": "湾沚",
			"y": "w"
		}, {
			"id": "340212",
			"pid": "340200",
			"name": "繁昌",
			"y": "f"
		}, {
			"id": "340223",
			"pid": "340200",
			"name": "南陵",
			"y": "n"
		}, {
			"id": "340281",
			"pid": "340200",
			"name": "无为",
			"y": "w"
		}]
	}, {
		"id": "340300",
		"pid": "340000",
		"name": "蚌埠",
		"y": "b",
		"child": [{
			"id": "340302",
			"pid": "340300",
			"name": "龙子湖",
			"y": "l"
		}, {
			"id": "340303",
			"pid": "340300",
			"name": "蚌山",
			"y": "b"
		}, {
			"id": "340304",
			"pid": "340300",
			"name": "禹会",
			"y": "y"
		}, {
			"id": "340311",
			"pid": "340300",
			"name": "淮上",
			"y": "h"
		}, {
			"id": "340321",
			"pid": "340300",
			"name": "怀远",
			"y": "h"
		}, {
			"id": "340322",
			"pid": "340300",
			"name": "五河",
			"y": "w"
		}, {
			"id": "340323",
			"pid": "340300",
			"name": "固镇",
			"y": "g"
		}]
	}, {
		"id": "340400",
		"pid": "340000",
		"name": "淮南",
		"y": "h",
		"child": [{
			"id": "340402",
			"pid": "340400",
			"name": "大通",
			"y": "d"
		}, {
			"id": "340403",
			"pid": "340400",
			"name": "田家庵",
			"y": "t"
		}, {
			"id": "340404",
			"pid": "340400",
			"name": "谢家集",
			"y": "x"
		}, {
			"id": "340405",
			"pid": "340400",
			"name": "八公山",
			"y": "b"
		}, {
			"id": "340406",
			"pid": "340400",
			"name": "潘集",
			"y": "p"
		}, {
			"id": "340421",
			"pid": "340400",
			"name": "凤台",
			"y": "f"
		}, {
			"id": "340422",
			"pid": "340400",
			"name": "寿县",
			"y": "s"
		}]
	}, {
		"id": "340500",
		"pid": "340000",
		"name": "马鞍山",
		"y": "m",
		"child": [{
			"id": "340503",
			"pid": "340500",
			"name": "花山",
			"y": "h"
		}, {
			"id": "340504",
			"pid": "340500",
			"name": "雨山",
			"y": "y"
		}, {
			"id": "340506",
			"pid": "340500",
			"name": "博望",
			"y": "b"
		}, {
			"id": "340521",
			"pid": "340500",
			"name": "当涂",
			"y": "d"
		}, {
			"id": "340522",
			"pid": "340500",
			"name": "含山",
			"y": "h"
		}, {
			"id": "340523",
			"pid": "340500",
			"name": "和县",
			"y": "h"
		}]
	}, {
		"id": "340600",
		"pid": "340000",
		"name": "淮北",
		"y": "h",
		"child": [{
			"id": "340602",
			"pid": "340600",
			"name": "杜集",
			"y": "d"
		}, {
			"id": "340603",
			"pid": "340600",
			"name": "相山",
			"y": "x"
		}, {
			"id": "340604",
			"pid": "340600",
			"name": "烈山",
			"y": "l"
		}, {
			"id": "340621",
			"pid": "340600",
			"name": "濉溪",
			"y": "s"
		}]
	}, {
		"id": "340700",
		"pid": "340000",
		"name": "铜陵",
		"y": "t",
		"child": [{
			"id": "340705",
			"pid": "340700",
			"name": "铜官",
			"y": "t"
		}, {
			"id": "340706",
			"pid": "340700",
			"name": "义安",
			"y": "y"
		}, {
			"id": "340711",
			"pid": "340700",
			"name": "郊区",
			"y": "j"
		}, {
			"id": "340722",
			"pid": "340700",
			"name": "枞阳",
			"y": "z"
		}]
	}, {
		"id": "340800",
		"pid": "340000",
		"name": "安庆",
		"y": "a",
		"child": [{
			"id": "340802",
			"pid": "340800",
			"name": "迎江",
			"y": "y"
		}, {
			"id": "340803",
			"pid": "340800",
			"name": "大观",
			"y": "d"
		}, {
			"id": "340811",
			"pid": "340800",
			"name": "宜秀",
			"y": "y"
		}, {
			"id": "340822",
			"pid": "340800",
			"name": "怀宁",
			"y": "h"
		}, {
			"id": "340825",
			"pid": "340800",
			"name": "太湖",
			"y": "t"
		}, {
			"id": "340826",
			"pid": "340800",
			"name": "宿松",
			"y": "s"
		}, {
			"id": "340827",
			"pid": "340800",
			"name": "望江",
			"y": "w"
		}, {
			"id": "340828",
			"pid": "340800",
			"name": "岳西",
			"y": "y"
		}, {
			"id": "340881",
			"pid": "340800",
			"name": "桐城",
			"y": "t"
		}, {
			"id": "340882",
			"pid": "340800",
			"name": "潜山",
			"y": "q"
		}]
	}, {
		"id": "341000",
		"pid": "340000",
		"name": "黄山",
		"y": "h",
		"child": [{
			"id": "341002",
			"pid": "341000",
			"name": "屯溪",
			"y": "t"
		}, {
			"id": "341003",
			"pid": "341000",
			"name": "黄山区",
			"y": "h"
		}, {
			"id": "341004",
			"pid": "341000",
			"name": "徽州",
			"y": "h"
		}, {
			"id": "341021",
			"pid": "341000",
			"name": "歙县",
			"y": "s"
		}, {
			"id": "341022",
			"pid": "341000",
			"name": "休宁",
			"y": "x"
		}, {
			"id": "341023",
			"pid": "341000",
			"name": "黟县",
			"y": "y"
		}, {
			"id": "341024",
			"pid": "341000",
			"name": "祁门",
			"y": "q"
		}]
	}, {
		"id": "341100",
		"pid": "340000",
		"name": "滁州",
		"y": "c",
		"child": [{
			"id": "341102",
			"pid": "341100",
			"name": "琅琊",
			"y": "l"
		}, {
			"id": "341103",
			"pid": "341100",
			"name": "南谯",
			"y": "n"
		}, {
			"id": "341122",
			"pid": "341100",
			"name": "来安",
			"y": "l"
		}, {
			"id": "341124",
			"pid": "341100",
			"name": "全椒",
			"y": "q"
		}, {
			"id": "341125",
			"pid": "341100",
			"name": "定远",
			"y": "d"
		}, {
			"id": "341126",
			"pid": "341100",
			"name": "凤阳",
			"y": "f"
		}, {
			"id": "341181",
			"pid": "341100",
			"name": "天长",
			"y": "t"
		}, {
			"id": "341182",
			"pid": "341100",
			"name": "明光",
			"y": "m"
		}]
	}, {
		"id": "341200",
		"pid": "340000",
		"name": "阜阳",
		"y": "f",
		"child": [{
			"id": "341202",
			"pid": "341200",
			"name": "颍州",
			"y": "y"
		}, {
			"id": "341203",
			"pid": "341200",
			"name": "颍东",
			"y": "y"
		}, {
			"id": "341204",
			"pid": "341200",
			"name": "颍泉",
			"y": "y"
		}, {
			"id": "341221",
			"pid": "341200",
			"name": "临泉",
			"y": "l"
		}, {
			"id": "341222",
			"pid": "341200",
			"name": "太和",
			"y": "t"
		}, {
			"id": "341225",
			"pid": "341200",
			"name": "阜南",
			"y": "f"
		}, {
			"id": "341226",
			"pid": "341200",
			"name": "颍上",
			"y": "y"
		}, {
			"id": "341282",
			"pid": "341200",
			"name": "界首",
			"y": "j"
		}]
	}, {
		"id": "341300",
		"pid": "340000",
		"name": "宿州",
		"y": "s",
		"child": [{
			"id": "341302",
			"pid": "341300",
			"name": "埇桥",
			"y": "y"
		}, {
			"id": "341321",
			"pid": "341300",
			"name": "砀山",
			"y": "d"
		}, {
			"id": "341322",
			"pid": "341300",
			"name": "萧县",
			"y": "x"
		}, {
			"id": "341323",
			"pid": "341300",
			"name": "灵璧",
			"y": "l"
		}, {
			"id": "341324",
			"pid": "341300",
			"name": "泗县",
			"y": "s"
		}]
	}, {
		"id": "341500",
		"pid": "340000",
		"name": "六安",
		"y": "l",
		"child": [{
			"id": "341502",
			"pid": "341500",
			"name": "金安",
			"y": "j"
		}, {
			"id": "341503",
			"pid": "341500",
			"name": "裕安",
			"y": "y"
		}, {
			"id": "341504",
			"pid": "341500",
			"name": "叶集",
			"y": "y"
		}, {
			"id": "341522",
			"pid": "341500",
			"name": "霍邱",
			"y": "h"
		}, {
			"id": "341523",
			"pid": "341500",
			"name": "舒城",
			"y": "s"
		}, {
			"id": "341524",
			"pid": "341500",
			"name": "金寨",
			"y": "j"
		}, {
			"id": "341525",
			"pid": "341500",
			"name": "霍山",
			"y": "h"
		}]
	}, {
		"id": "341600",
		"pid": "340000",
		"name": "亳州",
		"y": "b",
		"child": [{
			"id": "341602",
			"pid": "341600",
			"name": "谯城",
			"y": "q"
		}, {
			"id": "341621",
			"pid": "341600",
			"name": "涡阳",
			"y": "g"
		}, {
			"id": "341622",
			"pid": "341600",
			"name": "蒙城",
			"y": "m"
		}, {
			"id": "341623",
			"pid": "341600",
			"name": "利辛",
			"y": "l"
		}]
	}, {
		"id": "341700",
		"pid": "340000",
		"name": "池州",
		"y": "c",
		"child": [{
			"id": "341702",
			"pid": "341700",
			"name": "贵池",
			"y": "g"
		}, {
			"id": "341721",
			"pid": "341700",
			"name": "东至",
			"y": "d"
		}, {
			"id": "341722",
			"pid": "341700",
			"name": "石台",
			"y": "s"
		}, {
			"id": "341723",
			"pid": "341700",
			"name": "青阳",
			"y": "q"
		}]
	}, {
		"id": "341800",
		"pid": "340000",
		"name": "宣城",
		"y": "x",
		"child": [{
			"id": "341802",
			"pid": "341800",
			"name": "宣州",
			"y": "x"
		}, {
			"id": "341821",
			"pid": "341800",
			"name": "郎溪",
			"y": "l"
		}, {
			"id": "341823",
			"pid": "341800",
			"name": "泾县",
			"y": "j"
		}, {
			"id": "341824",
			"pid": "341800",
			"name": "绩溪",
			"y": "j"
		}, {
			"id": "341825",
			"pid": "341800",
			"name": "旌德",
			"y": "j"
		}, {
			"id": "341881",
			"pid": "341800",
			"name": "宁国",
			"y": "n"
		}, {
			"id": "341882",
			"pid": "341800",
			"name": "广德",
			"y": "g"
		}]
	}]
}, {
	"id": "350000",
	"pid": "0",
	"name": "福建",
	"y": "f",
	"child": [{
		"id": "350100",
		"pid": "350000",
		"name": "福州",
		"y": "f",
		"child": [{
			"id": "350102",
			"pid": "350100",
			"name": "鼓楼",
			"y": "g"
		}, {
			"id": "350103",
			"pid": "350100",
			"name": "台江",
			"y": "t"
		}, {
			"id": "350104",
			"pid": "350100",
			"name": "仓山",
			"y": "c"
		}, {
			"id": "350105",
			"pid": "350100",
			"name": "马尾",
			"y": "m"
		}, {
			"id": "350111",
			"pid": "350100",
			"name": "晋安",
			"y": "j"
		}, {
			"id": "350112",
			"pid": "350100",
			"name": "长乐",
			"y": "c"
		}, {
			"id": "350121",
			"pid": "350100",
			"name": "闽侯",
			"y": "m"
		}, {
			"id": "350122",
			"pid": "350100",
			"name": "连江",
			"y": "l"
		}, {
			"id": "350123",
			"pid": "350100",
			"name": "罗源",
			"y": "l"
		}, {
			"id": "350124",
			"pid": "350100",
			"name": "闽清",
			"y": "m"
		}, {
			"id": "350125",
			"pid": "350100",
			"name": "永泰",
			"y": "y"
		}, {
			"id": "350128",
			"pid": "350100",
			"name": "平潭",
			"y": "p"
		}, {
			"id": "350181",
			"pid": "350100",
			"name": "福清",
			"y": "f"
		}]
	}, {
		"id": "350200",
		"pid": "350000",
		"name": "厦门",
		"y": "x",
		"child": [{
			"id": "350203",
			"pid": "350200",
			"name": "思明",
			"y": "s"
		}, {
			"id": "350205",
			"pid": "350200",
			"name": "海沧",
			"y": "h"
		}, {
			"id": "350206",
			"pid": "350200",
			"name": "湖里",
			"y": "h"
		}, {
			"id": "350211",
			"pid": "350200",
			"name": "集美",
			"y": "j"
		}, {
			"id": "350212",
			"pid": "350200",
			"name": "同安",
			"y": "t"
		}, {
			"id": "350213",
			"pid": "350200",
			"name": "翔安",
			"y": "x"
		}]
	}, {
		"id": "350300",
		"pid": "350000",
		"name": "莆田",
		"y": "p",
		"child": [{
			"id": "350302",
			"pid": "350300",
			"name": "城厢",
			"y": "c"
		}, {
			"id": "350303",
			"pid": "350300",
			"name": "涵江",
			"y": "h"
		}, {
			"id": "350304",
			"pid": "350300",
			"name": "荔城",
			"y": "l"
		}, {
			"id": "350305",
			"pid": "350300",
			"name": "秀屿",
			"y": "x"
		}, {
			"id": "350322",
			"pid": "350300",
			"name": "仙游",
			"y": "x"
		}]
	}, {
		"id": "350400",
		"pid": "350000",
		"name": "三明",
		"y": "s",
		"child": [{
			"id": "350403",
			"pid": "350400",
			"name": "三元",
			"y": "s"
		}, {
			"id": "350421",
			"pid": "350400",
			"name": "明溪",
			"y": "m"
		}, {
			"id": "350423",
			"pid": "350400",
			"name": "清流",
			"y": "q"
		}, {
			"id": "350424",
			"pid": "350400",
			"name": "宁化",
			"y": "n"
		}, {
			"id": "350425",
			"pid": "350400",
			"name": "大田",
			"y": "d"
		}, {
			"id": "350426",
			"pid": "350400",
			"name": "尤溪",
			"y": "y"
		}, {
			"id": "350427",
			"pid": "350400",
			"name": "沙县",
			"y": "s"
		}, {
			"id": "350428",
			"pid": "350400",
			"name": "将乐",
			"y": "j"
		}, {
			"id": "350429",
			"pid": "350400",
			"name": "泰宁",
			"y": "t"
		}, {
			"id": "350430",
			"pid": "350400",
			"name": "建宁",
			"y": "j"
		}, {
			"id": "350481",
			"pid": "350400",
			"name": "永安",
			"y": "y"
		}]
	}, {
		"id": "350500",
		"pid": "350000",
		"name": "泉州",
		"y": "q",
		"child": [{
			"id": "350502",
			"pid": "350500",
			"name": "鲤城",
			"y": "l"
		}, {
			"id": "350503",
			"pid": "350500",
			"name": "丰泽",
			"y": "f"
		}, {
			"id": "350504",
			"pid": "350500",
			"name": "洛江",
			"y": "l"
		}, {
			"id": "350505",
			"pid": "350500",
			"name": "泉港",
			"y": "q"
		}, {
			"id": "350521",
			"pid": "350500",
			"name": "惠安",
			"y": "h"
		}, {
			"id": "350524",
			"pid": "350500",
			"name": "安溪",
			"y": "a"
		}, {
			"id": "350525",
			"pid": "350500",
			"name": "永春",
			"y": "y"
		}, {
			"id": "350526",
			"pid": "350500",
			"name": "德化",
			"y": "d"
		}, {
			"id": "350527",
			"pid": "350500",
			"name": "金门",
			"y": "j"
		}, {
			"id": "350581",
			"pid": "350500",
			"name": "石狮",
			"y": "s"
		}, {
			"id": "350582",
			"pid": "350500",
			"name": "晋江",
			"y": "j"
		}, {
			"id": "350583",
			"pid": "350500",
			"name": "南安",
			"y": "n"
		}]
	}, {
		"id": "350600",
		"pid": "350000",
		"name": "漳州",
		"y": "z",
		"child": [{
			"id": "350602",
			"pid": "350600",
			"name": "芗城",
			"y": "x"
		}, {
			"id": "350603",
			"pid": "350600",
			"name": "龙文",
			"y": "l"
		}, {
			"id": "350622",
			"pid": "350600",
			"name": "云霄",
			"y": "y"
		}, {
			"id": "350623",
			"pid": "350600",
			"name": "漳浦",
			"y": "z"
		}, {
			"id": "350624",
			"pid": "350600",
			"name": "诏安",
			"y": "z"
		}, {
			"id": "350625",
			"pid": "350600",
			"name": "长泰",
			"y": "c"
		}, {
			"id": "350626",
			"pid": "350600",
			"name": "东山",
			"y": "d"
		}, {
			"id": "350627",
			"pid": "350600",
			"name": "南靖",
			"y": "n"
		}, {
			"id": "350628",
			"pid": "350600",
			"name": "平和",
			"y": "p"
		}, {
			"id": "350629",
			"pid": "350600",
			"name": "华安",
			"y": "h"
		}, {
			"id": "350681",
			"pid": "350600",
			"name": "龙海",
			"y": "l"
		}]
	}, {
		"id": "350700",
		"pid": "350000",
		"name": "南平",
		"y": "n",
		"child": [{
			"id": "350702",
			"pid": "350700",
			"name": "延平",
			"y": "y"
		}, {
			"id": "350703",
			"pid": "350700",
			"name": "建阳",
			"y": "j"
		}, {
			"id": "350721",
			"pid": "350700",
			"name": "顺昌",
			"y": "s"
		}, {
			"id": "350722",
			"pid": "350700",
			"name": "浦城",
			"y": "p"
		}, {
			"id": "350723",
			"pid": "350700",
			"name": "光泽",
			"y": "g"
		}, {
			"id": "350724",
			"pid": "350700",
			"name": "松溪",
			"y": "s"
		}, {
			"id": "350725",
			"pid": "350700",
			"name": "政和",
			"y": "z"
		}, {
			"id": "350781",
			"pid": "350700",
			"name": "邵武",
			"y": "s"
		}, {
			"id": "350782",
			"pid": "350700",
			"name": "武夷山",
			"y": "w"
		}, {
			"id": "350783",
			"pid": "350700",
			"name": "建瓯",
			"y": "j"
		}]
	}, {
		"id": "350800",
		"pid": "350000",
		"name": "龙岩",
		"y": "l",
		"child": [{
			"id": "350802",
			"pid": "350800",
			"name": "新罗",
			"y": "x"
		}, {
			"id": "350803",
			"pid": "350800",
			"name": "永定",
			"y": "y"
		}, {
			"id": "350821",
			"pid": "350800",
			"name": "长汀",
			"y": "c"
		}, {
			"id": "350823",
			"pid": "350800",
			"name": "上杭",
			"y": "s"
		}, {
			"id": "350824",
			"pid": "350800",
			"name": "武平",
			"y": "w"
		}, {
			"id": "350825",
			"pid": "350800",
			"name": "连城",
			"y": "l"
		}, {
			"id": "350881",
			"pid": "350800",
			"name": "漳平",
			"y": "z"
		}]
	}, {
		"id": "350900",
		"pid": "350000",
		"name": "宁德",
		"y": "n",
		"child": [{
			"id": "350902",
			"pid": "350900",
			"name": "蕉城",
			"y": "j"
		}, {
			"id": "350921",
			"pid": "350900",
			"name": "霞浦",
			"y": "x"
		}, {
			"id": "350922",
			"pid": "350900",
			"name": "古田",
			"y": "g"
		}, {
			"id": "350923",
			"pid": "350900",
			"name": "屏南",
			"y": "p"
		}, {
			"id": "350924",
			"pid": "350900",
			"name": "寿宁",
			"y": "s"
		}, {
			"id": "350925",
			"pid": "350900",
			"name": "周宁",
			"y": "z"
		}, {
			"id": "350926",
			"pid": "350900",
			"name": "柘荣",
			"y": "z"
		}, {
			"id": "350981",
			"pid": "350900",
			"name": "福安",
			"y": "f"
		}, {
			"id": "350982",
			"pid": "350900",
			"name": "福鼎",
			"y": "f"
		}]
	}]
}, {
	"id": "360000",
	"pid": "0",
	"name": "江西",
	"y": "j",
	"child": [{
		"id": "360100",
		"pid": "360000",
		"name": "南昌",
		"y": "n",
		"child": [{
			"id": "360102",
			"pid": "360100",
			"name": "东湖",
			"y": "d"
		}, {
			"id": "360103",
			"pid": "360100",
			"name": "西湖",
			"y": "x"
		}, {
			"id": "360104",
			"pid": "360100",
			"name": "青云谱",
			"y": "q"
		}, {
			"id": "360111",
			"pid": "360100",
			"name": "青山湖",
			"y": "q"
		}, {
			"id": "360112",
			"pid": "360100",
			"name": "新建",
			"y": "x"
		}, {
			"id": "360113",
			"pid": "360100",
			"name": "红谷滩",
			"y": "h"
		}, {
			"id": "360121",
			"pid": "360100",
			"name": "南昌县",
			"y": "n"
		}, {
			"id": "360123",
			"pid": "360100",
			"name": "安义",
			"y": "a"
		}, {
			"id": "360124",
			"pid": "360100",
			"name": "进贤",
			"y": "j"
		}]
	}, {
		"id": "360200",
		"pid": "360000",
		"name": "景德镇",
		"y": "j",
		"child": [{
			"id": "360202",
			"pid": "360200",
			"name": "昌江",
			"y": "c"
		}, {
			"id": "360203",
			"pid": "360200",
			"name": "珠山",
			"y": "z"
		}, {
			"id": "360222",
			"pid": "360200",
			"name": "浮梁",
			"y": "f"
		}, {
			"id": "360281",
			"pid": "360200",
			"name": "乐平",
			"y": "l"
		}]
	}, {
		"id": "360300",
		"pid": "360000",
		"name": "萍乡",
		"y": "p",
		"child": [{
			"id": "360302",
			"pid": "360300",
			"name": "安源",
			"y": "a"
		}, {
			"id": "360313",
			"pid": "360300",
			"name": "湘东",
			"y": "x"
		}, {
			"id": "360321",
			"pid": "360300",
			"name": "莲花",
			"y": "l"
		}, {
			"id": "360322",
			"pid": "360300",
			"name": "上栗",
			"y": "s"
		}, {
			"id": "360323",
			"pid": "360300",
			"name": "芦溪",
			"y": "l"
		}]
	}, {
		"id": "360400",
		"pid": "360000",
		"name": "九江",
		"y": "j",
		"child": [{
			"id": "360402",
			"pid": "360400",
			"name": "濂溪",
			"y": "l"
		}, {
			"id": "360403",
			"pid": "360400",
			"name": "浔阳",
			"y": "x"
		}, {
			"id": "360404",
			"pid": "360400",
			"name": "柴桑",
			"y": "c"
		}, {
			"id": "360423",
			"pid": "360400",
			"name": "武宁",
			"y": "w"
		}, {
			"id": "360424",
			"pid": "360400",
			"name": "修水",
			"y": "x"
		}, {
			"id": "360425",
			"pid": "360400",
			"name": "永修",
			"y": "y"
		}, {
			"id": "360426",
			"pid": "360400",
			"name": "德安",
			"y": "d"
		}, {
			"id": "360428",
			"pid": "360400",
			"name": "都昌",
			"y": "d"
		}, {
			"id": "360429",
			"pid": "360400",
			"name": "湖口",
			"y": "h"
		}, {
			"id": "360430",
			"pid": "360400",
			"name": "彭泽",
			"y": "p"
		}, {
			"id": "360481",
			"pid": "360400",
			"name": "瑞昌",
			"y": "r"
		}, {
			"id": "360482",
			"pid": "360400",
			"name": "共青城",
			"y": "g"
		}, {
			"id": "360483",
			"pid": "360400",
			"name": "庐山",
			"y": "l"
		}]
	}, {
		"id": "360500",
		"pid": "360000",
		"name": "新余",
		"y": "x",
		"child": [{
			"id": "360502",
			"pid": "360500",
			"name": "渝水",
			"y": "y"
		}, {
			"id": "360521",
			"pid": "360500",
			"name": "分宜",
			"y": "f"
		}]
	}, {
		"id": "360600",
		"pid": "360000",
		"name": "鹰潭",
		"y": "y",
		"child": [{
			"id": "360602",
			"pid": "360600",
			"name": "月湖",
			"y": "y"
		}, {
			"id": "360603",
			"pid": "360600",
			"name": "余江",
			"y": "y"
		}, {
			"id": "360681",
			"pid": "360600",
			"name": "贵溪",
			"y": "g"
		}]
	}, {
		"id": "360700",
		"pid": "360000",
		"name": "赣州",
		"y": "g",
		"child": [{
			"id": "360702",
			"pid": "360700",
			"name": "章贡",
			"y": "z"
		}, {
			"id": "360703",
			"pid": "360700",
			"name": "南康",
			"y": "n"
		}, {
			"id": "360704",
			"pid": "360700",
			"name": "赣县",
			"y": "g"
		}, {
			"id": "360722",
			"pid": "360700",
			"name": "信丰",
			"y": "x"
		}, {
			"id": "360723",
			"pid": "360700",
			"name": "大余",
			"y": "d"
		}, {
			"id": "360724",
			"pid": "360700",
			"name": "上犹",
			"y": "s"
		}, {
			"id": "360725",
			"pid": "360700",
			"name": "崇义",
			"y": "c"
		}, {
			"id": "360726",
			"pid": "360700",
			"name": "安远",
			"y": "a"
		}, {
			"id": "360728",
			"pid": "360700",
			"name": "定南",
			"y": "d"
		}, {
			"id": "360729",
			"pid": "360700",
			"name": "全南",
			"y": "q"
		}, {
			"id": "360730",
			"pid": "360700",
			"name": "宁都",
			"y": "n"
		}, {
			"id": "360731",
			"pid": "360700",
			"name": "于都",
			"y": "y"
		}, {
			"id": "360732",
			"pid": "360700",
			"name": "兴国",
			"y": "x"
		}, {
			"id": "360733",
			"pid": "360700",
			"name": "会昌",
			"y": "h"
		}, {
			"id": "360734",
			"pid": "360700",
			"name": "寻乌",
			"y": "x"
		}, {
			"id": "360735",
			"pid": "360700",
			"name": "石城",
			"y": "s"
		}, {
			"id": "360781",
			"pid": "360700",
			"name": "瑞金",
			"y": "r"
		}, {
			"id": "360783",
			"pid": "360700",
			"name": "龙南",
			"y": "l"
		}]
	}, {
		"id": "360800",
		"pid": "360000",
		"name": "吉安",
		"y": "j",
		"child": [{
			"id": "360802",
			"pid": "360800",
			"name": "吉州",
			"y": "j"
		}, {
			"id": "360803",
			"pid": "360800",
			"name": "青原",
			"y": "q"
		}, {
			"id": "360821",
			"pid": "360800",
			"name": "吉安县",
			"y": "j"
		}, {
			"id": "360822",
			"pid": "360800",
			"name": "吉水",
			"y": "j"
		}, {
			"id": "360823",
			"pid": "360800",
			"name": "峡江",
			"y": "x"
		}, {
			"id": "360824",
			"pid": "360800",
			"name": "新干",
			"y": "x"
		}, {
			"id": "360825",
			"pid": "360800",
			"name": "永丰",
			"y": "y"
		}, {
			"id": "360826",
			"pid": "360800",
			"name": "泰和",
			"y": "t"
		}, {
			"id": "360827",
			"pid": "360800",
			"name": "遂川",
			"y": "s"
		}, {
			"id": "360828",
			"pid": "360800",
			"name": "万安",
			"y": "w"
		}, {
			"id": "360829",
			"pid": "360800",
			"name": "安福",
			"y": "a"
		}, {
			"id": "360830",
			"pid": "360800",
			"name": "永新",
			"y": "y"
		}, {
			"id": "360881",
			"pid": "360800",
			"name": "井冈山",
			"y": "j"
		}]
	}, {
		"id": "360900",
		"pid": "360000",
		"name": "宜春",
		"y": "y",
		"child": [{
			"id": "360902",
			"pid": "360900",
			"name": "袁州",
			"y": "y"
		}, {
			"id": "360921",
			"pid": "360900",
			"name": "奉新",
			"y": "f"
		}, {
			"id": "360922",
			"pid": "360900",
			"name": "万载",
			"y": "w"
		}, {
			"id": "360923",
			"pid": "360900",
			"name": "上高",
			"y": "s"
		}, {
			"id": "360924",
			"pid": "360900",
			"name": "宜丰",
			"y": "y"
		}, {
			"id": "360925",
			"pid": "360900",
			"name": "靖安",
			"y": "j"
		}, {
			"id": "360926",
			"pid": "360900",
			"name": "铜鼓",
			"y": "t"
		}, {
			"id": "360981",
			"pid": "360900",
			"name": "丰城",
			"y": "f"
		}, {
			"id": "360982",
			"pid": "360900",
			"name": "樟树",
			"y": "z"
		}, {
			"id": "360983",
			"pid": "360900",
			"name": "高安",
			"y": "g"
		}]
	}, {
		"id": "361000",
		"pid": "360000",
		"name": "抚州",
		"y": "f",
		"child": [{
			"id": "361002",
			"pid": "361000",
			"name": "临川",
			"y": "l"
		}, {
			"id": "361003",
			"pid": "361000",
			"name": "东乡",
			"y": "d"
		}, {
			"id": "361021",
			"pid": "361000",
			"name": "南城",
			"y": "n"
		}, {
			"id": "361022",
			"pid": "361000",
			"name": "黎川",
			"y": "l"
		}, {
			"id": "361023",
			"pid": "361000",
			"name": "南丰",
			"y": "n"
		}, {
			"id": "361024",
			"pid": "361000",
			"name": "崇仁",
			"y": "c"
		}, {
			"id": "361025",
			"pid": "361000",
			"name": "乐安",
			"y": "l"
		}, {
			"id": "361026",
			"pid": "361000",
			"name": "宜黄",
			"y": "y"
		}, {
			"id": "361027",
			"pid": "361000",
			"name": "金溪",
			"y": "j"
		}, {
			"id": "361028",
			"pid": "361000",
			"name": "资溪",
			"y": "z"
		}, {
			"id": "361030",
			"pid": "361000",
			"name": "广昌",
			"y": "g"
		}]
	}, {
		"id": "361100",
		"pid": "360000",
		"name": "上饶",
		"y": "s",
		"child": [{
			"id": "361102",
			"pid": "361100",
			"name": "信州",
			"y": "x"
		}, {
			"id": "361103",
			"pid": "361100",
			"name": "广丰",
			"y": "g"
		}, {
			"id": "361104",
			"pid": "361100",
			"name": "广信",
			"y": "g"
		}, {
			"id": "361123",
			"pid": "361100",
			"name": "玉山",
			"y": "y"
		}, {
			"id": "361124",
			"pid": "361100",
			"name": "铅山",
			"y": "y"
		}, {
			"id": "361125",
			"pid": "361100",
			"name": "横峰",
			"y": "h"
		}, {
			"id": "361126",
			"pid": "361100",
			"name": "弋阳",
			"y": "y"
		}, {
			"id": "361127",
			"pid": "361100",
			"name": "余干",
			"y": "y"
		}, {
			"id": "361128",
			"pid": "361100",
			"name": "鄱阳",
			"y": "p"
		}, {
			"id": "361129",
			"pid": "361100",
			"name": "万年",
			"y": "w"
		}, {
			"id": "361130",
			"pid": "361100",
			"name": "婺源",
			"y": "w"
		}, {
			"id": "361181",
			"pid": "361100",
			"name": "德兴",
			"y": "d"
		}]
	}]
}, {
	"id": "370000",
	"pid": "0",
	"name": "山东",
	"y": "s",
	"child": [{
		"id": "370100",
		"pid": "370000",
		"name": "济南",
		"y": "j",
		"child": [{
			"id": "370102",
			"pid": "370100",
			"name": "历下",
			"y": "l"
		}, {
			"id": "370103",
			"pid": "370100",
			"name": "市中",
			"y": "s"
		}, {
			"id": "370104",
			"pid": "370100",
			"name": "槐荫",
			"y": "h"
		}, {
			"id": "370105",
			"pid": "370100",
			"name": "天桥",
			"y": "t"
		}, {
			"id": "370112",
			"pid": "370100",
			"name": "历城",
			"y": "l"
		}, {
			"id": "370113",
			"pid": "370100",
			"name": "长清",
			"y": "c"
		}, {
			"id": "370114",
			"pid": "370100",
			"name": "章丘",
			"y": "z"
		}, {
			"id": "370115",
			"pid": "370100",
			"name": "济阳",
			"y": "j"
		}, {
			"id": "370116",
			"pid": "370100",
			"name": "莱芜",
			"y": "l"
		}, {
			"id": "370117",
			"pid": "370100",
			"name": "钢城",
			"y": "g"
		}, {
			"id": "370124",
			"pid": "370100",
			"name": "平阴",
			"y": "p"
		}, {
			"id": "370126",
			"pid": "370100",
			"name": "商河",
			"y": "s"
		}]
	}, {
		"id": "370200",
		"pid": "370000",
		"name": "青岛",
		"y": "q",
		"child": [{
			"id": "370202",
			"pid": "370200",
			"name": "市南",
			"y": "s"
		}, {
			"id": "370203",
			"pid": "370200",
			"name": "市北",
			"y": "s"
		}, {
			"id": "370211",
			"pid": "370200",
			"name": "黄岛",
			"y": "h"
		}, {
			"id": "370212",
			"pid": "370200",
			"name": "崂山",
			"y": "l"
		}, {
			"id": "370213",
			"pid": "370200",
			"name": "李沧",
			"y": "l"
		}, {
			"id": "370214",
			"pid": "370200",
			"name": "城阳",
			"y": "c"
		}, {
			"id": "370215",
			"pid": "370200",
			"name": "即墨",
			"y": "j"
		}, {
			"id": "370281",
			"pid": "370200",
			"name": "胶州",
			"y": "j"
		}, {
			"id": "370283",
			"pid": "370200",
			"name": "平度",
			"y": "p"
		}, {
			"id": "370285",
			"pid": "370200",
			"name": "莱西",
			"y": "l"
		}]
	}, {
		"id": "370300",
		"pid": "370000",
		"name": "淄博",
		"y": "z",
		"child": [{
			"id": "370302",
			"pid": "370300",
			"name": "淄川",
			"y": "z"
		}, {
			"id": "370303",
			"pid": "370300",
			"name": "张店",
			"y": "z"
		}, {
			"id": "370304",
			"pid": "370300",
			"name": "博山",
			"y": "b"
		}, {
			"id": "370305",
			"pid": "370300",
			"name": "临淄",
			"y": "l"
		}, {
			"id": "370306",
			"pid": "370300",
			"name": "周村",
			"y": "z"
		}, {
			"id": "370321",
			"pid": "370300",
			"name": "桓台",
			"y": "h"
		}, {
			"id": "370322",
			"pid": "370300",
			"name": "高青",
			"y": "g"
		}, {
			"id": "370323",
			"pid": "370300",
			"name": "沂源",
			"y": "y"
		}]
	}, {
		"id": "370400",
		"pid": "370000",
		"name": "枣庄",
		"y": "z",
		"child": [{
			"id": "370402",
			"pid": "370400",
			"name": "市中",
			"y": "s"
		}, {
			"id": "370403",
			"pid": "370400",
			"name": "薛城",
			"y": "x"
		}, {
			"id": "370404",
			"pid": "370400",
			"name": "峄城",
			"y": "y"
		}, {
			"id": "370405",
			"pid": "370400",
			"name": "台儿庄",
			"y": "t"
		}, {
			"id": "370406",
			"pid": "370400",
			"name": "山亭",
			"y": "s"
		}, {
			"id": "370481",
			"pid": "370400",
			"name": "滕州",
			"y": "t"
		}]
	}, {
		"id": "370500",
		"pid": "370000",
		"name": "东营",
		"y": "d",
		"child": [{
			"id": "370502",
			"pid": "370500",
			"name": "东营区",
			"y": "d"
		}, {
			"id": "370503",
			"pid": "370500",
			"name": "河口",
			"y": "h"
		}, {
			"id": "370505",
			"pid": "370500",
			"name": "垦利",
			"y": "k"
		}, {
			"id": "370522",
			"pid": "370500",
			"name": "利津",
			"y": "l"
		}, {
			"id": "370523",
			"pid": "370500",
			"name": "广饶",
			"y": "g"
		}]
	}, {
		"id": "370600",
		"pid": "370000",
		"name": "烟台",
		"y": "y",
		"child": [{
			"id": "370602",
			"pid": "370600",
			"name": "芝罘",
			"y": "z"
		}, {
			"id": "370611",
			"pid": "370600",
			"name": "福山",
			"y": "f"
		}, {
			"id": "370612",
			"pid": "370600",
			"name": "牟平",
			"y": "m"
		}, {
			"id": "370613",
			"pid": "370600",
			"name": "莱山",
			"y": "l"
		}, {
			"id": "370614",
			"pid": "370600",
			"name": "蓬莱",
			"y": "p"
		}, {
			"id": "370681",
			"pid": "370600",
			"name": "龙口",
			"y": "l"
		}, {
			"id": "370682",
			"pid": "370600",
			"name": "莱阳",
			"y": "l"
		}, {
			"id": "370683",
			"pid": "370600",
			"name": "莱州",
			"y": "l"
		}, {
			"id": "370685",
			"pid": "370600",
			"name": "招远",
			"y": "z"
		}, {
			"id": "370686",
			"pid": "370600",
			"name": "栖霞",
			"y": "q"
		}, {
			"id": "370687",
			"pid": "370600",
			"name": "海阳",
			"y": "h"
		}]
	}, {
		"id": "370700",
		"pid": "370000",
		"name": "潍坊",
		"y": "w",
		"child": [{
			"id": "370702",
			"pid": "370700",
			"name": "潍城",
			"y": "w"
		}, {
			"id": "370703",
			"pid": "370700",
			"name": "寒亭",
			"y": "h"
		}, {
			"id": "370704",
			"pid": "370700",
			"name": "坊子",
			"y": "f"
		}, {
			"id": "370705",
			"pid": "370700",
			"name": "奎文",
			"y": "k"
		}, {
			"id": "370724",
			"pid": "370700",
			"name": "临朐",
			"y": "l"
		}, {
			"id": "370725",
			"pid": "370700",
			"name": "昌乐",
			"y": "c"
		}, {
			"id": "370781",
			"pid": "370700",
			"name": "青州",
			"y": "q"
		}, {
			"id": "370782",
			"pid": "370700",
			"name": "诸城",
			"y": "z"
		}, {
			"id": "370783",
			"pid": "370700",
			"name": "寿光",
			"y": "s"
		}, {
			"id": "370784",
			"pid": "370700",
			"name": "安丘",
			"y": "a"
		}, {
			"id": "370785",
			"pid": "370700",
			"name": "高密",
			"y": "g"
		}, {
			"id": "370786",
			"pid": "370700",
			"name": "昌邑",
			"y": "c"
		}]
	}, {
		"id": "370800",
		"pid": "370000",
		"name": "济宁",
		"y": "j",
		"child": [{
			"id": "370811",
			"pid": "370800",
			"name": "任城",
			"y": "r"
		}, {
			"id": "370812",
			"pid": "370800",
			"name": "兖州",
			"y": "y"
		}, {
			"id": "370826",
			"pid": "370800",
			"name": "微山",
			"y": "w"
		}, {
			"id": "370827",
			"pid": "370800",
			"name": "鱼台",
			"y": "y"
		}, {
			"id": "370828",
			"pid": "370800",
			"name": "金乡",
			"y": "j"
		}, {
			"id": "370829",
			"pid": "370800",
			"name": "嘉祥",
			"y": "j"
		}, {
			"id": "370830",
			"pid": "370800",
			"name": "汶上",
			"y": "w"
		}, {
			"id": "370831",
			"pid": "370800",
			"name": "泗水",
			"y": "s"
		}, {
			"id": "370832",
			"pid": "370800",
			"name": "梁山",
			"y": "l"
		}, {
			"id": "370881",
			"pid": "370800",
			"name": "曲阜",
			"y": "q"
		}, {
			"id": "370883",
			"pid": "370800",
			"name": "邹城",
			"y": "z"
		}]
	}, {
		"id": "370900",
		"pid": "370000",
		"name": "泰安",
		"y": "t",
		"child": [{
			"id": "370902",
			"pid": "370900",
			"name": "泰山",
			"y": "t"
		}, {
			"id": "370911",
			"pid": "370900",
			"name": "岱岳",
			"y": "d"
		}, {
			"id": "370921",
			"pid": "370900",
			"name": "宁阳",
			"y": "n"
		}, {
			"id": "370923",
			"pid": "370900",
			"name": "东平",
			"y": "d"
		}, {
			"id": "370982",
			"pid": "370900",
			"name": "新泰",
			"y": "x"
		}, {
			"id": "370983",
			"pid": "370900",
			"name": "肥城",
			"y": "f"
		}]
	}, {
		"id": "371000",
		"pid": "370000",
		"name": "威海",
		"y": "w",
		"child": [{
			"id": "371002",
			"pid": "371000",
			"name": "环翠",
			"y": "h"
		}, {
			"id": "371003",
			"pid": "371000",
			"name": "文登",
			"y": "w"
		}, {
			"id": "371082",
			"pid": "371000",
			"name": "荣成",
			"y": "r"
		}, {
			"id": "371083",
			"pid": "371000",
			"name": "乳山",
			"y": "r"
		}]
	}, {
		"id": "371100",
		"pid": "370000",
		"name": "日照",
		"y": "r",
		"child": [{
			"id": "371102",
			"pid": "371100",
			"name": "东港",
			"y": "d"
		}, {
			"id": "371103",
			"pid": "371100",
			"name": "岚山",
			"y": "l"
		}, {
			"id": "371121",
			"pid": "371100",
			"name": "五莲",
			"y": "w"
		}, {
			"id": "371122",
			"pid": "371100",
			"name": "莒县",
			"y": "j"
		}]
	}, {
		"id": "371300",
		"pid": "370000",
		"name": "临沂",
		"y": "l",
		"child": [{
			"id": "371302",
			"pid": "371300",
			"name": "兰山",
			"y": "l"
		}, {
			"id": "371311",
			"pid": "371300",
			"name": "罗庄",
			"y": "l"
		}, {
			"id": "371312",
			"pid": "371300",
			"name": "河东",
			"y": "h"
		}, {
			"id": "371321",
			"pid": "371300",
			"name": "沂南",
			"y": "y"
		}, {
			"id": "371322",
			"pid": "371300",
			"name": "郯城",
			"y": "t"
		}, {
			"id": "371323",
			"pid": "371300",
			"name": "沂水",
			"y": "y"
		}, {
			"id": "371324",
			"pid": "371300",
			"name": "兰陵",
			"y": "l"
		}, {
			"id": "371325",
			"pid": "371300",
			"name": "费县",
			"y": "f"
		}, {
			"id": "371326",
			"pid": "371300",
			"name": "平邑",
			"y": "p"
		}, {
			"id": "371327",
			"pid": "371300",
			"name": "莒南",
			"y": "j"
		}, {
			"id": "371328",
			"pid": "371300",
			"name": "蒙阴",
			"y": "m"
		}, {
			"id": "371329",
			"pid": "371300",
			"name": "临沭",
			"y": "l"
		}]
	}, {
		"id": "371400",
		"pid": "370000",
		"name": "德州",
		"y": "d",
		"child": [{
			"id": "371402",
			"pid": "371400",
			"name": "德城",
			"y": "d"
		}, {
			"id": "371403",
			"pid": "371400",
			"name": "陵城",
			"y": "l"
		}, {
			"id": "371422",
			"pid": "371400",
			"name": "宁津",
			"y": "n"
		}, {
			"id": "371423",
			"pid": "371400",
			"name": "庆云",
			"y": "q"
		}, {
			"id": "371424",
			"pid": "371400",
			"name": "临邑",
			"y": "l"
		}, {
			"id": "371425",
			"pid": "371400",
			"name": "齐河",
			"y": "q"
		}, {
			"id": "371426",
			"pid": "371400",
			"name": "平原",
			"y": "p"
		}, {
			"id": "371427",
			"pid": "371400",
			"name": "夏津",
			"y": "x"
		}, {
			"id": "371428",
			"pid": "371400",
			"name": "武城",
			"y": "w"
		}, {
			"id": "371481",
			"pid": "371400",
			"name": "乐陵",
			"y": "l"
		}, {
			"id": "371482",
			"pid": "371400",
			"name": "禹城",
			"y": "y"
		}]
	}, {
		"id": "371500",
		"pid": "370000",
		"name": "聊城",
		"y": "l",
		"child": [{
			"id": "371502",
			"pid": "371500",
			"name": "东昌府",
			"y": "d"
		}, {
			"id": "371503",
			"pid": "371500",
			"name": "茌平",
			"y": "c"
		}, {
			"id": "371521",
			"pid": "371500",
			"name": "阳谷",
			"y": "y"
		}, {
			"id": "371522",
			"pid": "371500",
			"name": "莘县",
			"y": "s"
		}, {
			"id": "371524",
			"pid": "371500",
			"name": "东阿",
			"y": "d"
		}, {
			"id": "371525",
			"pid": "371500",
			"name": "冠县",
			"y": "g"
		}, {
			"id": "371526",
			"pid": "371500",
			"name": "高唐",
			"y": "g"
		}, {
			"id": "371581",
			"pid": "371500",
			"name": "临清",
			"y": "l"
		}]
	}, {
		"id": "371600",
		"pid": "370000",
		"name": "滨州",
		"y": "b",
		"child": [{
			"id": "371602",
			"pid": "371600",
			"name": "滨城",
			"y": "b"
		}, {
			"id": "371603",
			"pid": "371600",
			"name": "沾化",
			"y": "z"
		}, {
			"id": "371621",
			"pid": "371600",
			"name": "惠民",
			"y": "h"
		}, {
			"id": "371622",
			"pid": "371600",
			"name": "阳信",
			"y": "y"
		}, {
			"id": "371623",
			"pid": "371600",
			"name": "无棣",
			"y": "w"
		}, {
			"id": "371625",
			"pid": "371600",
			"name": "博兴",
			"y": "b"
		}, {
			"id": "371681",
			"pid": "371600",
			"name": "邹平",
			"y": "z"
		}]
	}, {
		"id": "371700",
		"pid": "370000",
		"name": "菏泽",
		"y": "h",
		"child": [{
			"id": "371702",
			"pid": "371700",
			"name": "牡丹",
			"y": "m"
		}, {
			"id": "371703",
			"pid": "371700",
			"name": "定陶",
			"y": "d"
		}, {
			"id": "371721",
			"pid": "371700",
			"name": "曹县",
			"y": "c"
		}, {
			"id": "371722",
			"pid": "371700",
			"name": "单县",
			"y": "s"
		}, {
			"id": "371723",
			"pid": "371700",
			"name": "成武",
			"y": "c"
		}, {
			"id": "371724",
			"pid": "371700",
			"name": "巨野",
			"y": "j"
		}, {
			"id": "371725",
			"pid": "371700",
			"name": "郓城",
			"y": "y"
		}, {
			"id": "371726",
			"pid": "371700",
			"name": "鄄城",
			"y": "j"
		}, {
			"id": "371728",
			"pid": "371700",
			"name": "东明",
			"y": "d"
		}]
	}]
}, {
	"id": "410000",
	"pid": "0",
	"name": "河南",
	"y": "h",
	"child": [{
		"id": "410100",
		"pid": "410000",
		"name": "郑州",
		"y": "z",
		"child": [{
			"id": "410102",
			"pid": "410100",
			"name": "中原",
			"y": "z"
		}, {
			"id": "410103",
			"pid": "410100",
			"name": "二七",
			"y": "e"
		}, {
			"id": "410104",
			"pid": "410100",
			"name": "管城回族区",
			"y": "g"
		}, {
			"id": "410105",
			"pid": "410100",
			"name": "金水",
			"y": "j"
		}, {
			"id": "410106",
			"pid": "410100",
			"name": "上街",
			"y": "s"
		}, {
			"id": "410108",
			"pid": "410100",
			"name": "惠济",
			"y": "h"
		}, {
			"id": "410122",
			"pid": "410100",
			"name": "中牟",
			"y": "z"
		}, {
			"id": "410181",
			"pid": "410100",
			"name": "巩义",
			"y": "g"
		}, {
			"id": "410182",
			"pid": "410100",
			"name": "荥阳",
			"y": "x"
		}, {
			"id": "410183",
			"pid": "410100",
			"name": "新密",
			"y": "x"
		}, {
			"id": "410184",
			"pid": "410100",
			"name": "新郑",
			"y": "x"
		}, {
			"id": "410185",
			"pid": "410100",
			"name": "登封",
			"y": "d"
		}]
	}, {
		"id": "410200",
		"pid": "410000",
		"name": "开封",
		"y": "k",
		"child": [{
			"id": "410202",
			"pid": "410200",
			"name": "龙亭",
			"y": "l"
		}, {
			"id": "410203",
			"pid": "410200",
			"name": "顺河回族区",
			"y": "s"
		}, {
			"id": "410204",
			"pid": "410200",
			"name": "鼓楼",
			"y": "g"
		}, {
			"id": "410205",
			"pid": "410200",
			"name": "禹王台",
			"y": "y"
		}, {
			"id": "410212",
			"pid": "410200",
			"name": "祥符",
			"y": "x"
		}, {
			"id": "410221",
			"pid": "410200",
			"name": "杞县",
			"y": "q"
		}, {
			"id": "410222",
			"pid": "410200",
			"name": "通许",
			"y": "t"
		}, {
			"id": "410223",
			"pid": "410200",
			"name": "尉氏",
			"y": "w"
		}, {
			"id": "410225",
			"pid": "410200",
			"name": "兰考",
			"y": "l"
		}]
	}, {
		"id": "410300",
		"pid": "410000",
		"name": "洛阳",
		"y": "l",
		"child": [{
			"id": "410302",
			"pid": "410300",
			"name": "老城",
			"y": "l"
		}, {
			"id": "410303",
			"pid": "410300",
			"name": "西工",
			"y": "x"
		}, {
			"id": "410304",
			"pid": "410300",
			"name": "瀍河回族区",
			"y": "c"
		}, {
			"id": "410305",
			"pid": "410300",
			"name": "涧西",
			"y": "j"
		}, {
			"id": "410306",
			"pid": "410300",
			"name": "孟津",
			"y": "m"
		}, {
			"id": "410311",
			"pid": "410300",
			"name": "洛龙",
			"y": "l"
		}, {
			"id": "410323",
			"pid": "410300",
			"name": "新安",
			"y": "x"
		}, {
			"id": "410324",
			"pid": "410300",
			"name": "栾川",
			"y": "l"
		}, {
			"id": "410325",
			"pid": "410300",
			"name": "嵩县",
			"y": "s"
		}, {
			"id": "410326",
			"pid": "410300",
			"name": "汝阳",
			"y": "r"
		}, {
			"id": "410327",
			"pid": "410300",
			"name": "宜阳",
			"y": "y"
		}, {
			"id": "410328",
			"pid": "410300",
			"name": "洛宁",
			"y": "l"
		}, {
			"id": "410329",
			"pid": "410300",
			"name": "伊川",
			"y": "y"
		}, {
			"id": "410381",
			"pid": "410300",
			"name": "偃师",
			"y": "y"
		}]
	}, {
		"id": "410400",
		"pid": "410000",
		"name": "平顶山",
		"y": "p",
		"child": [{
			"id": "410402",
			"pid": "410400",
			"name": "新华",
			"y": "x"
		}, {
			"id": "410403",
			"pid": "410400",
			"name": "卫东",
			"y": "w"
		}, {
			"id": "410404",
			"pid": "410400",
			"name": "石龙",
			"y": "s"
		}, {
			"id": "410411",
			"pid": "410400",
			"name": "湛河",
			"y": "z"
		}, {
			"id": "410421",
			"pid": "410400",
			"name": "宝丰",
			"y": "b"
		}, {
			"id": "410422",
			"pid": "410400",
			"name": "叶县",
			"y": "y"
		}, {
			"id": "410423",
			"pid": "410400",
			"name": "鲁山",
			"y": "l"
		}, {
			"id": "410425",
			"pid": "410400",
			"name": "郏县",
			"y": "j"
		}, {
			"id": "410481",
			"pid": "410400",
			"name": "舞钢",
			"y": "w"
		}, {
			"id": "410482",
			"pid": "410400",
			"name": "汝州",
			"y": "r"
		}]
	}, {
		"id": "410500",
		"pid": "410000",
		"name": "安阳",
		"y": "a",
		"child": [{
			"id": "410502",
			"pid": "410500",
			"name": "文峰",
			"y": "w"
		}, {
			"id": "410503",
			"pid": "410500",
			"name": "北关",
			"y": "b"
		}, {
			"id": "410505",
			"pid": "410500",
			"name": "殷都",
			"y": "y"
		}, {
			"id": "410506",
			"pid": "410500",
			"name": "龙安",
			"y": "l"
		}, {
			"id": "410522",
			"pid": "410500",
			"name": "安阳县",
			"y": "a"
		}, {
			"id": "410523",
			"pid": "410500",
			"name": "汤阴",
			"y": "t"
		}, {
			"id": "410526",
			"pid": "410500",
			"name": "滑县",
			"y": "h"
		}, {
			"id": "410527",
			"pid": "410500",
			"name": "内黄",
			"y": "n"
		}, {
			"id": "410581",
			"pid": "410500",
			"name": "林州",
			"y": "l"
		}]
	}, {
		"id": "410600",
		"pid": "410000",
		"name": "鹤壁",
		"y": "h",
		"child": [{
			"id": "410602",
			"pid": "410600",
			"name": "鹤山",
			"y": "h"
		}, {
			"id": "410603",
			"pid": "410600",
			"name": "山城",
			"y": "s"
		}, {
			"id": "410611",
			"pid": "410600",
			"name": "淇滨",
			"y": "q"
		}, {
			"id": "410621",
			"pid": "410600",
			"name": "浚县",
			"y": "x"
		}, {
			"id": "410622",
			"pid": "410600",
			"name": "淇县",
			"y": "q"
		}]
	}, {
		"id": "410700",
		"pid": "410000",
		"name": "新乡",
		"y": "x",
		"child": [{
			"id": "410702",
			"pid": "410700",
			"name": "红旗",
			"y": "h"
		}, {
			"id": "410703",
			"pid": "410700",
			"name": "卫滨",
			"y": "w"
		}, {
			"id": "410704",
			"pid": "410700",
			"name": "凤泉",
			"y": "f"
		}, {
			"id": "410711",
			"pid": "410700",
			"name": "牧野",
			"y": "m"
		}, {
			"id": "410721",
			"pid": "410700",
			"name": "新乡县",
			"y": "x"
		}, {
			"id": "410724",
			"pid": "410700",
			"name": "获嘉",
			"y": "h"
		}, {
			"id": "410725",
			"pid": "410700",
			"name": "原阳",
			"y": "y"
		}, {
			"id": "410726",
			"pid": "410700",
			"name": "延津",
			"y": "y"
		}, {
			"id": "410727",
			"pid": "410700",
			"name": "封丘",
			"y": "f"
		}, {
			"id": "410781",
			"pid": "410700",
			"name": "卫辉",
			"y": "w"
		}, {
			"id": "410782",
			"pid": "410700",
			"name": "辉县",
			"y": "h"
		}, {
			"id": "410783",
			"pid": "410700",
			"name": "长垣",
			"y": "c"
		}]
	}, {
		"id": "410800",
		"pid": "410000",
		"name": "焦作",
		"y": "j",
		"child": [{
			"id": "410802",
			"pid": "410800",
			"name": "解放",
			"y": "j"
		}, {
			"id": "410803",
			"pid": "410800",
			"name": "中站",
			"y": "z"
		}, {
			"id": "410804",
			"pid": "410800",
			"name": "马村",
			"y": "m"
		}, {
			"id": "410811",
			"pid": "410800",
			"name": "山阳",
			"y": "s"
		}, {
			"id": "410821",
			"pid": "410800",
			"name": "修武",
			"y": "x"
		}, {
			"id": "410822",
			"pid": "410800",
			"name": "博爱",
			"y": "b"
		}, {
			"id": "410823",
			"pid": "410800",
			"name": "武陟",
			"y": "w"
		}, {
			"id": "410825",
			"pid": "410800",
			"name": "温县",
			"y": "w"
		}, {
			"id": "410882",
			"pid": "410800",
			"name": "沁阳",
			"y": "q"
		}, {
			"id": "410883",
			"pid": "410800",
			"name": "孟州",
			"y": "m"
		}]
	}, {
		"id": "410900",
		"pid": "410000",
		"name": "濮阳",
		"y": "p",
		"child": [{
			"id": "410902",
			"pid": "410900",
			"name": "华龙",
			"y": "h"
		}, {
			"id": "410922",
			"pid": "410900",
			"name": "清丰",
			"y": "q"
		}, {
			"id": "410923",
			"pid": "410900",
			"name": "南乐",
			"y": "n"
		}, {
			"id": "410926",
			"pid": "410900",
			"name": "范县",
			"y": "f"
		}, {
			"id": "410927",
			"pid": "410900",
			"name": "台前",
			"y": "t"
		}, {
			"id": "410928",
			"pid": "410900",
			"name": "濮阳县",
			"y": "p"
		}]
	}, {
		"id": "411000",
		"pid": "410000",
		"name": "许昌",
		"y": "x",
		"child": [{
			"id": "411002",
			"pid": "411000",
			"name": "魏都",
			"y": "w"
		}, {
			"id": "411003",
			"pid": "411000",
			"name": "建安",
			"y": "j"
		}, {
			"id": "411024",
			"pid": "411000",
			"name": "鄢陵",
			"y": "y"
		}, {
			"id": "411025",
			"pid": "411000",
			"name": "襄城",
			"y": "x"
		}, {
			"id": "411081",
			"pid": "411000",
			"name": "禹州",
			"y": "y"
		}, {
			"id": "411082",
			"pid": "411000",
			"name": "长葛",
			"y": "c"
		}]
	}, {
		"id": "411100",
		"pid": "410000",
		"name": "漯河",
		"y": "l",
		"child": [{
			"id": "411102",
			"pid": "411100",
			"name": "源汇",
			"y": "y"
		}, {
			"id": "411103",
			"pid": "411100",
			"name": "郾城",
			"y": "y"
		}, {
			"id": "411104",
			"pid": "411100",
			"name": "召陵",
			"y": "s"
		}, {
			"id": "411121",
			"pid": "411100",
			"name": "舞阳",
			"y": "w"
		}, {
			"id": "411122",
			"pid": "411100",
			"name": "临颍",
			"y": "l"
		}]
	}, {
		"id": "411200",
		"pid": "410000",
		"name": "三门峡",
		"y": "s",
		"child": [{
			"id": "411202",
			"pid": "411200",
			"name": "湖滨",
			"y": "h"
		}, {
			"id": "411203",
			"pid": "411200",
			"name": "陕州",
			"y": "s"
		}, {
			"id": "411221",
			"pid": "411200",
			"name": "渑池",
			"y": "m"
		}, {
			"id": "411224",
			"pid": "411200",
			"name": "卢氏",
			"y": "l"
		}, {
			"id": "411281",
			"pid": "411200",
			"name": "义马",
			"y": "y"
		}, {
			"id": "411282",
			"pid": "411200",
			"name": "灵宝",
			"y": "l"
		}]
	}, {
		"id": "411300",
		"pid": "410000",
		"name": "南阳",
		"y": "n",
		"child": [{
			"id": "411302",
			"pid": "411300",
			"name": "宛城",
			"y": "w"
		}, {
			"id": "411303",
			"pid": "411300",
			"name": "卧龙",
			"y": "w"
		}, {
			"id": "411321",
			"pid": "411300",
			"name": "南召",
			"y": "n"
		}, {
			"id": "411322",
			"pid": "411300",
			"name": "方城",
			"y": "f"
		}, {
			"id": "411323",
			"pid": "411300",
			"name": "西峡",
			"y": "x"
		}, {
			"id": "411324",
			"pid": "411300",
			"name": "镇平",
			"y": "z"
		}, {
			"id": "411325",
			"pid": "411300",
			"name": "内乡",
			"y": "n"
		}, {
			"id": "411326",
			"pid": "411300",
			"name": "淅川",
			"y": "x"
		}, {
			"id": "411327",
			"pid": "411300",
			"name": "社旗",
			"y": "s"
		}, {
			"id": "411328",
			"pid": "411300",
			"name": "唐河",
			"y": "t"
		}, {
			"id": "411329",
			"pid": "411300",
			"name": "新野",
			"y": "x"
		}, {
			"id": "411330",
			"pid": "411300",
			"name": "桐柏",
			"y": "t"
		}, {
			"id": "411381",
			"pid": "411300",
			"name": "邓州",
			"y": "d"
		}]
	}, {
		"id": "411400",
		"pid": "410000",
		"name": "商丘",
		"y": "s",
		"child": [{
			"id": "411402",
			"pid": "411400",
			"name": "梁园",
			"y": "l"
		}, {
			"id": "411403",
			"pid": "411400",
			"name": "睢阳",
			"y": "s"
		}, {
			"id": "411421",
			"pid": "411400",
			"name": "民权",
			"y": "m"
		}, {
			"id": "411422",
			"pid": "411400",
			"name": "睢县",
			"y": "s"
		}, {
			"id": "411423",
			"pid": "411400",
			"name": "宁陵",
			"y": "n"
		}, {
			"id": "411424",
			"pid": "411400",
			"name": "柘城",
			"y": "z"
		}, {
			"id": "411425",
			"pid": "411400",
			"name": "虞城",
			"y": "y"
		}, {
			"id": "411426",
			"pid": "411400",
			"name": "夏邑",
			"y": "x"
		}, {
			"id": "411481",
			"pid": "411400",
			"name": "永城",
			"y": "y"
		}]
	}, {
		"id": "411500",
		"pid": "410000",
		"name": "信阳",
		"y": "x",
		"child": [{
			"id": "411502",
			"pid": "411500",
			"name": "浉河",
			"y": "s"
		}, {
			"id": "411503",
			"pid": "411500",
			"name": "平桥",
			"y": "p"
		}, {
			"id": "411521",
			"pid": "411500",
			"name": "罗山",
			"y": "l"
		}, {
			"id": "411522",
			"pid": "411500",
			"name": "光山",
			"y": "g"
		}, {
			"id": "411523",
			"pid": "411500",
			"name": "新县",
			"y": "x"
		}, {
			"id": "411524",
			"pid": "411500",
			"name": "商城",
			"y": "s"
		}, {
			"id": "411525",
			"pid": "411500",
			"name": "固始",
			"y": "g"
		}, {
			"id": "411526",
			"pid": "411500",
			"name": "潢川",
			"y": "h"
		}, {
			"id": "411527",
			"pid": "411500",
			"name": "淮滨",
			"y": "h"
		}, {
			"id": "411528",
			"pid": "411500",
			"name": "息县",
			"y": "x"
		}]
	}, {
		"id": "411600",
		"pid": "410000",
		"name": "周口",
		"y": "z",
		"child": [{
			"id": "411602",
			"pid": "411600",
			"name": "川汇",
			"y": "c"
		}, {
			"id": "411603",
			"pid": "411600",
			"name": "淮阳",
			"y": "h"
		}, {
			"id": "411621",
			"pid": "411600",
			"name": "扶沟",
			"y": "f"
		}, {
			"id": "411622",
			"pid": "411600",
			"name": "西华",
			"y": "x"
		}, {
			"id": "411623",
			"pid": "411600",
			"name": "商水",
			"y": "s"
		}, {
			"id": "411624",
			"pid": "411600",
			"name": "沈丘",
			"y": "s"
		}, {
			"id": "411625",
			"pid": "411600",
			"name": "郸城",
			"y": "d"
		}, {
			"id": "411627",
			"pid": "411600",
			"name": "太康",
			"y": "t"
		}, {
			"id": "411628",
			"pid": "411600",
			"name": "鹿邑",
			"y": "l"
		}, {
			"id": "411681",
			"pid": "411600",
			"name": "项城",
			"y": "x"
		}]
	}, {
		"id": "411700",
		"pid": "410000",
		"name": "驻马店",
		"y": "z",
		"child": [{
			"id": "411702",
			"pid": "411700",
			"name": "驿城",
			"y": "y"
		}, {
			"id": "411721",
			"pid": "411700",
			"name": "西平",
			"y": "x"
		}, {
			"id": "411722",
			"pid": "411700",
			"name": "上蔡",
			"y": "s"
		}, {
			"id": "411723",
			"pid": "411700",
			"name": "平舆",
			"y": "p"
		}, {
			"id": "411724",
			"pid": "411700",
			"name": "正阳",
			"y": "z"
		}, {
			"id": "411725",
			"pid": "411700",
			"name": "确山",
			"y": "q"
		}, {
			"id": "411726",
			"pid": "411700",
			"name": "泌阳",
			"y": "b"
		}, {
			"id": "411727",
			"pid": "411700",
			"name": "汝南",
			"y": "r"
		}, {
			"id": "411728",
			"pid": "411700",
			"name": "遂平",
			"y": "s"
		}, {
			"id": "411729",
			"pid": "411700",
			"name": "新蔡",
			"y": "x"
		}]
	}, {
		"id": "41900100",
		"pid": "410000",
		"name": "济源",
		"y": "j",
		"child": []
	}]
}, {
	"id": "420000",
	"pid": "0",
	"name": "湖北",
	"y": "h",
	"child": [{
		"id": "420100",
		"pid": "420000",
		"name": "武汉",
		"y": "w",
		"child": [{
			"id": "420102",
			"pid": "420100",
			"name": "江岸",
			"y": "j"
		}, {
			"id": "420103",
			"pid": "420100",
			"name": "江汉",
			"y": "j"
		}, {
			"id": "420104",
			"pid": "420100",
			"name": "硚口",
			"y": "q"
		}, {
			"id": "420105",
			"pid": "420100",
			"name": "汉阳",
			"y": "h"
		}, {
			"id": "420106",
			"pid": "420100",
			"name": "武昌",
			"y": "w"
		}, {
			"id": "420107",
			"pid": "420100",
			"name": "青山",
			"y": "q"
		}, {
			"id": "420111",
			"pid": "420100",
			"name": "洪山",
			"y": "h"
		}, {
			"id": "420112",
			"pid": "420100",
			"name": "东西湖",
			"y": "d"
		}, {
			"id": "420113",
			"pid": "420100",
			"name": "汉南",
			"y": "h"
		}, {
			"id": "420114",
			"pid": "420100",
			"name": "蔡甸",
			"y": "c"
		}, {
			"id": "420115",
			"pid": "420100",
			"name": "江夏",
			"y": "j"
		}, {
			"id": "420116",
			"pid": "420100",
			"name": "黄陂",
			"y": "h"
		}, {
			"id": "420117",
			"pid": "420100",
			"name": "新洲",
			"y": "x"
		}]
	}, {
		"id": "420200",
		"pid": "420000",
		"name": "黄石",
		"y": "h",
		"child": [{
			"id": "420202",
			"pid": "420200",
			"name": "黄石港",
			"y": "h"
		}, {
			"id": "420203",
			"pid": "420200",
			"name": "西塞山",
			"y": "x"
		}, {
			"id": "420204",
			"pid": "420200",
			"name": "下陆",
			"y": "x"
		}, {
			"id": "420205",
			"pid": "420200",
			"name": "铁山",
			"y": "t"
		}, {
			"id": "420222",
			"pid": "420200",
			"name": "阳新",
			"y": "y"
		}, {
			"id": "420281",
			"pid": "420200",
			"name": "大冶",
			"y": "d"
		}]
	}, {
		"id": "420300",
		"pid": "420000",
		"name": "十堰",
		"y": "s",
		"child": [{
			"id": "420302",
			"pid": "420300",
			"name": "茅箭",
			"y": "m"
		}, {
			"id": "420303",
			"pid": "420300",
			"name": "张湾",
			"y": "z"
		}, {
			"id": "420304",
			"pid": "420300",
			"name": "郧阳",
			"y": "y"
		}, {
			"id": "420322",
			"pid": "420300",
			"name": "郧西",
			"y": "y"
		}, {
			"id": "420323",
			"pid": "420300",
			"name": "竹山",
			"y": "z"
		}, {
			"id": "420324",
			"pid": "420300",
			"name": "竹溪",
			"y": "z"
		}, {
			"id": "420325",
			"pid": "420300",
			"name": "房县",
			"y": "f"
		}, {
			"id": "420381",
			"pid": "420300",
			"name": "丹江口",
			"y": "d"
		}]
	}, {
		"id": "420500",
		"pid": "420000",
		"name": "宜昌",
		"y": "y",
		"child": [{
			"id": "420502",
			"pid": "420500",
			"name": "西陵",
			"y": "x"
		}, {
			"id": "420503",
			"pid": "420500",
			"name": "伍家岗",
			"y": "w"
		}, {
			"id": "420504",
			"pid": "420500",
			"name": "点军",
			"y": "d"
		}, {
			"id": "420505",
			"pid": "420500",
			"name": "猇亭",
			"y": "x"
		}, {
			"id": "420506",
			"pid": "420500",
			"name": "夷陵",
			"y": "y"
		}, {
			"id": "420525",
			"pid": "420500",
			"name": "远安",
			"y": "y"
		}, {
			"id": "420526",
			"pid": "420500",
			"name": "兴山",
			"y": "x"
		}, {
			"id": "420527",
			"pid": "420500",
			"name": "秭归",
			"y": "z"
		}, {
			"id": "420528",
			"pid": "420500",
			"name": "长阳",
			"y": "c"
		}, {
			"id": "420529",
			"pid": "420500",
			"name": "五峰",
			"y": "w"
		}, {
			"id": "420581",
			"pid": "420500",
			"name": "宜都",
			"y": "y"
		}, {
			"id": "420582",
			"pid": "420500",
			"name": "当阳",
			"y": "d"
		}, {
			"id": "420583",
			"pid": "420500",
			"name": "枝江",
			"y": "z"
		}]
	}, {
		"id": "420600",
		"pid": "420000",
		"name": "襄阳",
		"y": "x",
		"child": [{
			"id": "420602",
			"pid": "420600",
			"name": "襄城",
			"y": "x"
		}, {
			"id": "420606",
			"pid": "420600",
			"name": "樊城",
			"y": "f"
		}, {
			"id": "420607",
			"pid": "420600",
			"name": "襄州",
			"y": "x"
		}, {
			"id": "420624",
			"pid": "420600",
			"name": "南漳",
			"y": "n"
		}, {
			"id": "420625",
			"pid": "420600",
			"name": "谷城",
			"y": "g"
		}, {
			"id": "420626",
			"pid": "420600",
			"name": "保康",
			"y": "b"
		}, {
			"id": "420682",
			"pid": "420600",
			"name": "老河口",
			"y": "l"
		}, {
			"id": "420683",
			"pid": "420600",
			"name": "枣阳",
			"y": "z"
		}, {
			"id": "420684",
			"pid": "420600",
			"name": "宜城",
			"y": "y"
		}]
	}, {
		"id": "420700",
		"pid": "420000",
		"name": "鄂州",
		"y": "e",
		"child": [{
			"id": "420702",
			"pid": "420700",
			"name": "梁子湖",
			"y": "l"
		}, {
			"id": "420703",
			"pid": "420700",
			"name": "华容",
			"y": "h"
		}, {
			"id": "420704",
			"pid": "420700",
			"name": "鄂城",
			"y": "e"
		}]
	}, {
		"id": "420800",
		"pid": "420000",
		"name": "荆门",
		"y": "j",
		"child": [{
			"id": "420802",
			"pid": "420800",
			"name": "东宝",
			"y": "d"
		}, {
			"id": "420804",
			"pid": "420800",
			"name": "掇刀",
			"y": "d"
		}, {
			"id": "420822",
			"pid": "420800",
			"name": "沙洋",
			"y": "s"
		}, {
			"id": "420881",
			"pid": "420800",
			"name": "钟祥",
			"y": "z"
		}, {
			"id": "420882",
			"pid": "420800",
			"name": "京山",
			"y": "j"
		}]
	}, {
		"id": "420900",
		"pid": "420000",
		"name": "孝感",
		"y": "x",
		"child": [{
			"id": "420902",
			"pid": "420900",
			"name": "孝南",
			"y": "x"
		}, {
			"id": "420921",
			"pid": "420900",
			"name": "孝昌",
			"y": "x"
		}, {
			"id": "420922",
			"pid": "420900",
			"name": "大悟",
			"y": "d"
		}, {
			"id": "420923",
			"pid": "420900",
			"name": "云梦",
			"y": "y"
		}, {
			"id": "420981",
			"pid": "420900",
			"name": "应城",
			"y": "y"
		}, {
			"id": "420982",
			"pid": "420900",
			"name": "安陆",
			"y": "a"
		}, {
			"id": "420984",
			"pid": "420900",
			"name": "汉川",
			"y": "h"
		}]
	}, {
		"id": "421000",
		"pid": "420000",
		"name": "荆州",
		"y": "j",
		"child": [{
			"id": "421002",
			"pid": "421000",
			"name": "沙市",
			"y": "s"
		}, {
			"id": "421003",
			"pid": "421000",
			"name": "荆州区",
			"y": "j"
		}, {
			"id": "421022",
			"pid": "421000",
			"name": "公安",
			"y": "g"
		}, {
			"id": "421024",
			"pid": "421000",
			"name": "江陵",
			"y": "j"
		}, {
			"id": "421081",
			"pid": "421000",
			"name": "石首",
			"y": "s"
		}, {
			"id": "421083",
			"pid": "421000",
			"name": "洪湖",
			"y": "h"
		}, {
			"id": "421087",
			"pid": "421000",
			"name": "松滋",
			"y": "s"
		}, {
			"id": "421088",
			"pid": "421000",
			"name": "监利",
			"y": "j"
		}]
	}, {
		"id": "421100",
		"pid": "420000",
		"name": "黄冈",
		"y": "h",
		"child": [{
			"id": "421102",
			"pid": "421100",
			"name": "黄州",
			"y": "h"
		}, {
			"id": "421121",
			"pid": "421100",
			"name": "团风",
			"y": "t"
		}, {
			"id": "421122",
			"pid": "421100",
			"name": "红安",
			"y": "h"
		}, {
			"id": "421123",
			"pid": "421100",
			"name": "罗田",
			"y": "l"
		}, {
			"id": "421124",
			"pid": "421100",
			"name": "英山",
			"y": "y"
		}, {
			"id": "421125",
			"pid": "421100",
			"name": "浠水",
			"y": "x"
		}, {
			"id": "421126",
			"pid": "421100",
			"name": "蕲春",
			"y": "q"
		}, {
			"id": "421127",
			"pid": "421100",
			"name": "黄梅",
			"y": "h"
		}, {
			"id": "421181",
			"pid": "421100",
			"name": "麻城",
			"y": "m"
		}, {
			"id": "421182",
			"pid": "421100",
			"name": "武穴",
			"y": "w"
		}]
	}, {
		"id": "421200",
		"pid": "420000",
		"name": "咸宁",
		"y": "x",
		"child": [{
			"id": "421202",
			"pid": "421200",
			"name": "咸安",
			"y": "x"
		}, {
			"id": "421221",
			"pid": "421200",
			"name": "嘉鱼",
			"y": "j"
		}, {
			"id": "421222",
			"pid": "421200",
			"name": "通城",
			"y": "t"
		}, {
			"id": "421223",
			"pid": "421200",
			"name": "崇阳",
			"y": "c"
		}, {
			"id": "421224",
			"pid": "421200",
			"name": "通山",
			"y": "t"
		}, {
			"id": "421281",
			"pid": "421200",
			"name": "赤壁",
			"y": "c"
		}]
	}, {
		"id": "421300",
		"pid": "420000",
		"name": "随州",
		"y": "s",
		"child": [{
			"id": "421303",
			"pid": "421300",
			"name": "曾都",
			"y": "z"
		}, {
			"id": "421321",
			"pid": "421300",
			"name": "随县",
			"y": "s"
		}, {
			"id": "421381",
			"pid": "421300",
			"name": "广水",
			"y": "g"
		}]
	}, {
		"id": "422800",
		"pid": "420000",
		"name": "恩施",
		"y": "e",
		"child": [{
			"id": "422801",
			"pid": "422800",
			"name": "恩施市",
			"y": "e"
		}, {
			"id": "422802",
			"pid": "422800",
			"name": "利川",
			"y": "l"
		}, {
			"id": "422822",
			"pid": "422800",
			"name": "建始",
			"y": "j"
		}, {
			"id": "422823",
			"pid": "422800",
			"name": "巴东",
			"y": "b"
		}, {
			"id": "422825",
			"pid": "422800",
			"name": "宣恩",
			"y": "x"
		}, {
			"id": "422826",
			"pid": "422800",
			"name": "咸丰",
			"y": "x"
		}, {
			"id": "422827",
			"pid": "422800",
			"name": "来凤",
			"y": "l"
		}, {
			"id": "422828",
			"pid": "422800",
			"name": "鹤峰",
			"y": "h"
		}]
	}, {
		"id": "42900400",
		"pid": "420000",
		"name": "仙桃",
		"y": "x",
		"child": []
	}, {
		"id": "42900500",
		"pid": "420000",
		"name": "潜江",
		"y": "q",
		"child": []
	}, {
		"id": "42900600",
		"pid": "420000",
		"name": "天门",
		"y": "t",
		"child": []
	}, {
		"id": "42902100",
		"pid": "420000",
		"name": "神农架",
		"y": "s",
		"child": []
	}]
}, {
	"id": "430000",
	"pid": "0",
	"name": "湖南",
	"y": "h",
	"child": [{
		"id": "430100",
		"pid": "430000",
		"name": "长沙",
		"y": "c",
		"child": [{
			"id": "430102",
			"pid": "430100",
			"name": "芙蓉",
			"y": "f"
		}, {
			"id": "430103",
			"pid": "430100",
			"name": "天心",
			"y": "t"
		}, {
			"id": "430104",
			"pid": "430100",
			"name": "岳麓",
			"y": "y"
		}, {
			"id": "430105",
			"pid": "430100",
			"name": "开福",
			"y": "k"
		}, {
			"id": "430111",
			"pid": "430100",
			"name": "雨花",
			"y": "y"
		}, {
			"id": "430112",
			"pid": "430100",
			"name": "望城",
			"y": "w"
		}, {
			"id": "430121",
			"pid": "430100",
			"name": "长沙县",
			"y": "c"
		}, {
			"id": "430181",
			"pid": "430100",
			"name": "浏阳",
			"y": "l"
		}, {
			"id": "430182",
			"pid": "430100",
			"name": "宁乡",
			"y": "n"
		}]
	}, {
		"id": "430200",
		"pid": "430000",
		"name": "株洲",
		"y": "z",
		"child": [{
			"id": "430202",
			"pid": "430200",
			"name": "荷塘",
			"y": "h"
		}, {
			"id": "430203",
			"pid": "430200",
			"name": "芦淞",
			"y": "l"
		}, {
			"id": "430204",
			"pid": "430200",
			"name": "石峰",
			"y": "s"
		}, {
			"id": "430211",
			"pid": "430200",
			"name": "天元",
			"y": "t"
		}, {
			"id": "430212",
			"pid": "430200",
			"name": "渌口",
			"y": "l"
		}, {
			"id": "430223",
			"pid": "430200",
			"name": "攸县",
			"y": "y"
		}, {
			"id": "430224",
			"pid": "430200",
			"name": "茶陵",
			"y": "c"
		}, {
			"id": "430225",
			"pid": "430200",
			"name": "炎陵",
			"y": "y"
		}, {
			"id": "430281",
			"pid": "430200",
			"name": "醴陵",
			"y": "l"
		}]
	}, {
		"id": "430300",
		"pid": "430000",
		"name": "湘潭",
		"y": "x",
		"child": [{
			"id": "430302",
			"pid": "430300",
			"name": "雨湖",
			"y": "y"
		}, {
			"id": "430304",
			"pid": "430300",
			"name": "岳塘",
			"y": "y"
		}, {
			"id": "430321",
			"pid": "430300",
			"name": "湘潭县",
			"y": "x"
		}, {
			"id": "430381",
			"pid": "430300",
			"name": "湘乡",
			"y": "x"
		}, {
			"id": "430382",
			"pid": "430300",
			"name": "韶山",
			"y": "s"
		}]
	}, {
		"id": "430400",
		"pid": "430000",
		"name": "衡阳",
		"y": "h",
		"child": [{
			"id": "430405",
			"pid": "430400",
			"name": "珠晖",
			"y": "z"
		}, {
			"id": "430406",
			"pid": "430400",
			"name": "雁峰",
			"y": "y"
		}, {
			"id": "430407",
			"pid": "430400",
			"name": "石鼓",
			"y": "s"
		}, {
			"id": "430408",
			"pid": "430400",
			"name": "蒸湘",
			"y": "z"
		}, {
			"id": "430412",
			"pid": "430400",
			"name": "南岳",
			"y": "n"
		}, {
			"id": "430421",
			"pid": "430400",
			"name": "衡阳县",
			"y": "h"
		}, {
			"id": "430422",
			"pid": "430400",
			"name": "衡南",
			"y": "h"
		}, {
			"id": "430423",
			"pid": "430400",
			"name": "衡山",
			"y": "h"
		}, {
			"id": "430424",
			"pid": "430400",
			"name": "衡东",
			"y": "h"
		}, {
			"id": "430426",
			"pid": "430400",
			"name": "祁东",
			"y": "q"
		}, {
			"id": "430481",
			"pid": "430400",
			"name": "耒阳",
			"y": "l"
		}, {
			"id": "430482",
			"pid": "430400",
			"name": "常宁",
			"y": "c"
		}]
	}, {
		"id": "430500",
		"pid": "430000",
		"name": "邵阳",
		"y": "s",
		"child": [{
			"id": "430502",
			"pid": "430500",
			"name": "双清",
			"y": "s"
		}, {
			"id": "430503",
			"pid": "430500",
			"name": "大祥",
			"y": "d"
		}, {
			"id": "430511",
			"pid": "430500",
			"name": "北塔",
			"y": "b"
		}, {
			"id": "430522",
			"pid": "430500",
			"name": "新邵",
			"y": "x"
		}, {
			"id": "430523",
			"pid": "430500",
			"name": "邵阳县",
			"y": "s"
		}, {
			"id": "430524",
			"pid": "430500",
			"name": "隆回",
			"y": "l"
		}, {
			"id": "430525",
			"pid": "430500",
			"name": "洞口",
			"y": "d"
		}, {
			"id": "430527",
			"pid": "430500",
			"name": "绥宁",
			"y": "s"
		}, {
			"id": "430528",
			"pid": "430500",
			"name": "新宁",
			"y": "x"
		}, {
			"id": "430529",
			"pid": "430500",
			"name": "城步",
			"y": "c"
		}, {
			"id": "430581",
			"pid": "430500",
			"name": "武冈",
			"y": "w"
		}, {
			"id": "430582",
			"pid": "430500",
			"name": "邵东",
			"y": "s"
		}]
	}, {
		"id": "430600",
		"pid": "430000",
		"name": "岳阳",
		"y": "y",
		"child": [{
			"id": "430602",
			"pid": "430600",
			"name": "岳阳楼",
			"y": "y"
		}, {
			"id": "430603",
			"pid": "430600",
			"name": "云溪",
			"y": "y"
		}, {
			"id": "430611",
			"pid": "430600",
			"name": "君山",
			"y": "j"
		}, {
			"id": "430621",
			"pid": "430600",
			"name": "岳阳县",
			"y": "y"
		}, {
			"id": "430623",
			"pid": "430600",
			"name": "华容",
			"y": "h"
		}, {
			"id": "430624",
			"pid": "430600",
			"name": "湘阴",
			"y": "x"
		}, {
			"id": "430626",
			"pid": "430600",
			"name": "平江",
			"y": "p"
		}, {
			"id": "430681",
			"pid": "430600",
			"name": "汨罗",
			"y": "m"
		}, {
			"id": "430682",
			"pid": "430600",
			"name": "临湘",
			"y": "l"
		}]
	}, {
		"id": "430700",
		"pid": "430000",
		"name": "常德",
		"y": "c",
		"child": [{
			"id": "430702",
			"pid": "430700",
			"name": "武陵",
			"y": "w"
		}, {
			"id": "430703",
			"pid": "430700",
			"name": "鼎城",
			"y": "d"
		}, {
			"id": "430721",
			"pid": "430700",
			"name": "安乡",
			"y": "a"
		}, {
			"id": "430722",
			"pid": "430700",
			"name": "汉寿",
			"y": "h"
		}, {
			"id": "430723",
			"pid": "430700",
			"name": "澧县",
			"y": "l"
		}, {
			"id": "430724",
			"pid": "430700",
			"name": "临澧",
			"y": "l"
		}, {
			"id": "430725",
			"pid": "430700",
			"name": "桃源",
			"y": "t"
		}, {
			"id": "430726",
			"pid": "430700",
			"name": "石门",
			"y": "s"
		}, {
			"id": "430781",
			"pid": "430700",
			"name": "津市",
			"y": "j"
		}]
	}, {
		"id": "430800",
		"pid": "430000",
		"name": "张家界",
		"y": "z",
		"child": [{
			"id": "430802",
			"pid": "430800",
			"name": "永定",
			"y": "y"
		}, {
			"id": "430811",
			"pid": "430800",
			"name": "武陵源",
			"y": "w"
		}, {
			"id": "430821",
			"pid": "430800",
			"name": "慈利",
			"y": "c"
		}, {
			"id": "430822",
			"pid": "430800",
			"name": "桑植",
			"y": "s"
		}]
	}, {
		"id": "430900",
		"pid": "430000",
		"name": "益阳",
		"y": "y",
		"child": [{
			"id": "430902",
			"pid": "430900",
			"name": "资阳",
			"y": "z"
		}, {
			"id": "430903",
			"pid": "430900",
			"name": "赫山",
			"y": "h"
		}, {
			"id": "430921",
			"pid": "430900",
			"name": "南县",
			"y": "n"
		}, {
			"id": "430922",
			"pid": "430900",
			"name": "桃江",
			"y": "t"
		}, {
			"id": "430923",
			"pid": "430900",
			"name": "安化",
			"y": "a"
		}, {
			"id": "430981",
			"pid": "430900",
			"name": "沅江",
			"y": "y"
		}]
	}, {
		"id": "431000",
		"pid": "430000",
		"name": "郴州",
		"y": "c",
		"child": [{
			"id": "431002",
			"pid": "431000",
			"name": "北湖",
			"y": "b"
		}, {
			"id": "431003",
			"pid": "431000",
			"name": "苏仙",
			"y": "s"
		}, {
			"id": "431021",
			"pid": "431000",
			"name": "桂阳",
			"y": "g"
		}, {
			"id": "431022",
			"pid": "431000",
			"name": "宜章",
			"y": "y"
		}, {
			"id": "431023",
			"pid": "431000",
			"name": "永兴",
			"y": "y"
		}, {
			"id": "431024",
			"pid": "431000",
			"name": "嘉禾",
			"y": "j"
		}, {
			"id": "431025",
			"pid": "431000",
			"name": "临武",
			"y": "l"
		}, {
			"id": "431026",
			"pid": "431000",
			"name": "汝城",
			"y": "r"
		}, {
			"id": "431027",
			"pid": "431000",
			"name": "桂东",
			"y": "g"
		}, {
			"id": "431028",
			"pid": "431000",
			"name": "安仁",
			"y": "a"
		}, {
			"id": "431081",
			"pid": "431000",
			"name": "资兴",
			"y": "z"
		}]
	}, {
		"id": "431100",
		"pid": "430000",
		"name": "永州",
		"y": "y",
		"child": [{
			"id": "431102",
			"pid": "431100",
			"name": "零陵",
			"y": "l"
		}, {
			"id": "431103",
			"pid": "431100",
			"name": "冷水滩",
			"y": "l"
		}, {
			"id": "431121",
			"pid": "431100",
			"name": "祁阳",
			"y": "q"
		}, {
			"id": "431122",
			"pid": "431100",
			"name": "东安",
			"y": "d"
		}, {
			"id": "431123",
			"pid": "431100",
			"name": "双牌",
			"y": "s"
		}, {
			"id": "431124",
			"pid": "431100",
			"name": "道县",
			"y": "d"
		}, {
			"id": "431125",
			"pid": "431100",
			"name": "江永",
			"y": "j"
		}, {
			"id": "431126",
			"pid": "431100",
			"name": "宁远",
			"y": "n"
		}, {
			"id": "431127",
			"pid": "431100",
			"name": "蓝山",
			"y": "l"
		}, {
			"id": "431128",
			"pid": "431100",
			"name": "新田",
			"y": "x"
		}, {
			"id": "431129",
			"pid": "431100",
			"name": "江华",
			"y": "j"
		}]
	}, {
		"id": "431200",
		"pid": "430000",
		"name": "怀化",
		"y": "h",
		"child": [{
			"id": "431202",
			"pid": "431200",
			"name": "鹤城",
			"y": "h"
		}, {
			"id": "431221",
			"pid": "431200",
			"name": "中方",
			"y": "z"
		}, {
			"id": "431222",
			"pid": "431200",
			"name": "沅陵",
			"y": "y"
		}, {
			"id": "431223",
			"pid": "431200",
			"name": "辰溪",
			"y": "c"
		}, {
			"id": "431224",
			"pid": "431200",
			"name": "溆浦",
			"y": "x"
		}, {
			"id": "431225",
			"pid": "431200",
			"name": "会同",
			"y": "h"
		}, {
			"id": "431226",
			"pid": "431200",
			"name": "麻阳",
			"y": "m"
		}, {
			"id": "431227",
			"pid": "431200",
			"name": "新晃",
			"y": "x"
		}, {
			"id": "431228",
			"pid": "431200",
			"name": "芷江",
			"y": "z"
		}, {
			"id": "431229",
			"pid": "431200",
			"name": "靖州",
			"y": "j"
		}, {
			"id": "431230",
			"pid": "431200",
			"name": "通道",
			"y": "t"
		}, {
			"id": "431281",
			"pid": "431200",
			"name": "洪江",
			"y": "h"
		}]
	}, {
		"id": "431300",
		"pid": "430000",
		"name": "娄底",
		"y": "l",
		"child": [{
			"id": "431302",
			"pid": "431300",
			"name": "娄星",
			"y": "l"
		}, {
			"id": "431321",
			"pid": "431300",
			"name": "双峰",
			"y": "s"
		}, {
			"id": "431322",
			"pid": "431300",
			"name": "新化",
			"y": "x"
		}, {
			"id": "431381",
			"pid": "431300",
			"name": "冷水江",
			"y": "l"
		}, {
			"id": "431382",
			"pid": "431300",
			"name": "涟源",
			"y": "l"
		}]
	}, {
		"id": "433100",
		"pid": "430000",
		"name": "湘西",
		"y": "x",
		"child": [{
			"id": "433101",
			"pid": "433100",
			"name": "吉首",
			"y": "j"
		}, {
			"id": "433122",
			"pid": "433100",
			"name": "泸溪",
			"y": "l"
		}, {
			"id": "433123",
			"pid": "433100",
			"name": "凤凰",
			"y": "f"
		}, {
			"id": "433124",
			"pid": "433100",
			"name": "花垣",
			"y": "h"
		}, {
			"id": "433125",
			"pid": "433100",
			"name": "保靖",
			"y": "b"
		}, {
			"id": "433126",
			"pid": "433100",
			"name": "古丈",
			"y": "g"
		}, {
			"id": "433127",
			"pid": "433100",
			"name": "永顺",
			"y": "y"
		}, {
			"id": "433130",
			"pid": "433100",
			"name": "龙山",
			"y": "l"
		}]
	}]
}, {
	"id": "440000",
	"pid": "0",
	"name": "广东",
	"y": "g",
	"child": [{
		"id": "440100",
		"pid": "440000",
		"name": "广州",
		"y": "g",
		"child": [{
			"id": "440103",
			"pid": "440100",
			"name": "荔湾",
			"y": "l"
		}, {
			"id": "440104",
			"pid": "440100",
			"name": "越秀",
			"y": "y"
		}, {
			"id": "440105",
			"pid": "440100",
			"name": "海珠",
			"y": "h"
		}, {
			"id": "440106",
			"pid": "440100",
			"name": "天河",
			"y": "t"
		}, {
			"id": "440111",
			"pid": "440100",
			"name": "白云",
			"y": "b"
		}, {
			"id": "440112",
			"pid": "440100",
			"name": "黄埔",
			"y": "h"
		}, {
			"id": "440113",
			"pid": "440100",
			"name": "番禺",
			"y": "p"
		}, {
			"id": "440114",
			"pid": "440100",
			"name": "花都",
			"y": "h"
		}, {
			"id": "440115",
			"pid": "440100",
			"name": "南沙",
			"y": "n"
		}, {
			"id": "440117",
			"pid": "440100",
			"name": "从化",
			"y": "c"
		}, {
			"id": "440118",
			"pid": "440100",
			"name": "增城",
			"y": "z"
		}]
	}, {
		"id": "440200",
		"pid": "440000",
		"name": "韶关",
		"y": "s",
		"child": [{
			"id": "440203",
			"pid": "440200",
			"name": "武江",
			"y": "w"
		}, {
			"id": "440204",
			"pid": "440200",
			"name": "浈江",
			"y": "z"
		}, {
			"id": "440205",
			"pid": "440200",
			"name": "曲江",
			"y": "q"
		}, {
			"id": "440222",
			"pid": "440200",
			"name": "始兴",
			"y": "s"
		}, {
			"id": "440224",
			"pid": "440200",
			"name": "仁化",
			"y": "r"
		}, {
			"id": "440229",
			"pid": "440200",
			"name": "翁源",
			"y": "w"
		}, {
			"id": "440232",
			"pid": "440200",
			"name": "乳源",
			"y": "r"
		}, {
			"id": "440233",
			"pid": "440200",
			"name": "新丰",
			"y": "x"
		}, {
			"id": "440281",
			"pid": "440200",
			"name": "乐昌",
			"y": "l"
		}, {
			"id": "440282",
			"pid": "440200",
			"name": "南雄",
			"y": "n"
		}]
	}, {
		"id": "440300",
		"pid": "440000",
		"name": "深圳",
		"y": "s",
		"child": [{
			"id": "440303",
			"pid": "440300",
			"name": "罗湖",
			"y": "l"
		}, {
			"id": "440304",
			"pid": "440300",
			"name": "福田",
			"y": "f"
		}, {
			"id": "440305",
			"pid": "440300",
			"name": "南山",
			"y": "n"
		}, {
			"id": "440306",
			"pid": "440300",
			"name": "宝安",
			"y": "b"
		}, {
			"id": "440307",
			"pid": "440300",
			"name": "龙岗",
			"y": "l"
		}, {
			"id": "440308",
			"pid": "440300",
			"name": "盐田",
			"y": "y"
		}, {
			"id": "440309",
			"pid": "440300",
			"name": "龙华",
			"y": "l"
		}, {
			"id": "440310",
			"pid": "440300",
			"name": "坪山",
			"y": "p"
		}, {
			"id": "440311",
			"pid": "440300",
			"name": "光明",
			"y": "g"
		}]
	}, {
		"id": "440400",
		"pid": "440000",
		"name": "珠海",
		"y": "z",
		"child": [{
			"id": "440402",
			"pid": "440400",
			"name": "香洲",
			"y": "x"
		}, {
			"id": "440403",
			"pid": "440400",
			"name": "斗门",
			"y": "d"
		}, {
			"id": "440404",
			"pid": "440400",
			"name": "金湾",
			"y": "j"
		}]
	}, {
		"id": "440500",
		"pid": "440000",
		"name": "汕头",
		"y": "s",
		"child": [{
			"id": "440507",
			"pid": "440500",
			"name": "龙湖",
			"y": "l"
		}, {
			"id": "440511",
			"pid": "440500",
			"name": "金平",
			"y": "j"
		}, {
			"id": "440512",
			"pid": "440500",
			"name": "濠江",
			"y": "h"
		}, {
			"id": "440513",
			"pid": "440500",
			"name": "潮阳",
			"y": "c"
		}, {
			"id": "440514",
			"pid": "440500",
			"name": "潮南",
			"y": "c"
		}, {
			"id": "440515",
			"pid": "440500",
			"name": "澄海",
			"y": "c"
		}, {
			"id": "440523",
			"pid": "440500",
			"name": "南澳",
			"y": "n"
		}]
	}, {
		"id": "440600",
		"pid": "440000",
		"name": "佛山",
		"y": "f",
		"child": [{
			"id": "440604",
			"pid": "440600",
			"name": "禅城",
			"y": "c"
		}, {
			"id": "440605",
			"pid": "440600",
			"name": "南海",
			"y": "n"
		}, {
			"id": "440606",
			"pid": "440600",
			"name": "顺德",
			"y": "s"
		}, {
			"id": "440607",
			"pid": "440600",
			"name": "三水",
			"y": "s"
		}, {
			"id": "440608",
			"pid": "440600",
			"name": "高明",
			"y": "g"
		}]
	}, {
		"id": "440700",
		"pid": "440000",
		"name": "江门",
		"y": "j",
		"child": [{
			"id": "440703",
			"pid": "440700",
			"name": "蓬江",
			"y": "p"
		}, {
			"id": "440704",
			"pid": "440700",
			"name": "江海",
			"y": "j"
		}, {
			"id": "440705",
			"pid": "440700",
			"name": "新会",
			"y": "x"
		}, {
			"id": "440781",
			"pid": "440700",
			"name": "台山",
			"y": "t"
		}, {
			"id": "440783",
			"pid": "440700",
			"name": "开平",
			"y": "k"
		}, {
			"id": "440784",
			"pid": "440700",
			"name": "鹤山",
			"y": "h"
		}, {
			"id": "440785",
			"pid": "440700",
			"name": "恩平",
			"y": "e"
		}]
	}, {
		"id": "440800",
		"pid": "440000",
		"name": "湛江",
		"y": "z",
		"child": [{
			"id": "440802",
			"pid": "440800",
			"name": "赤坎",
			"y": "c"
		}, {
			"id": "440803",
			"pid": "440800",
			"name": "霞山",
			"y": "x"
		}, {
			"id": "440804",
			"pid": "440800",
			"name": "坡头",
			"y": "p"
		}, {
			"id": "440811",
			"pid": "440800",
			"name": "麻章",
			"y": "m"
		}, {
			"id": "440823",
			"pid": "440800",
			"name": "遂溪",
			"y": "s"
		}, {
			"id": "440825",
			"pid": "440800",
			"name": "徐闻",
			"y": "x"
		}, {
			"id": "440881",
			"pid": "440800",
			"name": "廉江",
			"y": "l"
		}, {
			"id": "440882",
			"pid": "440800",
			"name": "雷州",
			"y": "l"
		}, {
			"id": "440883",
			"pid": "440800",
			"name": "吴川",
			"y": "w"
		}]
	}, {
		"id": "440900",
		"pid": "440000",
		"name": "茂名",
		"y": "m",
		"child": [{
			"id": "440902",
			"pid": "440900",
			"name": "茂南",
			"y": "m"
		}, {
			"id": "440904",
			"pid": "440900",
			"name": "电白",
			"y": "d"
		}, {
			"id": "440981",
			"pid": "440900",
			"name": "高州",
			"y": "g"
		}, {
			"id": "440982",
			"pid": "440900",
			"name": "化州",
			"y": "h"
		}, {
			"id": "440983",
			"pid": "440900",
			"name": "信宜",
			"y": "x"
		}]
	}, {
		"id": "441200",
		"pid": "440000",
		"name": "肇庆",
		"y": "z",
		"child": [{
			"id": "441202",
			"pid": "441200",
			"name": "端州",
			"y": "d"
		}, {
			"id": "441203",
			"pid": "441200",
			"name": "鼎湖",
			"y": "d"
		}, {
			"id": "441204",
			"pid": "441200",
			"name": "高要",
			"y": "g"
		}, {
			"id": "441223",
			"pid": "441200",
			"name": "广宁",
			"y": "g"
		}, {
			"id": "441224",
			"pid": "441200",
			"name": "怀集",
			"y": "h"
		}, {
			"id": "441225",
			"pid": "441200",
			"name": "封开",
			"y": "f"
		}, {
			"id": "441226",
			"pid": "441200",
			"name": "德庆",
			"y": "d"
		}, {
			"id": "441284",
			"pid": "441200",
			"name": "四会",
			"y": "s"
		}]
	}, {
		"id": "441300",
		"pid": "440000",
		"name": "惠州",
		"y": "h",
		"child": [{
			"id": "441302",
			"pid": "441300",
			"name": "惠城",
			"y": "h"
		}, {
			"id": "441303",
			"pid": "441300",
			"name": "惠阳",
			"y": "h"
		}, {
			"id": "441322",
			"pid": "441300",
			"name": "博罗",
			"y": "b"
		}, {
			"id": "441323",
			"pid": "441300",
			"name": "惠东",
			"y": "h"
		}, {
			"id": "441324",
			"pid": "441300",
			"name": "龙门",
			"y": "l"
		}]
	}, {
		"id": "441400",
		"pid": "440000",
		"name": "梅州",
		"y": "m",
		"child": [{
			"id": "441402",
			"pid": "441400",
			"name": "梅江",
			"y": "m"
		}, {
			"id": "441403",
			"pid": "441400",
			"name": "梅县",
			"y": "m"
		}, {
			"id": "441422",
			"pid": "441400",
			"name": "大埔",
			"y": "d"
		}, {
			"id": "441423",
			"pid": "441400",
			"name": "丰顺",
			"y": "f"
		}, {
			"id": "441424",
			"pid": "441400",
			"name": "五华",
			"y": "w"
		}, {
			"id": "441426",
			"pid": "441400",
			"name": "平远",
			"y": "p"
		}, {
			"id": "441427",
			"pid": "441400",
			"name": "蕉岭",
			"y": "j"
		}, {
			"id": "441481",
			"pid": "441400",
			"name": "兴宁",
			"y": "x"
		}]
	}, {
		"id": "441500",
		"pid": "440000",
		"name": "汕尾",
		"y": "s",
		"child": [{
			"id": "441502",
			"pid": "441500",
			"name": "城区",
			"y": "c"
		}, {
			"id": "441521",
			"pid": "441500",
			"name": "海丰",
			"y": "h"
		}, {
			"id": "441523",
			"pid": "441500",
			"name": "陆河",
			"y": "l"
		}, {
			"id": "441581",
			"pid": "441500",
			"name": "陆丰",
			"y": "l"
		}]
	}, {
		"id": "441600",
		"pid": "440000",
		"name": "河源",
		"y": "h",
		"child": [{
			"id": "441602",
			"pid": "441600",
			"name": "源城",
			"y": "y"
		}, {
			"id": "441621",
			"pid": "441600",
			"name": "紫金",
			"y": "z"
		}, {
			"id": "441622",
			"pid": "441600",
			"name": "龙川",
			"y": "l"
		}, {
			"id": "441623",
			"pid": "441600",
			"name": "连平",
			"y": "l"
		}, {
			"id": "441624",
			"pid": "441600",
			"name": "和平",
			"y": "h"
		}, {
			"id": "441625",
			"pid": "441600",
			"name": "东源",
			"y": "d"
		}]
	}, {
		"id": "441700",
		"pid": "440000",
		"name": "阳江",
		"y": "y",
		"child": [{
			"id": "441702",
			"pid": "441700",
			"name": "江城",
			"y": "j"
		}, {
			"id": "441704",
			"pid": "441700",
			"name": "阳东",
			"y": "y"
		}, {
			"id": "441721",
			"pid": "441700",
			"name": "阳西",
			"y": "y"
		}, {
			"id": "441781",
			"pid": "441700",
			"name": "阳春",
			"y": "y"
		}]
	}, {
		"id": "441800",
		"pid": "440000",
		"name": "清远",
		"y": "q",
		"child": [{
			"id": "441802",
			"pid": "441800",
			"name": "清城",
			"y": "q"
		}, {
			"id": "441803",
			"pid": "441800",
			"name": "清新区",
			"y": "q"
		}, {
			"id": "441821",
			"pid": "441800",
			"name": "佛冈",
			"y": "f"
		}, {
			"id": "441823",
			"pid": "441800",
			"name": "阳山",
			"y": "y"
		}, {
			"id": "441825",
			"pid": "441800",
			"name": "连山",
			"y": "l"
		}, {
			"id": "441826",
			"pid": "441800",
			"name": "连南",
			"y": "l"
		}, {
			"id": "441881",
			"pid": "441800",
			"name": "英德",
			"y": "y"
		}, {
			"id": "441882",
			"pid": "441800",
			"name": "连州",
			"y": "l"
		}]
	}, {
		"id": "441900",
		"pid": "440000",
		"name": "东莞",
		"y": "d",
		"child": [{
			"id": "441900",
			"pid": "441900",
			"name": "东莞",
			"y": "d"
		}]
	}, {
		"id": "442000",
		"pid": "440000",
		"name": "中山",
		"y": "z",
		"child": [{
			"id": "442000",
			"pid": "442000",
			"name": "中山",
			"y": "z"
		}]
	}, {
		"id": "445100",
		"pid": "440000",
		"name": "潮州",
		"y": "c",
		"child": [{
			"id": "445102",
			"pid": "445100",
			"name": "湘桥",
			"y": "x"
		}, {
			"id": "445103",
			"pid": "445100",
			"name": "潮安",
			"y": "c"
		}, {
			"id": "445122",
			"pid": "445100",
			"name": "饶平",
			"y": "r"
		}]
	}, {
		"id": "445200",
		"pid": "440000",
		"name": "揭阳",
		"y": "j",
		"child": [{
			"id": "445202",
			"pid": "445200",
			"name": "榕城",
			"y": "r"
		}, {
			"id": "445203",
			"pid": "445200",
			"name": "揭东",
			"y": "j"
		}, {
			"id": "445222",
			"pid": "445200",
			"name": "揭西",
			"y": "j"
		}, {
			"id": "445224",
			"pid": "445200",
			"name": "惠来",
			"y": "h"
		}, {
			"id": "445281",
			"pid": "445200",
			"name": "普宁",
			"y": "p"
		}]
	}, {
		"id": "445300",
		"pid": "440000",
		"name": "云浮",
		"y": "y",
		"child": [{
			"id": "445302",
			"pid": "445300",
			"name": "云城",
			"y": "y"
		}, {
			"id": "445303",
			"pid": "445300",
			"name": "云安",
			"y": "y"
		}, {
			"id": "445321",
			"pid": "445300",
			"name": "新兴",
			"y": "x"
		}, {
			"id": "445322",
			"pid": "445300",
			"name": "郁南",
			"y": "y"
		}, {
			"id": "445381",
			"pid": "445300",
			"name": "罗定",
			"y": "l"
		}]
	}]
}, {
	"id": "450000",
	"pid": "0",
	"name": "广西",
	"y": "g",
	"child": [{
		"id": "450100",
		"pid": "450000",
		"name": "南宁",
		"y": "n",
		"child": [{
			"id": "450102",
			"pid": "450100",
			"name": "兴宁",
			"y": "x"
		}, {
			"id": "450103",
			"pid": "450100",
			"name": "青秀",
			"y": "q"
		}, {
			"id": "450105",
			"pid": "450100",
			"name": "江南",
			"y": "j"
		}, {
			"id": "450107",
			"pid": "450100",
			"name": "西乡塘",
			"y": "x"
		}, {
			"id": "450108",
			"pid": "450100",
			"name": "良庆",
			"y": "l"
		}, {
			"id": "450109",
			"pid": "450100",
			"name": "邕宁",
			"y": "y"
		}, {
			"id": "450110",
			"pid": "450100",
			"name": "武鸣",
			"y": "w"
		}, {
			"id": "450123",
			"pid": "450100",
			"name": "隆安",
			"y": "l"
		}, {
			"id": "450124",
			"pid": "450100",
			"name": "马山",
			"y": "m"
		}, {
			"id": "450125",
			"pid": "450100",
			"name": "上林",
			"y": "s"
		}, {
			"id": "450126",
			"pid": "450100",
			"name": "宾阳",
			"y": "b"
		}, {
			"id": "450127",
			"pid": "450100",
			"name": "横县",
			"y": "h"
		}]
	}, {
		"id": "450200",
		"pid": "450000",
		"name": "柳州",
		"y": "l",
		"child": [{
			"id": "450202",
			"pid": "450200",
			"name": "城中",
			"y": "c"
		}, {
			"id": "450203",
			"pid": "450200",
			"name": "鱼峰",
			"y": "y"
		}, {
			"id": "450204",
			"pid": "450200",
			"name": "柳南",
			"y": "l"
		}, {
			"id": "450205",
			"pid": "450200",
			"name": "柳北",
			"y": "l"
		}, {
			"id": "450206",
			"pid": "450200",
			"name": "柳江",
			"y": "l"
		}, {
			"id": "450222",
			"pid": "450200",
			"name": "柳城",
			"y": "l"
		}, {
			"id": "450223",
			"pid": "450200",
			"name": "鹿寨",
			"y": "l"
		}, {
			"id": "450224",
			"pid": "450200",
			"name": "融安",
			"y": "r"
		}, {
			"id": "450225",
			"pid": "450200",
			"name": "融水",
			"y": "r"
		}, {
			"id": "450226",
			"pid": "450200",
			"name": "三江",
			"y": "s"
		}]
	}, {
		"id": "450300",
		"pid": "450000",
		"name": "桂林",
		"y": "g",
		"child": [{
			"id": "450302",
			"pid": "450300",
			"name": "秀峰",
			"y": "x"
		}, {
			"id": "450303",
			"pid": "450300",
			"name": "叠彩",
			"y": "d"
		}, {
			"id": "450304",
			"pid": "450300",
			"name": "象山",
			"y": "x"
		}, {
			"id": "450305",
			"pid": "450300",
			"name": "七星",
			"y": "q"
		}, {
			"id": "450311",
			"pid": "450300",
			"name": "雁山",
			"y": "y"
		}, {
			"id": "450312",
			"pid": "450300",
			"name": "临桂",
			"y": "l"
		}, {
			"id": "450321",
			"pid": "450300",
			"name": "阳朔",
			"y": "y"
		}, {
			"id": "450323",
			"pid": "450300",
			"name": "灵川",
			"y": "l"
		}, {
			"id": "450324",
			"pid": "450300",
			"name": "全州",
			"y": "q"
		}, {
			"id": "450325",
			"pid": "450300",
			"name": "兴安",
			"y": "x"
		}, {
			"id": "450326",
			"pid": "450300",
			"name": "永福",
			"y": "y"
		}, {
			"id": "450327",
			"pid": "450300",
			"name": "灌阳",
			"y": "g"
		}, {
			"id": "450328",
			"pid": "450300",
			"name": "龙胜",
			"y": "l"
		}, {
			"id": "450329",
			"pid": "450300",
			"name": "资源",
			"y": "z"
		}, {
			"id": "450330",
			"pid": "450300",
			"name": "平乐",
			"y": "p"
		}, {
			"id": "450332",
			"pid": "450300",
			"name": "恭城",
			"y": "g"
		}, {
			"id": "450381",
			"pid": "450300",
			"name": "荔浦",
			"y": "l"
		}]
	}, {
		"id": "450400",
		"pid": "450000",
		"name": "梧州",
		"y": "w",
		"child": [{
			"id": "450403",
			"pid": "450400",
			"name": "万秀",
			"y": "w"
		}, {
			"id": "450405",
			"pid": "450400",
			"name": "长洲",
			"y": "c"
		}, {
			"id": "450406",
			"pid": "450400",
			"name": "龙圩",
			"y": "l"
		}, {
			"id": "450421",
			"pid": "450400",
			"name": "苍梧",
			"y": "c"
		}, {
			"id": "450422",
			"pid": "450400",
			"name": "藤县",
			"y": "t"
		}, {
			"id": "450423",
			"pid": "450400",
			"name": "蒙山",
			"y": "m"
		}, {
			"id": "450481",
			"pid": "450400",
			"name": "岑溪",
			"y": "c"
		}]
	}, {
		"id": "450500",
		"pid": "450000",
		"name": "北海",
		"y": "b",
		"child": [{
			"id": "450502",
			"pid": "450500",
			"name": "海城",
			"y": "h"
		}, {
			"id": "450503",
			"pid": "450500",
			"name": "银海",
			"y": "y"
		}, {
			"id": "450512",
			"pid": "450500",
			"name": "铁山港",
			"y": "t"
		}, {
			"id": "450521",
			"pid": "450500",
			"name": "合浦",
			"y": "h"
		}]
	}, {
		"id": "450600",
		"pid": "450000",
		"name": "防城港",
		"y": "f",
		"child": [{
			"id": "450602",
			"pid": "450600",
			"name": "港口",
			"y": "g"
		}, {
			"id": "450603",
			"pid": "450600",
			"name": "防城",
			"y": "f"
		}, {
			"id": "450621",
			"pid": "450600",
			"name": "上思",
			"y": "s"
		}, {
			"id": "450681",
			"pid": "450600",
			"name": "东兴",
			"y": "d"
		}]
	}, {
		"id": "450700",
		"pid": "450000",
		"name": "钦州",
		"y": "q",
		"child": [{
			"id": "450702",
			"pid": "450700",
			"name": "钦南",
			"y": "q"
		}, {
			"id": "450703",
			"pid": "450700",
			"name": "钦北",
			"y": "q"
		}, {
			"id": "450721",
			"pid": "450700",
			"name": "灵山",
			"y": "l"
		}, {
			"id": "450722",
			"pid": "450700",
			"name": "浦北",
			"y": "p"
		}]
	}, {
		"id": "450800",
		"pid": "450000",
		"name": "贵港",
		"y": "g",
		"child": [{
			"id": "450802",
			"pid": "450800",
			"name": "港北",
			"y": "g"
		}, {
			"id": "450803",
			"pid": "450800",
			"name": "港南",
			"y": "g"
		}, {
			"id": "450804",
			"pid": "450800",
			"name": "覃塘",
			"y": "q"
		}, {
			"id": "450821",
			"pid": "450800",
			"name": "平南",
			"y": "p"
		}, {
			"id": "450881",
			"pid": "450800",
			"name": "桂平",
			"y": "g"
		}]
	}, {
		"id": "450900",
		"pid": "450000",
		"name": "玉林",
		"y": "y",
		"child": [{
			"id": "450902",
			"pid": "450900",
			"name": "玉州",
			"y": "y"
		}, {
			"id": "450903",
			"pid": "450900",
			"name": "福绵",
			"y": "f"
		}, {
			"id": "450921",
			"pid": "450900",
			"name": "容县",
			"y": "r"
		}, {
			"id": "450922",
			"pid": "450900",
			"name": "陆川",
			"y": "l"
		}, {
			"id": "450923",
			"pid": "450900",
			"name": "博白",
			"y": "b"
		}, {
			"id": "450924",
			"pid": "450900",
			"name": "兴业",
			"y": "x"
		}, {
			"id": "450981",
			"pid": "450900",
			"name": "北流",
			"y": "b"
		}]
	}, {
		"id": "451000",
		"pid": "450000",
		"name": "百色",
		"y": "b",
		"child": [{
			"id": "451002",
			"pid": "451000",
			"name": "右江",
			"y": "y"
		}, {
			"id": "451003",
			"pid": "451000",
			"name": "田阳",
			"y": "t"
		}, {
			"id": "451022",
			"pid": "451000",
			"name": "田东",
			"y": "t"
		}, {
			"id": "451024",
			"pid": "451000",
			"name": "德保",
			"y": "d"
		}, {
			"id": "451026",
			"pid": "451000",
			"name": "那坡",
			"y": "n"
		}, {
			"id": "451027",
			"pid": "451000",
			"name": "凌云",
			"y": "l"
		}, {
			"id": "451028",
			"pid": "451000",
			"name": "乐业",
			"y": "l"
		}, {
			"id": "451029",
			"pid": "451000",
			"name": "田林",
			"y": "t"
		}, {
			"id": "451030",
			"pid": "451000",
			"name": "西林",
			"y": "x"
		}, {
			"id": "451031",
			"pid": "451000",
			"name": "隆林",
			"y": "l"
		}, {
			"id": "451081",
			"pid": "451000",
			"name": "靖西",
			"y": "j"
		}, {
			"id": "451082",
			"pid": "451000",
			"name": "平果",
			"y": "p"
		}]
	}, {
		"id": "451100",
		"pid": "450000",
		"name": "贺州",
		"y": "h",
		"child": [{
			"id": "451102",
			"pid": "451100",
			"name": "八步",
			"y": "b"
		}, {
			"id": "451103",
			"pid": "451100",
			"name": "平桂",
			"y": "p"
		}, {
			"id": "451121",
			"pid": "451100",
			"name": "昭平",
			"y": "z"
		}, {
			"id": "451122",
			"pid": "451100",
			"name": "钟山",
			"y": "z"
		}, {
			"id": "451123",
			"pid": "451100",
			"name": "富川",
			"y": "f"
		}]
	}, {
		"id": "451200",
		"pid": "450000",
		"name": "河池",
		"y": "h",
		"child": [{
			"id": "451202",
			"pid": "451200",
			"name": "金城江",
			"y": "j"
		}, {
			"id": "451203",
			"pid": "451200",
			"name": "宜州",
			"y": "y"
		}, {
			"id": "451221",
			"pid": "451200",
			"name": "南丹",
			"y": "n"
		}, {
			"id": "451222",
			"pid": "451200",
			"name": "天峨",
			"y": "t"
		}, {
			"id": "451223",
			"pid": "451200",
			"name": "凤山",
			"y": "f"
		}, {
			"id": "451224",
			"pid": "451200",
			"name": "东兰",
			"y": "d"
		}, {
			"id": "451225",
			"pid": "451200",
			"name": "罗城",
			"y": "l"
		}, {
			"id": "451226",
			"pid": "451200",
			"name": "环江",
			"y": "h"
		}, {
			"id": "451227",
			"pid": "451200",
			"name": "巴马",
			"y": "b"
		}, {
			"id": "451228",
			"pid": "451200",
			"name": "都安",
			"y": "d"
		}, {
			"id": "451229",
			"pid": "451200",
			"name": "大化",
			"y": "d"
		}]
	}, {
		"id": "451300",
		"pid": "450000",
		"name": "来宾",
		"y": "l",
		"child": [{
			"id": "451302",
			"pid": "451300",
			"name": "兴宾",
			"y": "x"
		}, {
			"id": "451321",
			"pid": "451300",
			"name": "忻城",
			"y": "x"
		}, {
			"id": "451322",
			"pid": "451300",
			"name": "象州",
			"y": "x"
		}, {
			"id": "451323",
			"pid": "451300",
			"name": "武宣",
			"y": "w"
		}, {
			"id": "451324",
			"pid": "451300",
			"name": "金秀",
			"y": "j"
		}, {
			"id": "451381",
			"pid": "451300",
			"name": "合山",
			"y": "h"
		}]
	}, {
		"id": "451400",
		"pid": "450000",
		"name": "崇左",
		"y": "c",
		"child": [{
			"id": "451402",
			"pid": "451400",
			"name": "江州",
			"y": "j"
		}, {
			"id": "451421",
			"pid": "451400",
			"name": "扶绥",
			"y": "f"
		}, {
			"id": "451422",
			"pid": "451400",
			"name": "宁明",
			"y": "n"
		}, {
			"id": "451423",
			"pid": "451400",
			"name": "龙州",
			"y": "l"
		}, {
			"id": "451424",
			"pid": "451400",
			"name": "大新",
			"y": "d"
		}, {
			"id": "451425",
			"pid": "451400",
			"name": "天等",
			"y": "t"
		}, {
			"id": "451481",
			"pid": "451400",
			"name": "凭祥",
			"y": "p"
		}]
	}]
}, {
	"id": "460000",
	"pid": "0",
	"name": "海南",
	"y": "h",
	"child": [{
		"id": "460100",
		"pid": "460000",
		"name": "海口",
		"y": "h",
		"child": [{
			"id": "460105",
			"pid": "460100",
			"name": "秀英",
			"y": "x"
		}, {
			"id": "460106",
			"pid": "460100",
			"name": "龙华",
			"y": "l"
		}, {
			"id": "460107",
			"pid": "460100",
			"name": "琼山",
			"y": "q"
		}, {
			"id": "460108",
			"pid": "460100",
			"name": "美兰",
			"y": "m"
		}]
	}, {
		"id": "460200",
		"pid": "460000",
		"name": "三亚",
		"y": "s",
		"child": [{
			"id": "460202",
			"pid": "460200",
			"name": "海棠",
			"y": "h"
		}, {
			"id": "460203",
			"pid": "460200",
			"name": "吉阳",
			"y": "j"
		}, {
			"id": "460204",
			"pid": "460200",
			"name": "天涯",
			"y": "t"
		}, {
			"id": "460205",
			"pid": "460200",
			"name": "崖州",
			"y": "y"
		}]
	}, {
		"id": "460300",
		"pid": "460000",
		"name": "三沙",
		"y": "s",
		"child": [{
			"id": "460301",
			"pid": "460300",
			"name": "西沙",
			"y": "x"
		}, {
			"id": "460302",
			"pid": "460300",
			"name": "南沙",
			"y": "n"
		}]
	}, {
		"id": "460400",
		"pid": "460000",
		"name": "儋州",
		"y": "d",
		"child": [{
			"id": "460400",
			"pid": "460400",
			"name": "儋州",
			"y": "d"
		}]
	}, {
		"id": "46900100",
		"pid": "460000",
		"name": "五指山",
		"y": "w",
		"child": []
	}, {
		"id": "46900200",
		"pid": "460000",
		"name": "琼海",
		"y": "q",
		"child": []
	}, {
		"id": "46900500",
		"pid": "460000",
		"name": "文昌",
		"y": "w",
		"child": []
	}, {
		"id": "46900600",
		"pid": "460000",
		"name": "万宁",
		"y": "w",
		"child": []
	}, {
		"id": "46900700",
		"pid": "460000",
		"name": "东方",
		"y": "d",
		"child": []
	}, {
		"id": "46902100",
		"pid": "460000",
		"name": "定安",
		"y": "d",
		"child": []
	}, {
		"id": "46902200",
		"pid": "460000",
		"name": "屯昌",
		"y": "t",
		"child": []
	}, {
		"id": "46902300",
		"pid": "460000",
		"name": "澄迈",
		"y": "c",
		"child": []
	}, {
		"id": "46902400",
		"pid": "460000",
		"name": "临高",
		"y": "l",
		"child": []
	}, {
		"id": "46902500",
		"pid": "460000",
		"name": "白沙",
		"y": "b",
		"child": []
	}, {
		"id": "46902600",
		"pid": "460000",
		"name": "昌江",
		"y": "c",
		"child": []
	}, {
		"id": "46902700",
		"pid": "460000",
		"name": "乐东",
		"y": "l",
		"child": []
	}, {
		"id": "46902800",
		"pid": "460000",
		"name": "陵水",
		"y": "l",
		"child": []
	}, {
		"id": "46902900",
		"pid": "460000",
		"name": "保亭",
		"y": "b",
		"child": []
	}, {
		"id": "46903000",
		"pid": "460000",
		"name": "琼中",
		"y": "q",
		"child": []
	}]
}, {
	"id": "500000",
	"pid": "0",
	"name": "重庆",
	"y": "c",
	"child": [{
		"id": "500100",
		"pid": "500000",
		"name": "重庆城区",
		"y": "c",
		"child": [{
			"id": "500101",
			"pid": "500100",
			"name": "万州",
			"y": "w"
		}, {
			"id": "500102",
			"pid": "500100",
			"name": "涪陵",
			"y": "f"
		}, {
			"id": "500103",
			"pid": "500100",
			"name": "渝中",
			"y": "y"
		}, {
			"id": "500104",
			"pid": "500100",
			"name": "大渡口",
			"y": "d"
		}, {
			"id": "500105",
			"pid": "500100",
			"name": "江北",
			"y": "j"
		}, {
			"id": "500106",
			"pid": "500100",
			"name": "沙坪坝",
			"y": "s"
		}, {
			"id": "500107",
			"pid": "500100",
			"name": "九龙坡",
			"y": "j"
		}, {
			"id": "500108",
			"pid": "500100",
			"name": "南岸",
			"y": "n"
		}, {
			"id": "500109",
			"pid": "500100",
			"name": "北碚",
			"y": "b"
		}, {
			"id": "500110",
			"pid": "500100",
			"name": "綦江",
			"y": "q"
		}, {
			"id": "500111",
			"pid": "500100",
			"name": "大足",
			"y": "d"
		}, {
			"id": "500112",
			"pid": "500100",
			"name": "渝北",
			"y": "y"
		}, {
			"id": "500113",
			"pid": "500100",
			"name": "巴南",
			"y": "b"
		}, {
			"id": "500114",
			"pid": "500100",
			"name": "黔江",
			"y": "q"
		}, {
			"id": "500115",
			"pid": "500100",
			"name": "长寿",
			"y": "c"
		}, {
			"id": "500116",
			"pid": "500100",
			"name": "江津",
			"y": "j"
		}, {
			"id": "500117",
			"pid": "500100",
			"name": "合川",
			"y": "h"
		}, {
			"id": "500118",
			"pid": "500100",
			"name": "永川",
			"y": "y"
		}, {
			"id": "500119",
			"pid": "500100",
			"name": "南川",
			"y": "n"
		}, {
			"id": "500120",
			"pid": "500100",
			"name": "璧山",
			"y": "b"
		}, {
			"id": "500151",
			"pid": "500100",
			"name": "铜梁",
			"y": "t"
		}, {
			"id": "500152",
			"pid": "500100",
			"name": "潼南",
			"y": "t"
		}, {
			"id": "500153",
			"pid": "500100",
			"name": "荣昌",
			"y": "r"
		}, {
			"id": "500154",
			"pid": "500100",
			"name": "开州",
			"y": "k"
		}, {
			"id": "500155",
			"pid": "500100",
			"name": "梁平",
			"y": "l"
		}, {
			"id": "500156",
			"pid": "500100",
			"name": "武隆",
			"y": "w"
		}]
	}, {
		"id": "500200",
		"pid": "500000",
		"name": "重庆郊县",
		"y": "c",
		"child": [{
			"id": "500229",
			"pid": "500200",
			"name": "城口",
			"y": "c"
		}, {
			"id": "500230",
			"pid": "500200",
			"name": "丰都",
			"y": "f"
		}, {
			"id": "500231",
			"pid": "500200",
			"name": "垫江",
			"y": "d"
		}, {
			"id": "500233",
			"pid": "500200",
			"name": "忠县",
			"y": "z"
		}, {
			"id": "500235",
			"pid": "500200",
			"name": "云阳",
			"y": "y"
		}, {
			"id": "500236",
			"pid": "500200",
			"name": "奉节",
			"y": "f"
		}, {
			"id": "500237",
			"pid": "500200",
			"name": "巫山",
			"y": "w"
		}, {
			"id": "500238",
			"pid": "500200",
			"name": "巫溪",
			"y": "w"
		}, {
			"id": "500240",
			"pid": "500200",
			"name": "石柱",
			"y": "s"
		}, {
			"id": "500241",
			"pid": "500200",
			"name": "秀山",
			"y": "x"
		}, {
			"id": "500242",
			"pid": "500200",
			"name": "酉阳",
			"y": "y"
		}, {
			"id": "500243",
			"pid": "500200",
			"name": "彭水",
			"y": "p"
		}]
	}]
}, {
	"id": "510000",
	"pid": "0",
	"name": "四川",
	"y": "s",
	"child": [{
		"id": "510100",
		"pid": "510000",
		"name": "成都",
		"y": "c",
		"child": [{
			"id": "510104",
			"pid": "510100",
			"name": "锦江",
			"y": "j"
		}, {
			"id": "510105",
			"pid": "510100",
			"name": "青羊",
			"y": "q"
		}, {
			"id": "510106",
			"pid": "510100",
			"name": "金牛",
			"y": "j"
		}, {
			"id": "510107",
			"pid": "510100",
			"name": "武侯",
			"y": "w"
		}, {
			"id": "510108",
			"pid": "510100",
			"name": "成华",
			"y": "c"
		}, {
			"id": "510112",
			"pid": "510100",
			"name": "龙泉驿",
			"y": "l"
		}, {
			"id": "510113",
			"pid": "510100",
			"name": "青白江",
			"y": "q"
		}, {
			"id": "510114",
			"pid": "510100",
			"name": "新都",
			"y": "x"
		}, {
			"id": "510115",
			"pid": "510100",
			"name": "温江",
			"y": "w"
		}, {
			"id": "510116",
			"pid": "510100",
			"name": "双流",
			"y": "s"
		}, {
			"id": "510117",
			"pid": "510100",
			"name": "郫都",
			"y": "p"
		}, {
			"id": "510118",
			"pid": "510100",
			"name": "新津",
			"y": "x"
		}, {
			"id": "510121",
			"pid": "510100",
			"name": "金堂",
			"y": "j"
		}, {
			"id": "510129",
			"pid": "510100",
			"name": "大邑",
			"y": "d"
		}, {
			"id": "510131",
			"pid": "510100",
			"name": "蒲江",
			"y": "p"
		}, {
			"id": "510181",
			"pid": "510100",
			"name": "都江堰",
			"y": "d"
		}, {
			"id": "510182",
			"pid": "510100",
			"name": "彭州",
			"y": "p"
		}, {
			"id": "510183",
			"pid": "510100",
			"name": "邛崃",
			"y": "q"
		}, {
			"id": "510184",
			"pid": "510100",
			"name": "崇州",
			"y": "c"
		}, {
			"id": "510185",
			"pid": "510100",
			"name": "简阳",
			"y": "j"
		}]
	}, {
		"id": "510300",
		"pid": "510000",
		"name": "自贡",
		"y": "z",
		"child": [{
			"id": "510302",
			"pid": "510300",
			"name": "自流井",
			"y": "z"
		}, {
			"id": "510303",
			"pid": "510300",
			"name": "贡井",
			"y": "g"
		}, {
			"id": "510304",
			"pid": "510300",
			"name": "大安",
			"y": "d"
		}, {
			"id": "510311",
			"pid": "510300",
			"name": "沿滩",
			"y": "y"
		}, {
			"id": "510321",
			"pid": "510300",
			"name": "荣县",
			"y": "r"
		}, {
			"id": "510322",
			"pid": "510300",
			"name": "富顺",
			"y": "f"
		}]
	}, {
		"id": "510400",
		"pid": "510000",
		"name": "攀枝花",
		"y": "p",
		"child": [{
			"id": "510402",
			"pid": "510400",
			"name": "东区",
			"y": "d"
		}, {
			"id": "510403",
			"pid": "510400",
			"name": "西区",
			"y": "x"
		}, {
			"id": "510411",
			"pid": "510400",
			"name": "仁和",
			"y": "r"
		}, {
			"id": "510421",
			"pid": "510400",
			"name": "米易",
			"y": "m"
		}, {
			"id": "510422",
			"pid": "510400",
			"name": "盐边",
			"y": "y"
		}]
	}, {
		"id": "510500",
		"pid": "510000",
		"name": "泸州",
		"y": "l",
		"child": [{
			"id": "510502",
			"pid": "510500",
			"name": "江阳",
			"y": "j"
		}, {
			"id": "510503",
			"pid": "510500",
			"name": "纳溪",
			"y": "n"
		}, {
			"id": "510504",
			"pid": "510500",
			"name": "龙马潭",
			"y": "l"
		}, {
			"id": "510521",
			"pid": "510500",
			"name": "泸县",
			"y": "l"
		}, {
			"id": "510522",
			"pid": "510500",
			"name": "合江",
			"y": "h"
		}, {
			"id": "510524",
			"pid": "510500",
			"name": "叙永",
			"y": "x"
		}, {
			"id": "510525",
			"pid": "510500",
			"name": "古蔺",
			"y": "g"
		}]
	}, {
		"id": "510600",
		"pid": "510000",
		"name": "德阳",
		"y": "d",
		"child": [{
			"id": "510603",
			"pid": "510600",
			"name": "旌阳",
			"y": "j"
		}, {
			"id": "510604",
			"pid": "510600",
			"name": "罗江",
			"y": "l"
		}, {
			"id": "510623",
			"pid": "510600",
			"name": "中江",
			"y": "z"
		}, {
			"id": "510681",
			"pid": "510600",
			"name": "广汉",
			"y": "g"
		}, {
			"id": "510682",
			"pid": "510600",
			"name": "什邡",
			"y": "s"
		}, {
			"id": "510683",
			"pid": "510600",
			"name": "绵竹",
			"y": "m"
		}]
	}, {
		"id": "510700",
		"pid": "510000",
		"name": "绵阳",
		"y": "m",
		"child": [{
			"id": "510703",
			"pid": "510700",
			"name": "涪城",
			"y": "f"
		}, {
			"id": "510704",
			"pid": "510700",
			"name": "游仙",
			"y": "y"
		}, {
			"id": "510705",
			"pid": "510700",
			"name": "安州",
			"y": "a"
		}, {
			"id": "510722",
			"pid": "510700",
			"name": "三台",
			"y": "s"
		}, {
			"id": "510723",
			"pid": "510700",
			"name": "盐亭",
			"y": "y"
		}, {
			"id": "510725",
			"pid": "510700",
			"name": "梓潼",
			"y": "z"
		}, {
			"id": "510726",
			"pid": "510700",
			"name": "北川",
			"y": "b"
		}, {
			"id": "510727",
			"pid": "510700",
			"name": "平武",
			"y": "p"
		}, {
			"id": "510781",
			"pid": "510700",
			"name": "江油",
			"y": "j"
		}]
	}, {
		"id": "510800",
		"pid": "510000",
		"name": "广元",
		"y": "g",
		"child": [{
			"id": "510802",
			"pid": "510800",
			"name": "利州",
			"y": "l"
		}, {
			"id": "510811",
			"pid": "510800",
			"name": "昭化",
			"y": "z"
		}, {
			"id": "510812",
			"pid": "510800",
			"name": "朝天",
			"y": "c"
		}, {
			"id": "510821",
			"pid": "510800",
			"name": "旺苍",
			"y": "w"
		}, {
			"id": "510822",
			"pid": "510800",
			"name": "青川",
			"y": "q"
		}, {
			"id": "510823",
			"pid": "510800",
			"name": "剑阁",
			"y": "j"
		}, {
			"id": "510824",
			"pid": "510800",
			"name": "苍溪",
			"y": "c"
		}]
	}, {
		"id": "510900",
		"pid": "510000",
		"name": "遂宁",
		"y": "s",
		"child": [{
			"id": "510903",
			"pid": "510900",
			"name": "船山",
			"y": "c"
		}, {
			"id": "510904",
			"pid": "510900",
			"name": "安居",
			"y": "a"
		}, {
			"id": "510921",
			"pid": "510900",
			"name": "蓬溪",
			"y": "p"
		}, {
			"id": "510923",
			"pid": "510900",
			"name": "大英",
			"y": "d"
		}, {
			"id": "510981",
			"pid": "510900",
			"name": "射洪",
			"y": "s"
		}]
	}, {
		"id": "511000",
		"pid": "510000",
		"name": "内江",
		"y": "n",
		"child": [{
			"id": "511002",
			"pid": "511000",
			"name": "市中",
			"y": "s"
		}, {
			"id": "511011",
			"pid": "511000",
			"name": "东兴",
			"y": "d"
		}, {
			"id": "511024",
			"pid": "511000",
			"name": "威远",
			"y": "w"
		}, {
			"id": "511025",
			"pid": "511000",
			"name": "资中",
			"y": "z"
		}, {
			"id": "511083",
			"pid": "511000",
			"name": "隆昌",
			"y": "l"
		}]
	}, {
		"id": "511100",
		"pid": "510000",
		"name": "乐山",
		"y": "l",
		"child": [{
			"id": "511102",
			"pid": "511100",
			"name": "市中",
			"y": "s"
		}, {
			"id": "511111",
			"pid": "511100",
			"name": "沙湾",
			"y": "s"
		}, {
			"id": "511112",
			"pid": "511100",
			"name": "五通桥",
			"y": "w"
		}, {
			"id": "511113",
			"pid": "511100",
			"name": "金口河",
			"y": "j"
		}, {
			"id": "511123",
			"pid": "511100",
			"name": "犍为",
			"y": "q"
		}, {
			"id": "511124",
			"pid": "511100",
			"name": "井研",
			"y": "j"
		}, {
			"id": "511126",
			"pid": "511100",
			"name": "夹江",
			"y": "j"
		}, {
			"id": "511129",
			"pid": "511100",
			"name": "沐川",
			"y": "m"
		}, {
			"id": "511132",
			"pid": "511100",
			"name": "峨边",
			"y": "e"
		}, {
			"id": "511133",
			"pid": "511100",
			"name": "马边",
			"y": "m"
		}, {
			"id": "511181",
			"pid": "511100",
			"name": "峨眉山",
			"y": "e"
		}]
	}, {
		"id": "511300",
		"pid": "510000",
		"name": "南充",
		"y": "n",
		"child": [{
			"id": "511302",
			"pid": "511300",
			"name": "顺庆",
			"y": "s"
		}, {
			"id": "511303",
			"pid": "511300",
			"name": "高坪",
			"y": "g"
		}, {
			"id": "511304",
			"pid": "511300",
			"name": "嘉陵",
			"y": "j"
		}, {
			"id": "511321",
			"pid": "511300",
			"name": "南部",
			"y": "n"
		}, {
			"id": "511322",
			"pid": "511300",
			"name": "营山",
			"y": "y"
		}, {
			"id": "511323",
			"pid": "511300",
			"name": "蓬安",
			"y": "p"
		}, {
			"id": "511324",
			"pid": "511300",
			"name": "仪陇",
			"y": "y"
		}, {
			"id": "511325",
			"pid": "511300",
			"name": "西充",
			"y": "x"
		}, {
			"id": "511381",
			"pid": "511300",
			"name": "阆中",
			"y": "l"
		}]
	}, {
		"id": "511400",
		"pid": "510000",
		"name": "眉山",
		"y": "m",
		"child": [{
			"id": "511402",
			"pid": "511400",
			"name": "东坡",
			"y": "d"
		}, {
			"id": "511403",
			"pid": "511400",
			"name": "彭山",
			"y": "p"
		}, {
			"id": "511421",
			"pid": "511400",
			"name": "仁寿",
			"y": "r"
		}, {
			"id": "511423",
			"pid": "511400",
			"name": "洪雅",
			"y": "h"
		}, {
			"id": "511424",
			"pid": "511400",
			"name": "丹棱",
			"y": "d"
		}, {
			"id": "511425",
			"pid": "511400",
			"name": "青神",
			"y": "q"
		}]
	}, {
		"id": "511500",
		"pid": "510000",
		"name": "宜宾",
		"y": "y",
		"child": [{
			"id": "511502",
			"pid": "511500",
			"name": "翠屏",
			"y": "c"
		}, {
			"id": "511503",
			"pid": "511500",
			"name": "南溪",
			"y": "n"
		}, {
			"id": "511504",
			"pid": "511500",
			"name": "叙州",
			"y": "x"
		}, {
			"id": "511523",
			"pid": "511500",
			"name": "江安",
			"y": "j"
		}, {
			"id": "511524",
			"pid": "511500",
			"name": "长宁",
			"y": "c"
		}, {
			"id": "511525",
			"pid": "511500",
			"name": "高县",
			"y": "g"
		}, {
			"id": "511526",
			"pid": "511500",
			"name": "珙县",
			"y": "g"
		}, {
			"id": "511527",
			"pid": "511500",
			"name": "筠连",
			"y": "j"
		}, {
			"id": "511528",
			"pid": "511500",
			"name": "兴文",
			"y": "x"
		}, {
			"id": "511529",
			"pid": "511500",
			"name": "屏山",
			"y": "p"
		}]
	}, {
		"id": "511600",
		"pid": "510000",
		"name": "广安",
		"y": "g",
		"child": [{
			"id": "511602",
			"pid": "511600",
			"name": "广安区",
			"y": "g"
		}, {
			"id": "511603",
			"pid": "511600",
			"name": "前锋",
			"y": "q"
		}, {
			"id": "511621",
			"pid": "511600",
			"name": "岳池",
			"y": "y"
		}, {
			"id": "511622",
			"pid": "511600",
			"name": "武胜",
			"y": "w"
		}, {
			"id": "511623",
			"pid": "511600",
			"name": "邻水",
			"y": "l"
		}, {
			"id": "511681",
			"pid": "511600",
			"name": "华蓥",
			"y": "h"
		}]
	}, {
		"id": "511700",
		"pid": "510000",
		"name": "达州",
		"y": "d",
		"child": [{
			"id": "511702",
			"pid": "511700",
			"name": "通川",
			"y": "t"
		}, {
			"id": "511703",
			"pid": "511700",
			"name": "达川",
			"y": "d"
		}, {
			"id": "511722",
			"pid": "511700",
			"name": "宣汉",
			"y": "x"
		}, {
			"id": "511723",
			"pid": "511700",
			"name": "开江",
			"y": "k"
		}, {
			"id": "511724",
			"pid": "511700",
			"name": "大竹",
			"y": "d"
		}, {
			"id": "511725",
			"pid": "511700",
			"name": "渠县",
			"y": "q"
		}, {
			"id": "511781",
			"pid": "511700",
			"name": "万源",
			"y": "w"
		}]
	}, {
		"id": "511800",
		"pid": "510000",
		"name": "雅安",
		"y": "y",
		"child": [{
			"id": "511802",
			"pid": "511800",
			"name": "雨城",
			"y": "y"
		}, {
			"id": "511803",
			"pid": "511800",
			"name": "名山",
			"y": "m"
		}, {
			"id": "511822",
			"pid": "511800",
			"name": "荥经",
			"y": "y"
		}, {
			"id": "511823",
			"pid": "511800",
			"name": "汉源",
			"y": "h"
		}, {
			"id": "511824",
			"pid": "511800",
			"name": "石棉",
			"y": "s"
		}, {
			"id": "511825",
			"pid": "511800",
			"name": "天全",
			"y": "t"
		}, {
			"id": "511826",
			"pid": "511800",
			"name": "芦山",
			"y": "l"
		}, {
			"id": "511827",
			"pid": "511800",
			"name": "宝兴",
			"y": "b"
		}]
	}, {
		"id": "511900",
		"pid": "510000",
		"name": "巴中",
		"y": "b",
		"child": [{
			"id": "511902",
			"pid": "511900",
			"name": "巴州",
			"y": "b"
		}, {
			"id": "511903",
			"pid": "511900",
			"name": "恩阳",
			"y": "e"
		}, {
			"id": "511921",
			"pid": "511900",
			"name": "通江",
			"y": "t"
		}, {
			"id": "511922",
			"pid": "511900",
			"name": "南江",
			"y": "n"
		}, {
			"id": "511923",
			"pid": "511900",
			"name": "平昌",
			"y": "p"
		}]
	}, {
		"id": "512000",
		"pid": "510000",
		"name": "资阳",
		"y": "z",
		"child": [{
			"id": "512002",
			"pid": "512000",
			"name": "雁江",
			"y": "y"
		}, {
			"id": "512021",
			"pid": "512000",
			"name": "安岳",
			"y": "a"
		}, {
			"id": "512022",
			"pid": "512000",
			"name": "乐至",
			"y": "l"
		}]
	}, {
		"id": "513200",
		"pid": "510000",
		"name": "阿坝",
		"y": "a",
		"child": [{
			"id": "513201",
			"pid": "513200",
			"name": "马尔康",
			"y": "m"
		}, {
			"id": "513221",
			"pid": "513200",
			"name": "汶川",
			"y": "w"
		}, {
			"id": "513222",
			"pid": "513200",
			"name": "理县",
			"y": "l"
		}, {
			"id": "513223",
			"pid": "513200",
			"name": "茂县",
			"y": "m"
		}, {
			"id": "513224",
			"pid": "513200",
			"name": "松潘",
			"y": "s"
		}, {
			"id": "513225",
			"pid": "513200",
			"name": "九寨沟",
			"y": "j"
		}, {
			"id": "513226",
			"pid": "513200",
			"name": "金川",
			"y": "j"
		}, {
			"id": "513227",
			"pid": "513200",
			"name": "小金",
			"y": "x"
		}, {
			"id": "513228",
			"pid": "513200",
			"name": "黑水",
			"y": "h"
		}, {
			"id": "513230",
			"pid": "513200",
			"name": "壤塘",
			"y": "r"
		}, {
			"id": "513231",
			"pid": "513200",
			"name": "阿坝县",
			"y": "a"
		}, {
			"id": "513232",
			"pid": "513200",
			"name": "若尔盖",
			"y": "r"
		}, {
			"id": "513233",
			"pid": "513200",
			"name": "红原",
			"y": "h"
		}]
	}, {
		"id": "513300",
		"pid": "510000",
		"name": "甘孜",
		"y": "g",
		"child": [{
			"id": "513301",
			"pid": "513300",
			"name": "康定",
			"y": "k"
		}, {
			"id": "513322",
			"pid": "513300",
			"name": "泸定",
			"y": "l"
		}, {
			"id": "513323",
			"pid": "513300",
			"name": "丹巴",
			"y": "d"
		}, {
			"id": "513324",
			"pid": "513300",
			"name": "九龙",
			"y": "j"
		}, {
			"id": "513325",
			"pid": "513300",
			"name": "雅江",
			"y": "y"
		}, {
			"id": "513326",
			"pid": "513300",
			"name": "道孚",
			"y": "d"
		}, {
			"id": "513327",
			"pid": "513300",
			"name": "炉霍",
			"y": "l"
		}, {
			"id": "513328",
			"pid": "513300",
			"name": "甘孜县",
			"y": "g"
		}, {
			"id": "513329",
			"pid": "513300",
			"name": "新龙",
			"y": "x"
		}, {
			"id": "513330",
			"pid": "513300",
			"name": "德格",
			"y": "d"
		}, {
			"id": "513331",
			"pid": "513300",
			"name": "白玉",
			"y": "b"
		}, {
			"id": "513332",
			"pid": "513300",
			"name": "石渠",
			"y": "s"
		}, {
			"id": "513333",
			"pid": "513300",
			"name": "色达",
			"y": "s"
		}, {
			"id": "513334",
			"pid": "513300",
			"name": "理塘",
			"y": "l"
		}, {
			"id": "513335",
			"pid": "513300",
			"name": "巴塘",
			"y": "b"
		}, {
			"id": "513336",
			"pid": "513300",
			"name": "乡城",
			"y": "x"
		}, {
			"id": "513337",
			"pid": "513300",
			"name": "稻城",
			"y": "d"
		}, {
			"id": "513338",
			"pid": "513300",
			"name": "得荣",
			"y": "d"
		}]
	}, {
		"id": "513400",
		"pid": "510000",
		"name": "凉山",
		"y": "l",
		"child": [{
			"id": "513401",
			"pid": "513400",
			"name": "西昌",
			"y": "x"
		}, {
			"id": "513422",
			"pid": "513400",
			"name": "木里",
			"y": "m"
		}, {
			"id": "513423",
			"pid": "513400",
			"name": "盐源",
			"y": "y"
		}, {
			"id": "513424",
			"pid": "513400",
			"name": "德昌",
			"y": "d"
		}, {
			"id": "513425",
			"pid": "513400",
			"name": "会理",
			"y": "h"
		}, {
			"id": "513426",
			"pid": "513400",
			"name": "会东",
			"y": "h"
		}, {
			"id": "513427",
			"pid": "513400",
			"name": "宁南",
			"y": "n"
		}, {
			"id": "513428",
			"pid": "513400",
			"name": "普格",
			"y": "p"
		}, {
			"id": "513429",
			"pid": "513400",
			"name": "布拖",
			"y": "b"
		}, {
			"id": "513430",
			"pid": "513400",
			"name": "金阳",
			"y": "j"
		}, {
			"id": "513431",
			"pid": "513400",
			"name": "昭觉",
			"y": "z"
		}, {
			"id": "513432",
			"pid": "513400",
			"name": "喜德",
			"y": "x"
		}, {
			"id": "513433",
			"pid": "513400",
			"name": "冕宁",
			"y": "m"
		}, {
			"id": "513434",
			"pid": "513400",
			"name": "越西",
			"y": "y"
		}, {
			"id": "513435",
			"pid": "513400",
			"name": "甘洛",
			"y": "g"
		}, {
			"id": "513436",
			"pid": "513400",
			"name": "美姑",
			"y": "m"
		}, {
			"id": "513437",
			"pid": "513400",
			"name": "雷波",
			"y": "l"
		}]
	}]
}, {
	"id": "520000",
	"pid": "0",
	"name": "贵州",
	"y": "g",
	"child": [{
		"id": "520100",
		"pid": "520000",
		"name": "贵阳",
		"y": "g",
		"child": [{
			"id": "520102",
			"pid": "520100",
			"name": "南明",
			"y": "n"
		}, {
			"id": "520103",
			"pid": "520100",
			"name": "云岩",
			"y": "y"
		}, {
			"id": "520111",
			"pid": "520100",
			"name": "花溪",
			"y": "h"
		}, {
			"id": "520112",
			"pid": "520100",
			"name": "乌当",
			"y": "w"
		}, {
			"id": "520113",
			"pid": "520100",
			"name": "白云",
			"y": "b"
		}, {
			"id": "520115",
			"pid": "520100",
			"name": "观山湖",
			"y": "g"
		}, {
			"id": "520121",
			"pid": "520100",
			"name": "开阳",
			"y": "k"
		}, {
			"id": "520122",
			"pid": "520100",
			"name": "息烽",
			"y": "x"
		}, {
			"id": "520123",
			"pid": "520100",
			"name": "修文",
			"y": "x"
		}, {
			"id": "520181",
			"pid": "520100",
			"name": "清镇",
			"y": "q"
		}]
	}, {
		"id": "520200",
		"pid": "520000",
		"name": "六盘水",
		"y": "l",
		"child": [{
			"id": "520201",
			"pid": "520200",
			"name": "钟山",
			"y": "z"
		}, {
			"id": "520203",
			"pid": "520200",
			"name": "六枝特",
			"y": "l"
		}, {
			"id": "520204",
			"pid": "520200",
			"name": "水城",
			"y": "s"
		}, {
			"id": "520281",
			"pid": "520200",
			"name": "盘州",
			"y": "p"
		}]
	}, {
		"id": "520300",
		"pid": "520000",
		"name": "遵义",
		"y": "z",
		"child": [{
			"id": "520302",
			"pid": "520300",
			"name": "红花岗",
			"y": "h"
		}, {
			"id": "520303",
			"pid": "520300",
			"name": "汇川",
			"y": "h"
		}, {
			"id": "520304",
			"pid": "520300",
			"name": "播州",
			"y": "b"
		}, {
			"id": "520322",
			"pid": "520300",
			"name": "桐梓",
			"y": "t"
		}, {
			"id": "520323",
			"pid": "520300",
			"name": "绥阳",
			"y": "s"
		}, {
			"id": "520324",
			"pid": "520300",
			"name": "正安",
			"y": "z"
		}, {
			"id": "520325",
			"pid": "520300",
			"name": "道真",
			"y": "d"
		}, {
			"id": "520326",
			"pid": "520300",
			"name": "务川",
			"y": "w"
		}, {
			"id": "520327",
			"pid": "520300",
			"name": "凤冈",
			"y": "f"
		}, {
			"id": "520328",
			"pid": "520300",
			"name": "湄潭",
			"y": "m"
		}, {
			"id": "520329",
			"pid": "520300",
			"name": "余庆",
			"y": "y"
		}, {
			"id": "520330",
			"pid": "520300",
			"name": "习水",
			"y": "x"
		}, {
			"id": "520381",
			"pid": "520300",
			"name": "赤水",
			"y": "c"
		}, {
			"id": "520382",
			"pid": "520300",
			"name": "仁怀",
			"y": "r"
		}]
	}, {
		"id": "520400",
		"pid": "520000",
		"name": "安顺",
		"y": "a",
		"child": [{
			"id": "520402",
			"pid": "520400",
			"name": "西秀",
			"y": "x"
		}, {
			"id": "520403",
			"pid": "520400",
			"name": "平坝",
			"y": "p"
		}, {
			"id": "520422",
			"pid": "520400",
			"name": "普定",
			"y": "p"
		}, {
			"id": "520423",
			"pid": "520400",
			"name": "镇宁",
			"y": "z"
		}, {
			"id": "520424",
			"pid": "520400",
			"name": "关岭",
			"y": "g"
		}, {
			"id": "520425",
			"pid": "520400",
			"name": "紫云",
			"y": "z"
		}]
	}, {
		"id": "520500",
		"pid": "520000",
		"name": "毕节",
		"y": "b",
		"child": [{
			"id": "520502",
			"pid": "520500",
			"name": "七星关",
			"y": "q"
		}, {
			"id": "520521",
			"pid": "520500",
			"name": "大方",
			"y": "d"
		}, {
			"id": "520522",
			"pid": "520500",
			"name": "黔西",
			"y": "q"
		}, {
			"id": "520523",
			"pid": "520500",
			"name": "金沙",
			"y": "j"
		}, {
			"id": "520524",
			"pid": "520500",
			"name": "织金",
			"y": "z"
		}, {
			"id": "520525",
			"pid": "520500",
			"name": "纳雍",
			"y": "n"
		}, {
			"id": "520526",
			"pid": "520500",
			"name": "威宁",
			"y": "w"
		}, {
			"id": "520527",
			"pid": "520500",
			"name": "赫章",
			"y": "h"
		}]
	}, {
		"id": "520600",
		"pid": "520000",
		"name": "铜仁",
		"y": "t",
		"child": [{
			"id": "520602",
			"pid": "520600",
			"name": "碧江",
			"y": "b"
		}, {
			"id": "520603",
			"pid": "520600",
			"name": "万山",
			"y": "w"
		}, {
			"id": "520621",
			"pid": "520600",
			"name": "江口",
			"y": "j"
		}, {
			"id": "520622",
			"pid": "520600",
			"name": "玉屏",
			"y": "y"
		}, {
			"id": "520623",
			"pid": "520600",
			"name": "石阡",
			"y": "s"
		}, {
			"id": "520624",
			"pid": "520600",
			"name": "思南",
			"y": "s"
		}, {
			"id": "520625",
			"pid": "520600",
			"name": "印江",
			"y": "y"
		}, {
			"id": "520626",
			"pid": "520600",
			"name": "德江",
			"y": "d"
		}, {
			"id": "520627",
			"pid": "520600",
			"name": "沿河",
			"y": "y"
		}, {
			"id": "520628",
			"pid": "520600",
			"name": "松桃",
			"y": "s"
		}]
	}, {
		"id": "522300",
		"pid": "520000",
		"name": "黔西南",
		"y": "q",
		"child": [{
			"id": "522301",
			"pid": "522300",
			"name": "兴义",
			"y": "x"
		}, {
			"id": "522302",
			"pid": "522300",
			"name": "兴仁",
			"y": "x"
		}, {
			"id": "522323",
			"pid": "522300",
			"name": "普安",
			"y": "p"
		}, {
			"id": "522324",
			"pid": "522300",
			"name": "晴隆",
			"y": "q"
		}, {
			"id": "522325",
			"pid": "522300",
			"name": "贞丰",
			"y": "z"
		}, {
			"id": "522326",
			"pid": "522300",
			"name": "望谟",
			"y": "w"
		}, {
			"id": "522327",
			"pid": "522300",
			"name": "册亨",
			"y": "c"
		}, {
			"id": "522328",
			"pid": "522300",
			"name": "安龙",
			"y": "a"
		}]
	}, {
		"id": "522600",
		"pid": "520000",
		"name": "黔东南",
		"y": "q",
		"child": [{
			"id": "522601",
			"pid": "522600",
			"name": "凯里",
			"y": "k"
		}, {
			"id": "522622",
			"pid": "522600",
			"name": "黄平",
			"y": "h"
		}, {
			"id": "522623",
			"pid": "522600",
			"name": "施秉",
			"y": "s"
		}, {
			"id": "522624",
			"pid": "522600",
			"name": "三穗",
			"y": "s"
		}, {
			"id": "522625",
			"pid": "522600",
			"name": "镇远",
			"y": "z"
		}, {
			"id": "522626",
			"pid": "522600",
			"name": "岑巩",
			"y": "c"
		}, {
			"id": "522627",
			"pid": "522600",
			"name": "天柱",
			"y": "t"
		}, {
			"id": "522628",
			"pid": "522600",
			"name": "锦屏",
			"y": "j"
		}, {
			"id": "522629",
			"pid": "522600",
			"name": "剑河",
			"y": "j"
		}, {
			"id": "522630",
			"pid": "522600",
			"name": "台江",
			"y": "t"
		}, {
			"id": "522631",
			"pid": "522600",
			"name": "黎平",
			"y": "l"
		}, {
			"id": "522632",
			"pid": "522600",
			"name": "榕江",
			"y": "r"
		}, {
			"id": "522633",
			"pid": "522600",
			"name": "从江",
			"y": "c"
		}, {
			"id": "522634",
			"pid": "522600",
			"name": "雷山",
			"y": "l"
		}, {
			"id": "522635",
			"pid": "522600",
			"name": "麻江",
			"y": "m"
		}, {
			"id": "522636",
			"pid": "522600",
			"name": "丹寨",
			"y": "d"
		}]
	}, {
		"id": "522700",
		"pid": "520000",
		"name": "黔南",
		"y": "q",
		"child": [{
			"id": "522701",
			"pid": "522700",
			"name": "都匀",
			"y": "d"
		}, {
			"id": "522702",
			"pid": "522700",
			"name": "福泉",
			"y": "f"
		}, {
			"id": "522722",
			"pid": "522700",
			"name": "荔波",
			"y": "l"
		}, {
			"id": "522723",
			"pid": "522700",
			"name": "贵定",
			"y": "g"
		}, {
			"id": "522725",
			"pid": "522700",
			"name": "瓮安",
			"y": "w"
		}, {
			"id": "522726",
			"pid": "522700",
			"name": "独山",
			"y": "d"
		}, {
			"id": "522727",
			"pid": "522700",
			"name": "平塘",
			"y": "p"
		}, {
			"id": "522728",
			"pid": "522700",
			"name": "罗甸",
			"y": "l"
		}, {
			"id": "522729",
			"pid": "522700",
			"name": "长顺",
			"y": "c"
		}, {
			"id": "522730",
			"pid": "522700",
			"name": "龙里",
			"y": "l"
		}, {
			"id": "522731",
			"pid": "522700",
			"name": "惠水",
			"y": "h"
		}, {
			"id": "522732",
			"pid": "522700",
			"name": "三都",
			"y": "s"
		}]
	}]
}, {
	"id": "530000",
	"pid": "0",
	"name": "云南",
	"y": "y",
	"child": [{
		"id": "530100",
		"pid": "530000",
		"name": "昆明",
		"y": "k",
		"child": [{
			"id": "530102",
			"pid": "530100",
			"name": "五华",
			"y": "w"
		}, {
			"id": "530103",
			"pid": "530100",
			"name": "盘龙",
			"y": "p"
		}, {
			"id": "530111",
			"pid": "530100",
			"name": "官渡",
			"y": "g"
		}, {
			"id": "530112",
			"pid": "530100",
			"name": "西山",
			"y": "x"
		}, {
			"id": "530113",
			"pid": "530100",
			"name": "东川",
			"y": "d"
		}, {
			"id": "530114",
			"pid": "530100",
			"name": "呈贡",
			"y": "c"
		}, {
			"id": "530115",
			"pid": "530100",
			"name": "晋宁",
			"y": "j"
		}, {
			"id": "530124",
			"pid": "530100",
			"name": "富民",
			"y": "f"
		}, {
			"id": "530125",
			"pid": "530100",
			"name": "宜良",
			"y": "y"
		}, {
			"id": "530126",
			"pid": "530100",
			"name": "石林",
			"y": "s"
		}, {
			"id": "530127",
			"pid": "530100",
			"name": "嵩明",
			"y": "s"
		}, {
			"id": "530128",
			"pid": "530100",
			"name": "禄劝",
			"y": "l"
		}, {
			"id": "530129",
			"pid": "530100",
			"name": "寻甸",
			"y": "x"
		}, {
			"id": "530181",
			"pid": "530100",
			"name": "安宁",
			"y": "a"
		}]
	}, {
		"id": "530300",
		"pid": "530000",
		"name": "曲靖",
		"y": "q",
		"child": [{
			"id": "530302",
			"pid": "530300",
			"name": "麒麟",
			"y": "q"
		}, {
			"id": "530303",
			"pid": "530300",
			"name": "沾益",
			"y": "z"
		}, {
			"id": "530304",
			"pid": "530300",
			"name": "马龙",
			"y": "m"
		}, {
			"id": "530322",
			"pid": "530300",
			"name": "陆良",
			"y": "l"
		}, {
			"id": "530323",
			"pid": "530300",
			"name": "师宗",
			"y": "s"
		}, {
			"id": "530324",
			"pid": "530300",
			"name": "罗平",
			"y": "l"
		}, {
			"id": "530325",
			"pid": "530300",
			"name": "富源",
			"y": "f"
		}, {
			"id": "530326",
			"pid": "530300",
			"name": "会泽",
			"y": "h"
		}, {
			"id": "530381",
			"pid": "530300",
			"name": "宣威",
			"y": "x"
		}]
	}, {
		"id": "530400",
		"pid": "530000",
		"name": "玉溪",
		"y": "y",
		"child": [{
			"id": "530402",
			"pid": "530400",
			"name": "红塔",
			"y": "h"
		}, {
			"id": "530403",
			"pid": "530400",
			"name": "江川",
			"y": "j"
		}, {
			"id": "530423",
			"pid": "530400",
			"name": "通海",
			"y": "t"
		}, {
			"id": "530424",
			"pid": "530400",
			"name": "华宁",
			"y": "h"
		}, {
			"id": "530425",
			"pid": "530400",
			"name": "易门",
			"y": "y"
		}, {
			"id": "530426",
			"pid": "530400",
			"name": "峨山",
			"y": "e"
		}, {
			"id": "530427",
			"pid": "530400",
			"name": "新平",
			"y": "x"
		}, {
			"id": "530428",
			"pid": "530400",
			"name": "元江",
			"y": "y"
		}, {
			"id": "530481",
			"pid": "530400",
			"name": "澄江",
			"y": "c"
		}]
	}, {
		"id": "530500",
		"pid": "530000",
		"name": "保山",
		"y": "b",
		"child": [{
			"id": "530502",
			"pid": "530500",
			"name": "隆阳",
			"y": "l"
		}, {
			"id": "530521",
			"pid": "530500",
			"name": "施甸",
			"y": "s"
		}, {
			"id": "530523",
			"pid": "530500",
			"name": "龙陵",
			"y": "l"
		}, {
			"id": "530524",
			"pid": "530500",
			"name": "昌宁",
			"y": "c"
		}, {
			"id": "530581",
			"pid": "530500",
			"name": "腾冲",
			"y": "t"
		}]
	}, {
		"id": "530600",
		"pid": "530000",
		"name": "昭通",
		"y": "z",
		"child": [{
			"id": "530602",
			"pid": "530600",
			"name": "昭阳",
			"y": "z"
		}, {
			"id": "530621",
			"pid": "530600",
			"name": "鲁甸",
			"y": "l"
		}, {
			"id": "530622",
			"pid": "530600",
			"name": "巧家",
			"y": "q"
		}, {
			"id": "530623",
			"pid": "530600",
			"name": "盐津",
			"y": "y"
		}, {
			"id": "530624",
			"pid": "530600",
			"name": "大关",
			"y": "d"
		}, {
			"id": "530625",
			"pid": "530600",
			"name": "永善",
			"y": "y"
		}, {
			"id": "530626",
			"pid": "530600",
			"name": "绥江",
			"y": "s"
		}, {
			"id": "530627",
			"pid": "530600",
			"name": "镇雄",
			"y": "z"
		}, {
			"id": "530628",
			"pid": "530600",
			"name": "彝良",
			"y": "y"
		}, {
			"id": "530629",
			"pid": "530600",
			"name": "威信",
			"y": "w"
		}, {
			"id": "530681",
			"pid": "530600",
			"name": "水富",
			"y": "s"
		}]
	}, {
		"id": "530700",
		"pid": "530000",
		"name": "丽江",
		"y": "l",
		"child": [{
			"id": "530702",
			"pid": "530700",
			"name": "古城",
			"y": "g"
		}, {
			"id": "530721",
			"pid": "530700",
			"name": "玉龙",
			"y": "y"
		}, {
			"id": "530722",
			"pid": "530700",
			"name": "永胜",
			"y": "y"
		}, {
			"id": "530723",
			"pid": "530700",
			"name": "华坪",
			"y": "h"
		}, {
			"id": "530724",
			"pid": "530700",
			"name": "宁蒗",
			"y": "n"
		}]
	}, {
		"id": "530800",
		"pid": "530000",
		"name": "普洱",
		"y": "p",
		"child": [{
			"id": "530802",
			"pid": "530800",
			"name": "思茅",
			"y": "s"
		}, {
			"id": "530821",
			"pid": "530800",
			"name": "宁洱",
			"y": "n"
		}, {
			"id": "530822",
			"pid": "530800",
			"name": "墨江",
			"y": "m"
		}, {
			"id": "530823",
			"pid": "530800",
			"name": "景东",
			"y": "j"
		}, {
			"id": "530824",
			"pid": "530800",
			"name": "景谷",
			"y": "j"
		}, {
			"id": "530825",
			"pid": "530800",
			"name": "镇沅",
			"y": "z"
		}, {
			"id": "530826",
			"pid": "530800",
			"name": "江城",
			"y": "j"
		}, {
			"id": "530827",
			"pid": "530800",
			"name": "孟连",
			"y": "m"
		}, {
			"id": "530828",
			"pid": "530800",
			"name": "澜沧",
			"y": "l"
		}, {
			"id": "530829",
			"pid": "530800",
			"name": "西盟",
			"y": "x"
		}]
	}, {
		"id": "530900",
		"pid": "530000",
		"name": "临沧",
		"y": "l",
		"child": [{
			"id": "530902",
			"pid": "530900",
			"name": "临翔",
			"y": "l"
		}, {
			"id": "530921",
			"pid": "530900",
			"name": "凤庆",
			"y": "f"
		}, {
			"id": "530922",
			"pid": "530900",
			"name": "云县",
			"y": "y"
		}, {
			"id": "530923",
			"pid": "530900",
			"name": "永德",
			"y": "y"
		}, {
			"id": "530924",
			"pid": "530900",
			"name": "镇康",
			"y": "z"
		}, {
			"id": "530925",
			"pid": "530900",
			"name": "双江",
			"y": "s"
		}, {
			"id": "530926",
			"pid": "530900",
			"name": "耿马",
			"y": "g"
		}, {
			"id": "530927",
			"pid": "530900",
			"name": "沧源",
			"y": "c"
		}]
	}, {
		"id": "532300",
		"pid": "530000",
		"name": "楚雄",
		"y": "c",
		"child": [{
			"id": "532301",
			"pid": "532300",
			"name": "楚雄市",
			"y": "c"
		}, {
			"id": "532322",
			"pid": "532300",
			"name": "双柏",
			"y": "s"
		}, {
			"id": "532323",
			"pid": "532300",
			"name": "牟定",
			"y": "m"
		}, {
			"id": "532324",
			"pid": "532300",
			"name": "南华",
			"y": "n"
		}, {
			"id": "532325",
			"pid": "532300",
			"name": "姚安",
			"y": "y"
		}, {
			"id": "532326",
			"pid": "532300",
			"name": "大姚",
			"y": "d"
		}, {
			"id": "532327",
			"pid": "532300",
			"name": "永仁",
			"y": "y"
		}, {
			"id": "532328",
			"pid": "532300",
			"name": "元谋",
			"y": "y"
		}, {
			"id": "532329",
			"pid": "532300",
			"name": "武定",
			"y": "w"
		}, {
			"id": "532331",
			"pid": "532300",
			"name": "禄丰",
			"y": "l"
		}]
	}, {
		"id": "532500",
		"pid": "530000",
		"name": "红河",
		"y": "h",
		"child": [{
			"id": "532501",
			"pid": "532500",
			"name": "个旧",
			"y": "g"
		}, {
			"id": "532502",
			"pid": "532500",
			"name": "开远",
			"y": "k"
		}, {
			"id": "532503",
			"pid": "532500",
			"name": "蒙自",
			"y": "m"
		}, {
			"id": "532504",
			"pid": "532500",
			"name": "弥勒",
			"y": "m"
		}, {
			"id": "532523",
			"pid": "532500",
			"name": "屏边",
			"y": "p"
		}, {
			"id": "532524",
			"pid": "532500",
			"name": "建水",
			"y": "j"
		}, {
			"id": "532525",
			"pid": "532500",
			"name": "石屏",
			"y": "s"
		}, {
			"id": "532527",
			"pid": "532500",
			"name": "泸西",
			"y": "l"
		}, {
			"id": "532528",
			"pid": "532500",
			"name": "元阳",
			"y": "y"
		}, {
			"id": "532529",
			"pid": "532500",
			"name": "红河县",
			"y": "h"
		}, {
			"id": "532530",
			"pid": "532500",
			"name": "金平",
			"y": "j"
		}, {
			"id": "532531",
			"pid": "532500",
			"name": "绿春",
			"y": "l"
		}, {
			"id": "532532",
			"pid": "532500",
			"name": "河口",
			"y": "h"
		}]
	}, {
		"id": "532600",
		"pid": "530000",
		"name": "文山",
		"y": "w",
		"child": [{
			"id": "532601",
			"pid": "532600",
			"name": "文山市",
			"y": "w"
		}, {
			"id": "532622",
			"pid": "532600",
			"name": "砚山",
			"y": "y"
		}, {
			"id": "532623",
			"pid": "532600",
			"name": "西畴",
			"y": "x"
		}, {
			"id": "532624",
			"pid": "532600",
			"name": "麻栗坡",
			"y": "m"
		}, {
			"id": "532625",
			"pid": "532600",
			"name": "马关",
			"y": "m"
		}, {
			"id": "532626",
			"pid": "532600",
			"name": "丘北",
			"y": "q"
		}, {
			"id": "532627",
			"pid": "532600",
			"name": "广南",
			"y": "g"
		}, {
			"id": "532628",
			"pid": "532600",
			"name": "富宁",
			"y": "f"
		}]
	}, {
		"id": "532800",
		"pid": "530000",
		"name": "西双版纳",
		"y": "x",
		"child": [{
			"id": "532801",
			"pid": "532800",
			"name": "景洪",
			"y": "j"
		}, {
			"id": "532822",
			"pid": "532800",
			"name": "勐海",
			"y": "m"
		}, {
			"id": "532823",
			"pid": "532800",
			"name": "勐腊",
			"y": "m"
		}]
	}, {
		"id": "532900",
		"pid": "530000",
		"name": "大理",
		"y": "d",
		"child": [{
			"id": "532901",
			"pid": "532900",
			"name": "大理市",
			"y": "d"
		}, {
			"id": "532922",
			"pid": "532900",
			"name": "漾濞",
			"y": "y"
		}, {
			"id": "532923",
			"pid": "532900",
			"name": "祥云",
			"y": "x"
		}, {
			"id": "532924",
			"pid": "532900",
			"name": "宾川",
			"y": "b"
		}, {
			"id": "532925",
			"pid": "532900",
			"name": "弥渡",
			"y": "m"
		}, {
			"id": "532926",
			"pid": "532900",
			"name": "南涧",
			"y": "n"
		}, {
			"id": "532927",
			"pid": "532900",
			"name": "巍山",
			"y": "w"
		}, {
			"id": "532928",
			"pid": "532900",
			"name": "永平",
			"y": "y"
		}, {
			"id": "532929",
			"pid": "532900",
			"name": "云龙",
			"y": "y"
		}, {
			"id": "532930",
			"pid": "532900",
			"name": "洱源",
			"y": "e"
		}, {
			"id": "532931",
			"pid": "532900",
			"name": "剑川",
			"y": "j"
		}, {
			"id": "532932",
			"pid": "532900",
			"name": "鹤庆",
			"y": "h"
		}]
	}, {
		"id": "533100",
		"pid": "530000",
		"name": "德宏",
		"y": "d",
		"child": [{
			"id": "533102",
			"pid": "533100",
			"name": "瑞丽",
			"y": "r"
		}, {
			"id": "533103",
			"pid": "533100",
			"name": "芒市",
			"y": "m"
		}, {
			"id": "533122",
			"pid": "533100",
			"name": "梁河",
			"y": "l"
		}, {
			"id": "533123",
			"pid": "533100",
			"name": "盈江",
			"y": "y"
		}, {
			"id": "533124",
			"pid": "533100",
			"name": "陇川",
			"y": "l"
		}]
	}, {
		"id": "533300",
		"pid": "530000",
		"name": "怒江",
		"y": "n",
		"child": [{
			"id": "533301",
			"pid": "533300",
			"name": "泸水",
			"y": "l"
		}, {
			"id": "533323",
			"pid": "533300",
			"name": "福贡",
			"y": "f"
		}, {
			"id": "533324",
			"pid": "533300",
			"name": "贡山",
			"y": "g"
		}, {
			"id": "533325",
			"pid": "533300",
			"name": "兰坪",
			"y": "l"
		}]
	}, {
		"id": "533400",
		"pid": "530000",
		"name": "迪庆",
		"y": "d",
		"child": [{
			"id": "533401",
			"pid": "533400",
			"name": "香格里拉",
			"y": "x"
		}, {
			"id": "533422",
			"pid": "533400",
			"name": "德钦",
			"y": "d"
		}, {
			"id": "533423",
			"pid": "533400",
			"name": "维西",
			"y": "w"
		}]
	}]
}, {
	"id": "540000",
	"pid": "0",
	"name": "西藏",
	"y": "x",
	"child": [{
		"id": "540100",
		"pid": "540000",
		"name": "拉萨",
		"y": "l",
		"child": [{
			"id": "540102",
			"pid": "540100",
			"name": "城关",
			"y": "c"
		}, {
			"id": "540103",
			"pid": "540100",
			"name": "堆龙德庆区",
			"y": "d"
		}, {
			"id": "540104",
			"pid": "540100",
			"name": "达孜",
			"y": "d"
		}, {
			"id": "540121",
			"pid": "540100",
			"name": "林周",
			"y": "l"
		}, {
			"id": "540122",
			"pid": "540100",
			"name": "当雄",
			"y": "d"
		}, {
			"id": "540123",
			"pid": "540100",
			"name": "尼木",
			"y": "n"
		}, {
			"id": "540124",
			"pid": "540100",
			"name": "曲水",
			"y": "q"
		}, {
			"id": "540127",
			"pid": "540100",
			"name": "墨竹工卡",
			"y": "m"
		}]
	}, {
		"id": "540200",
		"pid": "540000",
		"name": "日喀则",
		"y": "r",
		"child": [{
			"id": "540202",
			"pid": "540200",
			"name": "桑珠孜",
			"y": "s"
		}, {
			"id": "540221",
			"pid": "540200",
			"name": "南木林",
			"y": "n"
		}, {
			"id": "540222",
			"pid": "540200",
			"name": "江孜",
			"y": "j"
		}, {
			"id": "540223",
			"pid": "540200",
			"name": "定日",
			"y": "d"
		}, {
			"id": "540224",
			"pid": "540200",
			"name": "萨迦",
			"y": "s"
		}, {
			"id": "540225",
			"pid": "540200",
			"name": "拉孜",
			"y": "l"
		}, {
			"id": "540226",
			"pid": "540200",
			"name": "昂仁",
			"y": "a"
		}, {
			"id": "540227",
			"pid": "540200",
			"name": "谢通门",
			"y": "x"
		}, {
			"id": "540228",
			"pid": "540200",
			"name": "白朗",
			"y": "b"
		}, {
			"id": "540229",
			"pid": "540200",
			"name": "仁布",
			"y": "r"
		}, {
			"id": "540230",
			"pid": "540200",
			"name": "康马",
			"y": "k"
		}, {
			"id": "540231",
			"pid": "540200",
			"name": "定结",
			"y": "d"
		}, {
			"id": "540232",
			"pid": "540200",
			"name": "仲巴",
			"y": "z"
		}, {
			"id": "540233",
			"pid": "540200",
			"name": "亚东",
			"y": "y"
		}, {
			"id": "540234",
			"pid": "540200",
			"name": "吉隆",
			"y": "j"
		}, {
			"id": "540235",
			"pid": "540200",
			"name": "聂拉木",
			"y": "n"
		}, {
			"id": "540236",
			"pid": "540200",
			"name": "萨嘎",
			"y": "s"
		}, {
			"id": "540237",
			"pid": "540200",
			"name": "岗巴",
			"y": "g"
		}]
	}, {
		"id": "540300",
		"pid": "540000",
		"name": "昌都",
		"y": "c",
		"child": [{
			"id": "540302",
			"pid": "540300",
			"name": "卡若",
			"y": "k"
		}, {
			"id": "540321",
			"pid": "540300",
			"name": "江达",
			"y": "j"
		}, {
			"id": "540322",
			"pid": "540300",
			"name": "贡觉",
			"y": "g"
		}, {
			"id": "540323",
			"pid": "540300",
			"name": "类乌齐",
			"y": "l"
		}, {
			"id": "540324",
			"pid": "540300",
			"name": "丁青",
			"y": "d"
		}, {
			"id": "540325",
			"pid": "540300",
			"name": "察雅",
			"y": "c"
		}, {
			"id": "540326",
			"pid": "540300",
			"name": "八宿",
			"y": "b"
		}, {
			"id": "540327",
			"pid": "540300",
			"name": "左贡",
			"y": "z"
		}, {
			"id": "540328",
			"pid": "540300",
			"name": "芒康",
			"y": "m"
		}, {
			"id": "540329",
			"pid": "540300",
			"name": "洛隆",
			"y": "l"
		}, {
			"id": "540330",
			"pid": "540300",
			"name": "边坝",
			"y": "b"
		}]
	}, {
		"id": "540400",
		"pid": "540000",
		"name": "林芝",
		"y": "l",
		"child": [{
			"id": "540402",
			"pid": "540400",
			"name": "巴宜",
			"y": "b"
		}, {
			"id": "540421",
			"pid": "540400",
			"name": "工布江达",
			"y": "g"
		}, {
			"id": "540422",
			"pid": "540400",
			"name": "米林",
			"y": "m"
		}, {
			"id": "540423",
			"pid": "540400",
			"name": "墨脱",
			"y": "m"
		}, {
			"id": "540424",
			"pid": "540400",
			"name": "波密",
			"y": "b"
		}, {
			"id": "540425",
			"pid": "540400",
			"name": "察隅",
			"y": "c"
		}, {
			"id": "540426",
			"pid": "540400",
			"name": "朗县",
			"y": "l"
		}]
	}, {
		"id": "540500",
		"pid": "540000",
		"name": "山南",
		"y": "s",
		"child": [{
			"id": "540502",
			"pid": "540500",
			"name": "乃东",
			"y": "n"
		}, {
			"id": "540521",
			"pid": "540500",
			"name": "扎囊",
			"y": "z"
		}, {
			"id": "540522",
			"pid": "540500",
			"name": "贡嘎",
			"y": "g"
		}, {
			"id": "540523",
			"pid": "540500",
			"name": "桑日",
			"y": "s"
		}, {
			"id": "540524",
			"pid": "540500",
			"name": "琼结",
			"y": "q"
		}, {
			"id": "540525",
			"pid": "540500",
			"name": "曲松",
			"y": "q"
		}, {
			"id": "540526",
			"pid": "540500",
			"name": "措美",
			"y": "c"
		}, {
			"id": "540527",
			"pid": "540500",
			"name": "洛扎",
			"y": "l"
		}, {
			"id": "540528",
			"pid": "540500",
			"name": "加查",
			"y": "j"
		}, {
			"id": "540529",
			"pid": "540500",
			"name": "隆子",
			"y": "l"
		}, {
			"id": "540530",
			"pid": "540500",
			"name": "错那",
			"y": "c"
		}, {
			"id": "540531",
			"pid": "540500",
			"name": "浪卡子",
			"y": "l"
		}]
	}, {
		"id": "540600",
		"pid": "540000",
		"name": "那曲",
		"y": "n",
		"child": [{
			"id": "540602",
			"pid": "540600",
			"name": "色尼",
			"y": "s"
		}, {
			"id": "540621",
			"pid": "540600",
			"name": "嘉黎",
			"y": "j"
		}, {
			"id": "540622",
			"pid": "540600",
			"name": "比如",
			"y": "b"
		}, {
			"id": "540623",
			"pid": "540600",
			"name": "聂荣",
			"y": "n"
		}, {
			"id": "540624",
			"pid": "540600",
			"name": "安多",
			"y": "a"
		}, {
			"id": "540625",
			"pid": "540600",
			"name": "申扎",
			"y": "s"
		}, {
			"id": "540626",
			"pid": "540600",
			"name": "索县",
			"y": "s"
		}, {
			"id": "540627",
			"pid": "540600",
			"name": "班戈",
			"y": "b"
		}, {
			"id": "540628",
			"pid": "540600",
			"name": "巴青",
			"y": "b"
		}, {
			"id": "540629",
			"pid": "540600",
			"name": "尼玛",
			"y": "n"
		}, {
			"id": "540630",
			"pid": "540600",
			"name": "双湖",
			"y": "s"
		}]
	}, {
		"id": "542500",
		"pid": "540000",
		"name": "阿里",
		"y": "a",
		"child": [{
			"id": "542521",
			"pid": "542500",
			"name": "普兰",
			"y": "p"
		}, {
			"id": "542522",
			"pid": "542500",
			"name": "札达",
			"y": "z"
		}, {
			"id": "542523",
			"pid": "542500",
			"name": "噶尔",
			"y": "g"
		}, {
			"id": "542524",
			"pid": "542500",
			"name": "日土",
			"y": "r"
		}, {
			"id": "542525",
			"pid": "542500",
			"name": "革吉",
			"y": "g"
		}, {
			"id": "542526",
			"pid": "542500",
			"name": "改则",
			"y": "g"
		}, {
			"id": "542527",
			"pid": "542500",
			"name": "措勤",
			"y": "c"
		}]
	}]
}, {
	"id": "610000",
	"pid": "0",
	"name": "陕西",
	"y": "s",
	"child": [{
		"id": "610100",
		"pid": "610000",
		"name": "西安",
		"y": "x",
		"child": [{
			"id": "610102",
			"pid": "610100",
			"name": "新城",
			"y": "x"
		}, {
			"id": "610103",
			"pid": "610100",
			"name": "碑林",
			"y": "b"
		}, {
			"id": "610104",
			"pid": "610100",
			"name": "莲湖",
			"y": "l"
		}, {
			"id": "610111",
			"pid": "610100",
			"name": "灞桥",
			"y": "b"
		}, {
			"id": "610112",
			"pid": "610100",
			"name": "未央",
			"y": "w"
		}, {
			"id": "610113",
			"pid": "610100",
			"name": "雁塔",
			"y": "y"
		}, {
			"id": "610114",
			"pid": "610100",
			"name": "阎良",
			"y": "y"
		}, {
			"id": "610115",
			"pid": "610100",
			"name": "临潼",
			"y": "l"
		}, {
			"id": "610116",
			"pid": "610100",
			"name": "长安",
			"y": "c"
		}, {
			"id": "610117",
			"pid": "610100",
			"name": "高陵",
			"y": "g"
		}, {
			"id": "610118",
			"pid": "610100",
			"name": "鄠邑",
			"y": "h"
		}, {
			"id": "610122",
			"pid": "610100",
			"name": "蓝田",
			"y": "l"
		}, {
			"id": "610124",
			"pid": "610100",
			"name": "周至",
			"y": "z"
		}]
	}, {
		"id": "610200",
		"pid": "610000",
		"name": "铜川",
		"y": "t",
		"child": [{
			"id": "610202",
			"pid": "610200",
			"name": "王益",
			"y": "w"
		}, {
			"id": "610203",
			"pid": "610200",
			"name": "印台",
			"y": "y"
		}, {
			"id": "610204",
			"pid": "610200",
			"name": "耀州",
			"y": "y"
		}, {
			"id": "610222",
			"pid": "610200",
			"name": "宜君",
			"y": "y"
		}]
	}, {
		"id": "610300",
		"pid": "610000",
		"name": "宝鸡",
		"y": "b",
		"child": [{
			"id": "610302",
			"pid": "610300",
			"name": "渭滨",
			"y": "w"
		}, {
			"id": "610303",
			"pid": "610300",
			"name": "金台",
			"y": "j"
		}, {
			"id": "610304",
			"pid": "610300",
			"name": "陈仓",
			"y": "c"
		}, {
			"id": "610322",
			"pid": "610300",
			"name": "凤翔",
			"y": "f"
		}, {
			"id": "610323",
			"pid": "610300",
			"name": "岐山",
			"y": "q"
		}, {
			"id": "610324",
			"pid": "610300",
			"name": "扶风",
			"y": "f"
		}, {
			"id": "610326",
			"pid": "610300",
			"name": "眉县",
			"y": "m"
		}, {
			"id": "610327",
			"pid": "610300",
			"name": "陇县",
			"y": "l"
		}, {
			"id": "610328",
			"pid": "610300",
			"name": "千阳",
			"y": "q"
		}, {
			"id": "610329",
			"pid": "610300",
			"name": "麟游",
			"y": "l"
		}, {
			"id": "610330",
			"pid": "610300",
			"name": "凤县",
			"y": "f"
		}, {
			"id": "610331",
			"pid": "610300",
			"name": "太白",
			"y": "t"
		}]
	}, {
		"id": "610400",
		"pid": "610000",
		"name": "咸阳",
		"y": "x",
		"child": [{
			"id": "610402",
			"pid": "610400",
			"name": "秦都",
			"y": "q"
		}, {
			"id": "610403",
			"pid": "610400",
			"name": "杨陵",
			"y": "y"
		}, {
			"id": "610404",
			"pid": "610400",
			"name": "渭城",
			"y": "w"
		}, {
			"id": "610422",
			"pid": "610400",
			"name": "三原",
			"y": "s"
		}, {
			"id": "610423",
			"pid": "610400",
			"name": "泾阳",
			"y": "j"
		}, {
			"id": "610424",
			"pid": "610400",
			"name": "乾县",
			"y": "q"
		}, {
			"id": "610425",
			"pid": "610400",
			"name": "礼泉",
			"y": "l"
		}, {
			"id": "610426",
			"pid": "610400",
			"name": "永寿",
			"y": "y"
		}, {
			"id": "610428",
			"pid": "610400",
			"name": "长武",
			"y": "c"
		}, {
			"id": "610429",
			"pid": "610400",
			"name": "旬邑",
			"y": "x"
		}, {
			"id": "610430",
			"pid": "610400",
			"name": "淳化",
			"y": "c"
		}, {
			"id": "610431",
			"pid": "610400",
			"name": "武功",
			"y": "w"
		}, {
			"id": "610481",
			"pid": "610400",
			"name": "兴平",
			"y": "x"
		}, {
			"id": "610482",
			"pid": "610400",
			"name": "彬州",
			"y": "b"
		}]
	}, {
		"id": "610500",
		"pid": "610000",
		"name": "渭南",
		"y": "w",
		"child": [{
			"id": "610502",
			"pid": "610500",
			"name": "临渭",
			"y": "l"
		}, {
			"id": "610503",
			"pid": "610500",
			"name": "华州",
			"y": "h"
		}, {
			"id": "610522",
			"pid": "610500",
			"name": "潼关",
			"y": "t"
		}, {
			"id": "610523",
			"pid": "610500",
			"name": "大荔",
			"y": "d"
		}, {
			"id": "610524",
			"pid": "610500",
			"name": "合阳",
			"y": "h"
		}, {
			"id": "610525",
			"pid": "610500",
			"name": "澄城",
			"y": "c"
		}, {
			"id": "610526",
			"pid": "610500",
			"name": "蒲城",
			"y": "p"
		}, {
			"id": "610527",
			"pid": "610500",
			"name": "白水",
			"y": "b"
		}, {
			"id": "610528",
			"pid": "610500",
			"name": "富平",
			"y": "f"
		}, {
			"id": "610581",
			"pid": "610500",
			"name": "韩城",
			"y": "h"
		}, {
			"id": "610582",
			"pid": "610500",
			"name": "华阴",
			"y": "h"
		}]
	}, {
		"id": "610600",
		"pid": "610000",
		"name": "延安",
		"y": "y",
		"child": [{
			"id": "610602",
			"pid": "610600",
			"name": "宝塔",
			"y": "b"
		}, {
			"id": "610603",
			"pid": "610600",
			"name": "安塞",
			"y": "a"
		}, {
			"id": "610621",
			"pid": "610600",
			"name": "延长",
			"y": "y"
		}, {
			"id": "610622",
			"pid": "610600",
			"name": "延川",
			"y": "y"
		}, {
			"id": "610625",
			"pid": "610600",
			"name": "志丹",
			"y": "z"
		}, {
			"id": "610626",
			"pid": "610600",
			"name": "吴起",
			"y": "w"
		}, {
			"id": "610627",
			"pid": "610600",
			"name": "甘泉",
			"y": "g"
		}, {
			"id": "610628",
			"pid": "610600",
			"name": "富县",
			"y": "f"
		}, {
			"id": "610629",
			"pid": "610600",
			"name": "洛川",
			"y": "l"
		}, {
			"id": "610630",
			"pid": "610600",
			"name": "宜川",
			"y": "y"
		}, {
			"id": "610631",
			"pid": "610600",
			"name": "黄龙",
			"y": "h"
		}, {
			"id": "610632",
			"pid": "610600",
			"name": "黄陵",
			"y": "h"
		}, {
			"id": "610681",
			"pid": "610600",
			"name": "子长",
			"y": "z"
		}]
	}, {
		"id": "610700",
		"pid": "610000",
		"name": "汉中",
		"y": "h",
		"child": [{
			"id": "610702",
			"pid": "610700",
			"name": "汉台",
			"y": "h"
		}, {
			"id": "610703",
			"pid": "610700",
			"name": "南郑",
			"y": "n"
		}, {
			"id": "610722",
			"pid": "610700",
			"name": "城固",
			"y": "c"
		}, {
			"id": "610723",
			"pid": "610700",
			"name": "洋县",
			"y": "y"
		}, {
			"id": "610724",
			"pid": "610700",
			"name": "西乡",
			"y": "x"
		}, {
			"id": "610725",
			"pid": "610700",
			"name": "勉县",
			"y": "m"
		}, {
			"id": "610726",
			"pid": "610700",
			"name": "宁强",
			"y": "n"
		}, {
			"id": "610727",
			"pid": "610700",
			"name": "略阳",
			"y": "l"
		}, {
			"id": "610728",
			"pid": "610700",
			"name": "镇巴",
			"y": "z"
		}, {
			"id": "610729",
			"pid": "610700",
			"name": "留坝",
			"y": "l"
		}, {
			"id": "610730",
			"pid": "610700",
			"name": "佛坪",
			"y": "f"
		}]
	}, {
		"id": "610800",
		"pid": "610000",
		"name": "榆林",
		"y": "y",
		"child": [{
			"id": "610802",
			"pid": "610800",
			"name": "榆阳",
			"y": "y"
		}, {
			"id": "610803",
			"pid": "610800",
			"name": "横山",
			"y": "h"
		}, {
			"id": "610822",
			"pid": "610800",
			"name": "府谷",
			"y": "f"
		}, {
			"id": "610824",
			"pid": "610800",
			"name": "靖边",
			"y": "j"
		}, {
			"id": "610825",
			"pid": "610800",
			"name": "定边",
			"y": "d"
		}, {
			"id": "610826",
			"pid": "610800",
			"name": "绥德",
			"y": "s"
		}, {
			"id": "610827",
			"pid": "610800",
			"name": "米脂",
			"y": "m"
		}, {
			"id": "610828",
			"pid": "610800",
			"name": "佳县",
			"y": "j"
		}, {
			"id": "610829",
			"pid": "610800",
			"name": "吴堡",
			"y": "w"
		}, {
			"id": "610830",
			"pid": "610800",
			"name": "清涧",
			"y": "q"
		}, {
			"id": "610831",
			"pid": "610800",
			"name": "子洲",
			"y": "z"
		}, {
			"id": "610881",
			"pid": "610800",
			"name": "神木",
			"y": "s"
		}]
	}, {
		"id": "610900",
		"pid": "610000",
		"name": "安康",
		"y": "a",
		"child": [{
			"id": "610902",
			"pid": "610900",
			"name": "汉滨",
			"y": "h"
		}, {
			"id": "610921",
			"pid": "610900",
			"name": "汉阴",
			"y": "h"
		}, {
			"id": "610922",
			"pid": "610900",
			"name": "石泉",
			"y": "s"
		}, {
			"id": "610923",
			"pid": "610900",
			"name": "宁陕",
			"y": "n"
		}, {
			"id": "610924",
			"pid": "610900",
			"name": "紫阳",
			"y": "z"
		}, {
			"id": "610925",
			"pid": "610900",
			"name": "岚皋",
			"y": "l"
		}, {
			"id": "610926",
			"pid": "610900",
			"name": "平利",
			"y": "p"
		}, {
			"id": "610927",
			"pid": "610900",
			"name": "镇坪",
			"y": "z"
		}, {
			"id": "610928",
			"pid": "610900",
			"name": "旬阳",
			"y": "x"
		}, {
			"id": "610929",
			"pid": "610900",
			"name": "白河",
			"y": "b"
		}]
	}, {
		"id": "611000",
		"pid": "610000",
		"name": "商洛",
		"y": "s",
		"child": [{
			"id": "611002",
			"pid": "611000",
			"name": "商州",
			"y": "s"
		}, {
			"id": "611021",
			"pid": "611000",
			"name": "洛南",
			"y": "l"
		}, {
			"id": "611022",
			"pid": "611000",
			"name": "丹凤",
			"y": "d"
		}, {
			"id": "611023",
			"pid": "611000",
			"name": "商南",
			"y": "s"
		}, {
			"id": "611024",
			"pid": "611000",
			"name": "山阳",
			"y": "s"
		}, {
			"id": "611025",
			"pid": "611000",
			"name": "镇安",
			"y": "z"
		}, {
			"id": "611026",
			"pid": "611000",
			"name": "柞水",
			"y": "z"
		}]
	}]
}, {
	"id": "620000",
	"pid": "0",
	"name": "甘肃",
	"y": "g",
	"child": [{
		"id": "620100",
		"pid": "620000",
		"name": "兰州",
		"y": "l",
		"child": [{
			"id": "620102",
			"pid": "620100",
			"name": "城关",
			"y": "c"
		}, {
			"id": "620103",
			"pid": "620100",
			"name": "七里河",
			"y": "q"
		}, {
			"id": "620104",
			"pid": "620100",
			"name": "西固",
			"y": "x"
		}, {
			"id": "620105",
			"pid": "620100",
			"name": "安宁",
			"y": "a"
		}, {
			"id": "620111",
			"pid": "620100",
			"name": "红古",
			"y": "h"
		}, {
			"id": "620121",
			"pid": "620100",
			"name": "永登",
			"y": "y"
		}, {
			"id": "620122",
			"pid": "620100",
			"name": "皋兰",
			"y": "g"
		}, {
			"id": "620123",
			"pid": "620100",
			"name": "榆中",
			"y": "y"
		}]
	}, {
		"id": "620200",
		"pid": "620000",
		"name": "嘉峪关",
		"y": "j",
		"child": [{
			"id": "620201",
			"pid": "620200",
			"name": "嘉峪关",
			"y": "j"
		}]
	}, {
		"id": "620300",
		"pid": "620000",
		"name": "金昌",
		"y": "j",
		"child": [{
			"id": "620302",
			"pid": "620300",
			"name": "金川",
			"y": "j"
		}, {
			"id": "620321",
			"pid": "620300",
			"name": "永昌",
			"y": "y"
		}]
	}, {
		"id": "620400",
		"pid": "620000",
		"name": "白银",
		"y": "b",
		"child": [{
			"id": "620402",
			"pid": "620400",
			"name": "白银区",
			"y": "b"
		}, {
			"id": "620403",
			"pid": "620400",
			"name": "平川",
			"y": "p"
		}, {
			"id": "620421",
			"pid": "620400",
			"name": "靖远",
			"y": "j"
		}, {
			"id": "620422",
			"pid": "620400",
			"name": "会宁",
			"y": "h"
		}, {
			"id": "620423",
			"pid": "620400",
			"name": "景泰",
			"y": "j"
		}]
	}, {
		"id": "620500",
		"pid": "620000",
		"name": "天水",
		"y": "t",
		"child": [{
			"id": "620502",
			"pid": "620500",
			"name": "秦州",
			"y": "q"
		}, {
			"id": "620503",
			"pid": "620500",
			"name": "麦积",
			"y": "m"
		}, {
			"id": "620521",
			"pid": "620500",
			"name": "清水",
			"y": "q"
		}, {
			"id": "620522",
			"pid": "620500",
			"name": "秦安",
			"y": "q"
		}, {
			"id": "620523",
			"pid": "620500",
			"name": "甘谷",
			"y": "g"
		}, {
			"id": "620524",
			"pid": "620500",
			"name": "武山",
			"y": "w"
		}, {
			"id": "620525",
			"pid": "620500",
			"name": "张家川",
			"y": "z"
		}]
	}, {
		"id": "620600",
		"pid": "620000",
		"name": "武威",
		"y": "w",
		"child": [{
			"id": "620602",
			"pid": "620600",
			"name": "凉州",
			"y": "l"
		}, {
			"id": "620621",
			"pid": "620600",
			"name": "民勤",
			"y": "m"
		}, {
			"id": "620622",
			"pid": "620600",
			"name": "古浪",
			"y": "g"
		}, {
			"id": "620623",
			"pid": "620600",
			"name": "天祝",
			"y": "t"
		}]
	}, {
		"id": "620700",
		"pid": "620000",
		"name": "张掖",
		"y": "z",
		"child": [{
			"id": "620702",
			"pid": "620700",
			"name": "甘州",
			"y": "g"
		}, {
			"id": "620721",
			"pid": "620700",
			"name": "肃南",
			"y": "s"
		}, {
			"id": "620722",
			"pid": "620700",
			"name": "民乐",
			"y": "m"
		}, {
			"id": "620723",
			"pid": "620700",
			"name": "临泽",
			"y": "l"
		}, {
			"id": "620724",
			"pid": "620700",
			"name": "高台",
			"y": "g"
		}, {
			"id": "620725",
			"pid": "620700",
			"name": "山丹",
			"y": "s"
		}]
	}, {
		"id": "620800",
		"pid": "620000",
		"name": "平凉",
		"y": "p",
		"child": [{
			"id": "620802",
			"pid": "620800",
			"name": "崆峒",
			"y": "k"
		}, {
			"id": "620821",
			"pid": "620800",
			"name": "泾川",
			"y": "j"
		}, {
			"id": "620822",
			"pid": "620800",
			"name": "灵台",
			"y": "l"
		}, {
			"id": "620823",
			"pid": "620800",
			"name": "崇信",
			"y": "c"
		}, {
			"id": "620825",
			"pid": "620800",
			"name": "庄浪",
			"y": "z"
		}, {
			"id": "620826",
			"pid": "620800",
			"name": "静宁",
			"y": "j"
		}, {
			"id": "620881",
			"pid": "620800",
			"name": "华亭",
			"y": "h"
		}]
	}, {
		"id": "620900",
		"pid": "620000",
		"name": "酒泉",
		"y": "j",
		"child": [{
			"id": "620902",
			"pid": "620900",
			"name": "肃州",
			"y": "s"
		}, {
			"id": "620921",
			"pid": "620900",
			"name": "金塔",
			"y": "j"
		}, {
			"id": "620922",
			"pid": "620900",
			"name": "瓜州",
			"y": "g"
		}, {
			"id": "620923",
			"pid": "620900",
			"name": "肃北",
			"y": "s"
		}, {
			"id": "620924",
			"pid": "620900",
			"name": "阿克塞",
			"y": "a"
		}, {
			"id": "620981",
			"pid": "620900",
			"name": "玉门",
			"y": "y"
		}, {
			"id": "620982",
			"pid": "620900",
			"name": "敦煌",
			"y": "d"
		}]
	}, {
		"id": "621000",
		"pid": "620000",
		"name": "庆阳",
		"y": "q",
		"child": [{
			"id": "621002",
			"pid": "621000",
			"name": "西峰",
			"y": "x"
		}, {
			"id": "621021",
			"pid": "621000",
			"name": "庆城",
			"y": "q"
		}, {
			"id": "621022",
			"pid": "621000",
			"name": "环县",
			"y": "h"
		}, {
			"id": "621023",
			"pid": "621000",
			"name": "华池",
			"y": "h"
		}, {
			"id": "621024",
			"pid": "621000",
			"name": "合水",
			"y": "h"
		}, {
			"id": "621025",
			"pid": "621000",
			"name": "正宁",
			"y": "z"
		}, {
			"id": "621026",
			"pid": "621000",
			"name": "宁县",
			"y": "n"
		}, {
			"id": "621027",
			"pid": "621000",
			"name": "镇原",
			"y": "z"
		}]
	}, {
		"id": "621100",
		"pid": "620000",
		"name": "定西",
		"y": "d",
		"child": [{
			"id": "621102",
			"pid": "621100",
			"name": "安定",
			"y": "a"
		}, {
			"id": "621121",
			"pid": "621100",
			"name": "通渭",
			"y": "t"
		}, {
			"id": "621122",
			"pid": "621100",
			"name": "陇西",
			"y": "l"
		}, {
			"id": "621123",
			"pid": "621100",
			"name": "渭源",
			"y": "w"
		}, {
			"id": "621124",
			"pid": "621100",
			"name": "临洮",
			"y": "l"
		}, {
			"id": "621125",
			"pid": "621100",
			"name": "漳县",
			"y": "z"
		}, {
			"id": "621126",
			"pid": "621100",
			"name": "岷县",
			"y": "m"
		}]
	}, {
		"id": "621200",
		"pid": "620000",
		"name": "陇南",
		"y": "l",
		"child": [{
			"id": "621202",
			"pid": "621200",
			"name": "武都",
			"y": "w"
		}, {
			"id": "621221",
			"pid": "621200",
			"name": "成县",
			"y": "c"
		}, {
			"id": "621222",
			"pid": "621200",
			"name": "文县",
			"y": "w"
		}, {
			"id": "621223",
			"pid": "621200",
			"name": "宕昌",
			"y": "t"
		}, {
			"id": "621224",
			"pid": "621200",
			"name": "康县",
			"y": "k"
		}, {
			"id": "621225",
			"pid": "621200",
			"name": "西和",
			"y": "x"
		}, {
			"id": "621226",
			"pid": "621200",
			"name": "礼县",
			"y": "l"
		}, {
			"id": "621227",
			"pid": "621200",
			"name": "徽县",
			"y": "h"
		}, {
			"id": "621228",
			"pid": "621200",
			"name": "两当",
			"y": "l"
		}]
	}, {
		"id": "622900",
		"pid": "620000",
		"name": "临夏",
		"y": "l",
		"child": [{
			"id": "622901",
			"pid": "622900",
			"name": "临夏市",
			"y": "l"
		}, {
			"id": "622921",
			"pid": "622900",
			"name": "临夏县",
			"y": "l"
		}, {
			"id": "622922",
			"pid": "622900",
			"name": "康乐",
			"y": "k"
		}, {
			"id": "622923",
			"pid": "622900",
			"name": "永靖",
			"y": "y"
		}, {
			"id": "622924",
			"pid": "622900",
			"name": "广河",
			"y": "g"
		}, {
			"id": "622925",
			"pid": "622900",
			"name": "和政",
			"y": "h"
		}, {
			"id": "622926",
			"pid": "622900",
			"name": "东乡族自治县",
			"y": "d"
		}, {
			"id": "622927",
			"pid": "622900",
			"name": "积石山",
			"y": "j"
		}]
	}, {
		"id": "623000",
		"pid": "620000",
		"name": "甘南",
		"y": "g",
		"child": [{
			"id": "623001",
			"pid": "623000",
			"name": "合作",
			"y": "h"
		}, {
			"id": "623021",
			"pid": "623000",
			"name": "临潭",
			"y": "l"
		}, {
			"id": "623022",
			"pid": "623000",
			"name": "卓尼",
			"y": "z"
		}, {
			"id": "623023",
			"pid": "623000",
			"name": "舟曲",
			"y": "z"
		}, {
			"id": "623024",
			"pid": "623000",
			"name": "迭部",
			"y": "d"
		}, {
			"id": "623025",
			"pid": "623000",
			"name": "玛曲",
			"y": "m"
		}, {
			"id": "623026",
			"pid": "623000",
			"name": "碌曲",
			"y": "l"
		}, {
			"id": "623027",
			"pid": "623000",
			"name": "夏河",
			"y": "x"
		}]
	}]
}, {
	"id": "630000",
	"pid": "0",
	"name": "青海",
	"y": "q",
	"child": [{
		"id": "630100",
		"pid": "630000",
		"name": "西宁",
		"y": "x",
		"child": [{
			"id": "630102",
			"pid": "630100",
			"name": "城东",
			"y": "c"
		}, {
			"id": "630103",
			"pid": "630100",
			"name": "城中",
			"y": "c"
		}, {
			"id": "630104",
			"pid": "630100",
			"name": "城西",
			"y": "c"
		}, {
			"id": "630105",
			"pid": "630100",
			"name": "城北",
			"y": "c"
		}, {
			"id": "630106",
			"pid": "630100",
			"name": "湟中",
			"y": "h"
		}, {
			"id": "630121",
			"pid": "630100",
			"name": "大通",
			"y": "d"
		}, {
			"id": "630123",
			"pid": "630100",
			"name": "湟源",
			"y": "h"
		}]
	}, {
		"id": "630200",
		"pid": "630000",
		"name": "海东",
		"y": "h",
		"child": [{
			"id": "630202",
			"pid": "630200",
			"name": "乐都",
			"y": "l"
		}, {
			"id": "630203",
			"pid": "630200",
			"name": "平安",
			"y": "p"
		}, {
			"id": "630222",
			"pid": "630200",
			"name": "民和",
			"y": "m"
		}, {
			"id": "630223",
			"pid": "630200",
			"name": "互助",
			"y": "h"
		}, {
			"id": "630224",
			"pid": "630200",
			"name": "化隆",
			"y": "h"
		}, {
			"id": "630225",
			"pid": "630200",
			"name": "循化",
			"y": "x"
		}]
	}, {
		"id": "632200",
		"pid": "630000",
		"name": "海北",
		"y": "h",
		"child": [{
			"id": "632221",
			"pid": "632200",
			"name": "门源",
			"y": "m"
		}, {
			"id": "632222",
			"pid": "632200",
			"name": "祁连",
			"y": "q"
		}, {
			"id": "632223",
			"pid": "632200",
			"name": "海晏",
			"y": "h"
		}, {
			"id": "632224",
			"pid": "632200",
			"name": "刚察",
			"y": "g"
		}]
	}, {
		"id": "632300",
		"pid": "630000",
		"name": "黄南",
		"y": "h",
		"child": [{
			"id": "632301",
			"pid": "632300",
			"name": "同仁",
			"y": "t"
		}, {
			"id": "632322",
			"pid": "632300",
			"name": "尖扎",
			"y": "j"
		}, {
			"id": "632323",
			"pid": "632300",
			"name": "泽库",
			"y": "z"
		}, {
			"id": "632324",
			"pid": "632300",
			"name": "河南",
			"y": "h"
		}]
	}, {
		"id": "632500",
		"pid": "630000",
		"name": "海南",
		"y": "h",
		"child": [{
			"id": "632521",
			"pid": "632500",
			"name": "共和",
			"y": "g"
		}, {
			"id": "632522",
			"pid": "632500",
			"name": "同德",
			"y": "t"
		}, {
			"id": "632523",
			"pid": "632500",
			"name": "贵德",
			"y": "g"
		}, {
			"id": "632524",
			"pid": "632500",
			"name": "兴海",
			"y": "x"
		}, {
			"id": "632525",
			"pid": "632500",
			"name": "贵南",
			"y": "g"
		}]
	}, {
		"id": "632600",
		"pid": "630000",
		"name": "果洛",
		"y": "g",
		"child": [{
			"id": "632621",
			"pid": "632600",
			"name": "玛沁",
			"y": "m"
		}, {
			"id": "632622",
			"pid": "632600",
			"name": "班玛",
			"y": "b"
		}, {
			"id": "632623",
			"pid": "632600",
			"name": "甘德",
			"y": "g"
		}, {
			"id": "632624",
			"pid": "632600",
			"name": "达日",
			"y": "d"
		}, {
			"id": "632625",
			"pid": "632600",
			"name": "久治",
			"y": "j"
		}, {
			"id": "632626",
			"pid": "632600",
			"name": "玛多",
			"y": "m"
		}]
	}, {
		"id": "632700",
		"pid": "630000",
		"name": "玉树",
		"y": "y",
		"child": [{
			"id": "632701",
			"pid": "632700",
			"name": "玉树市",
			"y": "y"
		}, {
			"id": "632722",
			"pid": "632700",
			"name": "杂多",
			"y": "z"
		}, {
			"id": "632723",
			"pid": "632700",
			"name": "称多",
			"y": "c"
		}, {
			"id": "632724",
			"pid": "632700",
			"name": "治多",
			"y": "z"
		}, {
			"id": "632725",
			"pid": "632700",
			"name": "囊谦",
			"y": "n"
		}, {
			"id": "632726",
			"pid": "632700",
			"name": "曲麻莱",
			"y": "q"
		}]
	}, {
		"id": "632800",
		"pid": "630000",
		"name": "海西",
		"y": "h",
		"child": [{
			"id": "632801",
			"pid": "632800",
			"name": "格尔木",
			"y": "g"
		}, {
			"id": "632802",
			"pid": "632800",
			"name": "德令哈",
			"y": "d"
		}, {
			"id": "632803",
			"pid": "632800",
			"name": "茫崖",
			"y": "m"
		}, {
			"id": "632821",
			"pid": "632800",
			"name": "乌兰",
			"y": "w"
		}, {
			"id": "632822",
			"pid": "632800",
			"name": "都兰",
			"y": "d"
		}, {
			"id": "632823",
			"pid": "632800",
			"name": "天峻",
			"y": "t"
		}, {
			"id": "632857",
			"pid": "632800",
			"name": "大柴旦行政委员会",
			"y": "d"
		}]
	}]
}, {
	"id": "640000",
	"pid": "0",
	"name": "宁夏",
	"y": "n",
	"child": [{
		"id": "640100",
		"pid": "640000",
		"name": "银川",
		"y": "y",
		"child": [{
			"id": "640104",
			"pid": "640100",
			"name": "兴庆",
			"y": "x"
		}, {
			"id": "640105",
			"pid": "640100",
			"name": "西夏",
			"y": "x"
		}, {
			"id": "640106",
			"pid": "640100",
			"name": "金凤",
			"y": "j"
		}, {
			"id": "640121",
			"pid": "640100",
			"name": "永宁",
			"y": "y"
		}, {
			"id": "640122",
			"pid": "640100",
			"name": "贺兰",
			"y": "h"
		}, {
			"id": "640181",
			"pid": "640100",
			"name": "灵武",
			"y": "l"
		}]
	}, {
		"id": "640200",
		"pid": "640000",
		"name": "石嘴山",
		"y": "s",
		"child": [{
			"id": "640202",
			"pid": "640200",
			"name": "大武口",
			"y": "d"
		}, {
			"id": "640205",
			"pid": "640200",
			"name": "惠农",
			"y": "h"
		}, {
			"id": "640221",
			"pid": "640200",
			"name": "平罗",
			"y": "p"
		}]
	}, {
		"id": "640300",
		"pid": "640000",
		"name": "吴忠",
		"y": "w",
		"child": [{
			"id": "640302",
			"pid": "640300",
			"name": "利通",
			"y": "l"
		}, {
			"id": "640303",
			"pid": "640300",
			"name": "红寺堡",
			"y": "h"
		}, {
			"id": "640323",
			"pid": "640300",
			"name": "盐池",
			"y": "y"
		}, {
			"id": "640324",
			"pid": "640300",
			"name": "同心",
			"y": "t"
		}, {
			"id": "640381",
			"pid": "640300",
			"name": "青铜峡",
			"y": "q"
		}]
	}, {
		"id": "640400",
		"pid": "640000",
		"name": "固原",
		"y": "g",
		"child": [{
			"id": "640402",
			"pid": "640400",
			"name": "原州",
			"y": "y"
		}, {
			"id": "640422",
			"pid": "640400",
			"name": "西吉",
			"y": "x"
		}, {
			"id": "640423",
			"pid": "640400",
			"name": "隆德",
			"y": "l"
		}, {
			"id": "640424",
			"pid": "640400",
			"name": "泾源",
			"y": "j"
		}, {
			"id": "640425",
			"pid": "640400",
			"name": "彭阳",
			"y": "p"
		}]
	}, {
		"id": "640500",
		"pid": "640000",
		"name": "中卫",
		"y": "z",
		"child": [{
			"id": "640502",
			"pid": "640500",
			"name": "沙坡头",
			"y": "s"
		}, {
			"id": "640521",
			"pid": "640500",
			"name": "中宁",
			"y": "z"
		}, {
			"id": "640522",
			"pid": "640500",
			"name": "海原",
			"y": "h"
		}]
	}]
}, {
	"id": "650000",
	"pid": "0",
	"name": "新疆",
	"y": "x",
	"child": [{
		"id": "650100",
		"pid": "650000",
		"name": "乌鲁木齐",
		"y": "w",
		"child": [{
			"id": "650102",
			"pid": "650100",
			"name": "天山",
			"y": "t"
		}, {
			"id": "650103",
			"pid": "650100",
			"name": "沙依巴克区",
			"y": "s"
		}, {
			"id": "650104",
			"pid": "650100",
			"name": "新市",
			"y": "x"
		}, {
			"id": "650105",
			"pid": "650100",
			"name": "水磨沟",
			"y": "s"
		}, {
			"id": "650106",
			"pid": "650100",
			"name": "头屯河",
			"y": "t"
		}, {
			"id": "650107",
			"pid": "650100",
			"name": "达坂城",
			"y": "d"
		}, {
			"id": "650109",
			"pid": "650100",
			"name": "米东",
			"y": "m"
		}, {
			"id": "650121",
			"pid": "650100",
			"name": "乌鲁木齐县",
			"y": "w"
		}]
	}, {
		"id": "650200",
		"pid": "650000",
		"name": "克拉玛依",
		"y": "k",
		"child": [{
			"id": "650202",
			"pid": "650200",
			"name": "独山子",
			"y": "d"
		}, {
			"id": "650203",
			"pid": "650200",
			"name": "克拉玛依区",
			"y": "k"
		}, {
			"id": "650204",
			"pid": "650200",
			"name": "白碱滩",
			"y": "b"
		}, {
			"id": "650205",
			"pid": "650200",
			"name": "乌尔禾",
			"y": "w"
		}]
	}, {
		"id": "650400",
		"pid": "650000",
		"name": "吐鲁番",
		"y": "t",
		"child": [{
			"id": "650402",
			"pid": "650400",
			"name": "高昌",
			"y": "g"
		}, {
			"id": "650421",
			"pid": "650400",
			"name": "鄯善",
			"y": "s"
		}, {
			"id": "650422",
			"pid": "650400",
			"name": "托克逊",
			"y": "t"
		}]
	}, {
		"id": "650500",
		"pid": "650000",
		"name": "哈密",
		"y": "h",
		"child": [{
			"id": "650502",
			"pid": "650500",
			"name": "伊州",
			"y": "y"
		}, {
			"id": "650521",
			"pid": "650500",
			"name": "巴里坤",
			"y": "b"
		}, {
			"id": "650522",
			"pid": "650500",
			"name": "伊吾",
			"y": "y"
		}]
	}, {
		"id": "652300",
		"pid": "650000",
		"name": "昌吉",
		"y": "c",
		"child": [{
			"id": "652301",
			"pid": "652300",
			"name": "昌吉市",
			"y": "c"
		}, {
			"id": "652302",
			"pid": "652300",
			"name": "阜康",
			"y": "f"
		}, {
			"id": "652323",
			"pid": "652300",
			"name": "呼图壁",
			"y": "h"
		}, {
			"id": "652324",
			"pid": "652300",
			"name": "玛纳斯",
			"y": "m"
		}, {
			"id": "652325",
			"pid": "652300",
			"name": "奇台",
			"y": "q"
		}, {
			"id": "652327",
			"pid": "652300",
			"name": "吉木萨尔",
			"y": "j"
		}, {
			"id": "652328",
			"pid": "652300",
			"name": "木垒",
			"y": "m"
		}]
	}, {
		"id": "652700",
		"pid": "650000",
		"name": "博尔塔拉",
		"y": "b",
		"child": [{
			"id": "652701",
			"pid": "652700",
			"name": "博乐",
			"y": "b"
		}, {
			"id": "652702",
			"pid": "652700",
			"name": "阿拉山口",
			"y": "a"
		}, {
			"id": "652722",
			"pid": "652700",
			"name": "精河",
			"y": "j"
		}, {
			"id": "652723",
			"pid": "652700",
			"name": "温泉",
			"y": "w"
		}]
	}, {
		"id": "652800",
		"pid": "650000",
		"name": "巴音郭楞",
		"y": "b",
		"child": [{
			"id": "652801",
			"pid": "652800",
			"name": "库尔勒",
			"y": "k"
		}, {
			"id": "652822",
			"pid": "652800",
			"name": "轮台",
			"y": "l"
		}, {
			"id": "652823",
			"pid": "652800",
			"name": "尉犁",
			"y": "y"
		}, {
			"id": "652824",
			"pid": "652800",
			"name": "若羌",
			"y": "r"
		}, {
			"id": "652825",
			"pid": "652800",
			"name": "且末",
			"y": "q"
		}, {
			"id": "652826",
			"pid": "652800",
			"name": "焉耆",
			"y": "y"
		}, {
			"id": "652827",
			"pid": "652800",
			"name": "和静",
			"y": "h"
		}, {
			"id": "652828",
			"pid": "652800",
			"name": "和硕",
			"y": "h"
		}, {
			"id": "652829",
			"pid": "652800",
			"name": "博湖",
			"y": "b"
		}]
	}, {
		"id": "652900",
		"pid": "650000",
		"name": "阿克苏",
		"y": "a",
		"child": [{
			"id": "652901",
			"pid": "652900",
			"name": "阿克苏市",
			"y": "a"
		}, {
			"id": "652902",
			"pid": "652900",
			"name": "库车",
			"y": "k"
		}, {
			"id": "652922",
			"pid": "652900",
			"name": "温宿",
			"y": "w"
		}, {
			"id": "652924",
			"pid": "652900",
			"name": "沙雅",
			"y": "s"
		}, {
			"id": "652925",
			"pid": "652900",
			"name": "新和",
			"y": "x"
		}, {
			"id": "652926",
			"pid": "652900",
			"name": "拜城",
			"y": "b"
		}, {
			"id": "652927",
			"pid": "652900",
			"name": "乌什",
			"y": "w"
		}, {
			"id": "652928",
			"pid": "652900",
			"name": "阿瓦提",
			"y": "a"
		}, {
			"id": "652929",
			"pid": "652900",
			"name": "柯坪",
			"y": "k"
		}]
	}, {
		"id": "653000",
		"pid": "650000",
		"name": "克孜勒苏",
		"y": "k",
		"child": [{
			"id": "653001",
			"pid": "653000",
			"name": "阿图什",
			"y": "a"
		}, {
			"id": "653022",
			"pid": "653000",
			"name": "阿克陶",
			"y": "a"
		}, {
			"id": "653023",
			"pid": "653000",
			"name": "阿合奇",
			"y": "a"
		}, {
			"id": "653024",
			"pid": "653000",
			"name": "乌恰",
			"y": "w"
		}]
	}, {
		"id": "653100",
		"pid": "650000",
		"name": "喀什",
		"y": "k",
		"child": [{
			"id": "653101",
			"pid": "653100",
			"name": "喀什市",
			"y": "k"
		}, {
			"id": "653121",
			"pid": "653100",
			"name": "疏附",
			"y": "s"
		}, {
			"id": "653122",
			"pid": "653100",
			"name": "疏勒",
			"y": "s"
		}, {
			"id": "653123",
			"pid": "653100",
			"name": "英吉沙",
			"y": "y"
		}, {
			"id": "653124",
			"pid": "653100",
			"name": "泽普",
			"y": "z"
		}, {
			"id": "653125",
			"pid": "653100",
			"name": "莎车",
			"y": "s"
		}, {
			"id": "653126",
			"pid": "653100",
			"name": "叶城",
			"y": "y"
		}, {
			"id": "653127",
			"pid": "653100",
			"name": "麦盖提",
			"y": "m"
		}, {
			"id": "653128",
			"pid": "653100",
			"name": "岳普湖",
			"y": "y"
		}, {
			"id": "653129",
			"pid": "653100",
			"name": "伽师",
			"y": "j"
		}, {
			"id": "653130",
			"pid": "653100",
			"name": "巴楚",
			"y": "b"
		}, {
			"id": "653131",
			"pid": "653100",
			"name": "塔什库尔干",
			"y": "t"
		}]
	}, {
		"id": "653200",
		"pid": "650000",
		"name": "和田",
		"y": "h",
		"child": [{
			"id": "653201",
			"pid": "653200",
			"name": "和田市",
			"y": "h"
		}, {
			"id": "653221",
			"pid": "653200",
			"name": "和田县",
			"y": "h"
		}, {
			"id": "653222",
			"pid": "653200",
			"name": "墨玉",
			"y": "m"
		}, {
			"id": "653223",
			"pid": "653200",
			"name": "皮山",
			"y": "p"
		}, {
			"id": "653224",
			"pid": "653200",
			"name": "洛浦",
			"y": "l"
		}, {
			"id": "653225",
			"pid": "653200",
			"name": "策勒",
			"y": "c"
		}, {
			"id": "653226",
			"pid": "653200",
			"name": "于田",
			"y": "y"
		}, {
			"id": "653227",
			"pid": "653200",
			"name": "民丰",
			"y": "m"
		}]
	}, {
		"id": "654000",
		"pid": "650000",
		"name": "伊犁",
		"y": "y",
		"child": [{
			"id": "654002",
			"pid": "654000",
			"name": "伊宁市",
			"y": "y"
		}, {
			"id": "654003",
			"pid": "654000",
			"name": "奎屯",
			"y": "k"
		}, {
			"id": "654004",
			"pid": "654000",
			"name": "霍尔果斯",
			"y": "h"
		}, {
			"id": "654021",
			"pid": "654000",
			"name": "伊宁县",
			"y": "y"
		}, {
			"id": "654022",
			"pid": "654000",
			"name": "察布查尔",
			"y": "c"
		}, {
			"id": "654023",
			"pid": "654000",
			"name": "霍城",
			"y": "h"
		}, {
			"id": "654024",
			"pid": "654000",
			"name": "巩留",
			"y": "g"
		}, {
			"id": "654025",
			"pid": "654000",
			"name": "新源",
			"y": "x"
		}, {
			"id": "654026",
			"pid": "654000",
			"name": "昭苏",
			"y": "z"
		}, {
			"id": "654027",
			"pid": "654000",
			"name": "特克斯",
			"y": "t"
		}, {
			"id": "654028",
			"pid": "654000",
			"name": "尼勒克",
			"y": "n"
		}]
	}, {
		"id": "654200",
		"pid": "650000",
		"name": "塔城",
		"y": "t",
		"child": [{
			"id": "654201",
			"pid": "654200",
			"name": "塔城市",
			"y": "t"
		}, {
			"id": "654202",
			"pid": "654200",
			"name": "乌苏",
			"y": "w"
		}, {
			"id": "654221",
			"pid": "654200",
			"name": "额敏",
			"y": "e"
		}, {
			"id": "654223",
			"pid": "654200",
			"name": "沙湾",
			"y": "s"
		}, {
			"id": "654224",
			"pid": "654200",
			"name": "托里",
			"y": "t"
		}, {
			"id": "654225",
			"pid": "654200",
			"name": "裕民",
			"y": "y"
		}, {
			"id": "654226",
			"pid": "654200",
			"name": "和布克赛尔",
			"y": "h"
		}]
	}, {
		"id": "654300",
		"pid": "650000",
		"name": "阿勒泰",
		"y": "a",
		"child": [{
			"id": "654301",
			"pid": "654300",
			"name": "阿勒泰市",
			"y": "a"
		}, {
			"id": "654321",
			"pid": "654300",
			"name": "布尔津",
			"y": "b"
		}, {
			"id": "654322",
			"pid": "654300",
			"name": "富蕴",
			"y": "f"
		}, {
			"id": "654323",
			"pid": "654300",
			"name": "福海",
			"y": "f"
		}, {
			"id": "654324",
			"pid": "654300",
			"name": "哈巴河",
			"y": "h"
		}, {
			"id": "654325",
			"pid": "654300",
			"name": "青河",
			"y": "q"
		}, {
			"id": "654326",
			"pid": "654300",
			"name": "吉木乃",
			"y": "j"
		}]
	}, {
		"id": "65900100",
		"pid": "650000",
		"name": "石河子",
		"y": "s",
		"child": []
	}, {
		"id": "65900200",
		"pid": "650000",
		"name": "阿拉尔",
		"y": "a",
		"child": []
	}, {
		"id": "65900300",
		"pid": "650000",
		"name": "图木舒克",
		"y": "t",
		"child": []
	}, {
		"id": "65900400",
		"pid": "650000",
		"name": "五家渠",
		"y": "w",
		"child": []
	}, {
		"id": "65900500",
		"pid": "650000",
		"name": "北屯",
		"y": "b",
		"child": []
	}, {
		"id": "65900600",
		"pid": "650000",
		"name": "铁门关",
		"y": "t",
		"child": []
	}, {
		"id": "65900700",
		"pid": "650000",
		"name": "双河",
		"y": "s",
		"child": []
	}, {
		"id": "65900800",
		"pid": "650000",
		"name": "可克达拉",
		"y": "k",
		"child": []
	}, {
		"id": "65900900",
		"pid": "650000",
		"name": "昆玉",
		"y": "k",
		"child": []
	}, {
		"id": "65901000",
		"pid": "650000",
		"name": "胡杨河",
		"y": "h",
		"child": []
	}]
}, {
	"id": "710000",
	"pid": "0",
	"name": "台湾",
	"y": "~3",
	"child": [{
		"id": "710100",
		"pid": "710000",
		"name": "台北",
		"y": "t",
		"child": [{
			"id": "710101",
			"pid": "710100",
			"name": "中正",
			"y": "z"
		}, {
			"id": "710102",
			"pid": "710100",
			"name": "大同",
			"y": "d"
		}, {
			"id": "710103",
			"pid": "710100",
			"name": "中山",
			"y": "z"
		}, {
			"id": "710104",
			"pid": "710100",
			"name": "松山",
			"y": "s"
		}, {
			"id": "710105",
			"pid": "710100",
			"name": "大安",
			"y": "d"
		}, {
			"id": "710106",
			"pid": "710100",
			"name": "万华",
			"y": "w"
		}, {
			"id": "710107",
			"pid": "710100",
			"name": "信义",
			"y": "x"
		}, {
			"id": "710108",
			"pid": "710100",
			"name": "士林",
			"y": "s"
		}, {
			"id": "710109",
			"pid": "710100",
			"name": "北投",
			"y": "b"
		}, {
			"id": "710110",
			"pid": "710100",
			"name": "内湖",
			"y": "n"
		}, {
			"id": "710111",
			"pid": "710100",
			"name": "南港",
			"y": "n"
		}, {
			"id": "710112",
			"pid": "710100",
			"name": "文山",
			"y": "w"
		}]
	}, {
		"id": "710200",
		"pid": "710000",
		"name": "高雄",
		"y": "g",
		"child": [{
			"id": "710201",
			"pid": "710200",
			"name": "新兴",
			"y": "x"
		}, {
			"id": "710202",
			"pid": "710200",
			"name": "前金",
			"y": "q"
		}, {
			"id": "710203",
			"pid": "710200",
			"name": "苓雅",
			"y": "l"
		}, {
			"id": "710204",
			"pid": "710200",
			"name": "盐埕",
			"y": "y"
		}, {
			"id": "710205",
			"pid": "710200",
			"name": "鼓山",
			"y": "g"
		}, {
			"id": "710206",
			"pid": "710200",
			"name": "旗津",
			"y": "q"
		}, {
			"id": "710207",
			"pid": "710200",
			"name": "前镇",
			"y": "q"
		}, {
			"id": "710208",
			"pid": "710200",
			"name": "三民",
			"y": "s"
		}, {
			"id": "710209",
			"pid": "710200",
			"name": "左营",
			"y": "z"
		}, {
			"id": "710210",
			"pid": "710200",
			"name": "楠梓",
			"y": "n"
		}, {
			"id": "710211",
			"pid": "710200",
			"name": "小港",
			"y": "x"
		}, {
			"id": "710242",
			"pid": "710200",
			"name": "仁武",
			"y": "r"
		}, {
			"id": "710243",
			"pid": "710200",
			"name": "大社",
			"y": "d"
		}, {
			"id": "710244",
			"pid": "710200",
			"name": "冈山",
			"y": "g"
		}, {
			"id": "710245",
			"pid": "710200",
			"name": "路竹",
			"y": "l"
		}, {
			"id": "710246",
			"pid": "710200",
			"name": "阿莲",
			"y": "a"
		}, {
			"id": "710247",
			"pid": "710200",
			"name": "田寮",
			"y": "t"
		}, {
			"id": "710248",
			"pid": "710200",
			"name": "燕巢",
			"y": "y"
		}, {
			"id": "710249",
			"pid": "710200",
			"name": "桥头",
			"y": "q"
		}, {
			"id": "710250",
			"pid": "710200",
			"name": "梓官",
			"y": "z"
		}, {
			"id": "710251",
			"pid": "710200",
			"name": "弥陀",
			"y": "m"
		}, {
			"id": "710252",
			"pid": "710200",
			"name": "永安",
			"y": "y"
		}, {
			"id": "710253",
			"pid": "710200",
			"name": "湖内",
			"y": "h"
		}, {
			"id": "710254",
			"pid": "710200",
			"name": "凤山",
			"y": "f"
		}, {
			"id": "710255",
			"pid": "710200",
			"name": "大寮",
			"y": "d"
		}, {
			"id": "710256",
			"pid": "710200",
			"name": "林园",
			"y": "l"
		}, {
			"id": "710257",
			"pid": "710200",
			"name": "鸟松",
			"y": "n"
		}, {
			"id": "710258",
			"pid": "710200",
			"name": "大树",
			"y": "d"
		}, {
			"id": "710259",
			"pid": "710200",
			"name": "旗山",
			"y": "q"
		}, {
			"id": "710260",
			"pid": "710200",
			"name": "美浓",
			"y": "m"
		}, {
			"id": "710261",
			"pid": "710200",
			"name": "六龟",
			"y": "l"
		}, {
			"id": "710262",
			"pid": "710200",
			"name": "内门",
			"y": "n"
		}, {
			"id": "710263",
			"pid": "710200",
			"name": "杉林",
			"y": "s"
		}, {
			"id": "710264",
			"pid": "710200",
			"name": "甲仙",
			"y": "j"
		}, {
			"id": "710265",
			"pid": "710200",
			"name": "桃源",
			"y": "t"
		}, {
			"id": "710266",
			"pid": "710200",
			"name": "那玛夏",
			"y": "n"
		}, {
			"id": "710267",
			"pid": "710200",
			"name": "茂林",
			"y": "m"
		}, {
			"id": "710268",
			"pid": "710200",
			"name": "茄萣",
			"y": "q"
		}]
	}, {
		"id": "710300",
		"pid": "710000",
		"name": "台南",
		"y": "t",
		"child": [{
			"id": "710301",
			"pid": "710300",
			"name": "中西",
			"y": "z"
		}, {
			"id": "710302",
			"pid": "710300",
			"name": "东区",
			"y": "d"
		}, {
			"id": "710303",
			"pid": "710300",
			"name": "南区",
			"y": "n"
		}, {
			"id": "710304",
			"pid": "710300",
			"name": "北区",
			"y": "b"
		}, {
			"id": "710305",
			"pid": "710300",
			"name": "安平",
			"y": "a"
		}, {
			"id": "710306",
			"pid": "710300",
			"name": "安南",
			"y": "a"
		}, {
			"id": "710339",
			"pid": "710300",
			"name": "永康",
			"y": "y"
		}, {
			"id": "710340",
			"pid": "710300",
			"name": "归仁",
			"y": "g"
		}, {
			"id": "710341",
			"pid": "710300",
			"name": "新化",
			"y": "x"
		}, {
			"id": "710342",
			"pid": "710300",
			"name": "左镇",
			"y": "z"
		}, {
			"id": "710343",
			"pid": "710300",
			"name": "玉井",
			"y": "y"
		}, {
			"id": "710344",
			"pid": "710300",
			"name": "楠西",
			"y": "n"
		}, {
			"id": "710345",
			"pid": "710300",
			"name": "南化",
			"y": "n"
		}, {
			"id": "710346",
			"pid": "710300",
			"name": "仁德",
			"y": "r"
		}, {
			"id": "710347",
			"pid": "710300",
			"name": "关庙",
			"y": "g"
		}, {
			"id": "710348",
			"pid": "710300",
			"name": "龙崎",
			"y": "l"
		}, {
			"id": "710349",
			"pid": "710300",
			"name": "官田",
			"y": "g"
		}, {
			"id": "710350",
			"pid": "710300",
			"name": "麻豆",
			"y": "m"
		}, {
			"id": "710351",
			"pid": "710300",
			"name": "佳里",
			"y": "j"
		}, {
			"id": "710352",
			"pid": "710300",
			"name": "西港",
			"y": "x"
		}, {
			"id": "710353",
			"pid": "710300",
			"name": "七股",
			"y": "q"
		}, {
			"id": "710354",
			"pid": "710300",
			"name": "将军",
			"y": "j"
		}, {
			"id": "710355",
			"pid": "710300",
			"name": "学甲",
			"y": "x"
		}, {
			"id": "710356",
			"pid": "710300",
			"name": "北门",
			"y": "b"
		}, {
			"id": "710357",
			"pid": "710300",
			"name": "新营",
			"y": "x"
		}, {
			"id": "710358",
			"pid": "710300",
			"name": "后壁",
			"y": "h"
		}, {
			"id": "710359",
			"pid": "710300",
			"name": "白河",
			"y": "b"
		}, {
			"id": "710360",
			"pid": "710300",
			"name": "东山",
			"y": "d"
		}, {
			"id": "710361",
			"pid": "710300",
			"name": "六甲",
			"y": "l"
		}, {
			"id": "710362",
			"pid": "710300",
			"name": "下营",
			"y": "x"
		}, {
			"id": "710363",
			"pid": "710300",
			"name": "柳营",
			"y": "l"
		}, {
			"id": "710364",
			"pid": "710300",
			"name": "盐水",
			"y": "y"
		}, {
			"id": "710365",
			"pid": "710300",
			"name": "善化",
			"y": "s"
		}, {
			"id": "710366",
			"pid": "710300",
			"name": "大内",
			"y": "d"
		}, {
			"id": "710367",
			"pid": "710300",
			"name": "山上",
			"y": "s"
		}, {
			"id": "710368",
			"pid": "710300",
			"name": "新市",
			"y": "x"
		}, {
			"id": "710369",
			"pid": "710300",
			"name": "安定",
			"y": "a"
		}]
	}, {
		"id": "710400",
		"pid": "710000",
		"name": "台中",
		"y": "t",
		"child": [{
			"id": "710401",
			"pid": "710400",
			"name": "中区",
			"y": "z"
		}, {
			"id": "710402",
			"pid": "710400",
			"name": "东区",
			"y": "d"
		}, {
			"id": "710403",
			"pid": "710400",
			"name": "南区",
			"y": "n"
		}, {
			"id": "710404",
			"pid": "710400",
			"name": "西区",
			"y": "x"
		}, {
			"id": "710405",
			"pid": "710400",
			"name": "北区",
			"y": "b"
		}, {
			"id": "710406",
			"pid": "710400",
			"name": "北屯",
			"y": "b"
		}, {
			"id": "710407",
			"pid": "710400",
			"name": "西屯",
			"y": "x"
		}, {
			"id": "710408",
			"pid": "710400",
			"name": "南屯",
			"y": "n"
		}, {
			"id": "710431",
			"pid": "710400",
			"name": "太平",
			"y": "t"
		}, {
			"id": "710432",
			"pid": "710400",
			"name": "大里",
			"y": "d"
		}, {
			"id": "710433",
			"pid": "710400",
			"name": "雾峰",
			"y": "w"
		}, {
			"id": "710434",
			"pid": "710400",
			"name": "乌日",
			"y": "w"
		}, {
			"id": "710435",
			"pid": "710400",
			"name": "丰原",
			"y": "f"
		}, {
			"id": "710436",
			"pid": "710400",
			"name": "后里",
			"y": "h"
		}, {
			"id": "710437",
			"pid": "710400",
			"name": "石冈",
			"y": "s"
		}, {
			"id": "710438",
			"pid": "710400",
			"name": "东势",
			"y": "d"
		}, {
			"id": "710439",
			"pid": "710400",
			"name": "和平",
			"y": "h"
		}, {
			"id": "710440",
			"pid": "710400",
			"name": "新社",
			"y": "x"
		}, {
			"id": "710441",
			"pid": "710400",
			"name": "潭子",
			"y": "t"
		}, {
			"id": "710442",
			"pid": "710400",
			"name": "大雅",
			"y": "d"
		}, {
			"id": "710443",
			"pid": "710400",
			"name": "神冈",
			"y": "s"
		}, {
			"id": "710444",
			"pid": "710400",
			"name": "大肚",
			"y": "d"
		}, {
			"id": "710445",
			"pid": "710400",
			"name": "沙鹿",
			"y": "s"
		}, {
			"id": "710446",
			"pid": "710400",
			"name": "龙井",
			"y": "l"
		}, {
			"id": "710447",
			"pid": "710400",
			"name": "梧栖",
			"y": "w"
		}, {
			"id": "710448",
			"pid": "710400",
			"name": "清水",
			"y": "q"
		}, {
			"id": "710449",
			"pid": "710400",
			"name": "大甲",
			"y": "d"
		}, {
			"id": "710450",
			"pid": "710400",
			"name": "外埔",
			"y": "w"
		}, {
			"id": "710451",
			"pid": "710400",
			"name": "大安",
			"y": "d"
		}]
	}, {
		"id": "710600",
		"pid": "710000",
		"name": "南投",
		"y": "n",
		"child": [{
			"id": "710614",
			"pid": "710600",
			"name": "南投市",
			"y": "n"
		}, {
			"id": "710615",
			"pid": "710600",
			"name": "中寮",
			"y": "z"
		}, {
			"id": "710616",
			"pid": "710600",
			"name": "草屯",
			"y": "c"
		}, {
			"id": "710617",
			"pid": "710600",
			"name": "国姓",
			"y": "g"
		}, {
			"id": "710618",
			"pid": "710600",
			"name": "埔里",
			"y": "b"
		}, {
			"id": "710619",
			"pid": "710600",
			"name": "仁爱",
			"y": "r"
		}, {
			"id": "710620",
			"pid": "710600",
			"name": "名间",
			"y": "m"
		}, {
			"id": "710621",
			"pid": "710600",
			"name": "集集",
			"y": "j"
		}, {
			"id": "710622",
			"pid": "710600",
			"name": "水里",
			"y": "s"
		}, {
			"id": "710623",
			"pid": "710600",
			"name": "鱼池",
			"y": "y"
		}, {
			"id": "710624",
			"pid": "710600",
			"name": "信义",
			"y": "x"
		}, {
			"id": "710625",
			"pid": "710600",
			"name": "竹山",
			"y": "z"
		}, {
			"id": "710626",
			"pid": "710600",
			"name": "鹿谷",
			"y": "l"
		}]
	}, {
		"id": "710700",
		"pid": "710000",
		"name": "基隆",
		"y": "j",
		"child": [{
			"id": "710701",
			"pid": "710700",
			"name": "仁爱",
			"y": "r"
		}, {
			"id": "710702",
			"pid": "710700",
			"name": "信义",
			"y": "x"
		}, {
			"id": "710703",
			"pid": "710700",
			"name": "中正",
			"y": "z"
		}, {
			"id": "710704",
			"pid": "710700",
			"name": "中山",
			"y": "z"
		}, {
			"id": "710705",
			"pid": "710700",
			"name": "安乐",
			"y": "a"
		}, {
			"id": "710706",
			"pid": "710700",
			"name": "暖暖",
			"y": "n"
		}, {
			"id": "710707",
			"pid": "710700",
			"name": "七堵",
			"y": "q"
		}]
	}, {
		"id": "710800",
		"pid": "710000",
		"name": "新竹市",
		"y": "x",
		"child": [{
			"id": "710801",
			"pid": "710800",
			"name": "东区",
			"y": "d"
		}, {
			"id": "710802",
			"pid": "710800",
			"name": "北区",
			"y": "b"
		}, {
			"id": "710803",
			"pid": "710800",
			"name": "香山",
			"y": "x"
		}]
	}, {
		"id": "710900",
		"pid": "710000",
		"name": "嘉义市",
		"y": "j",
		"child": [{
			"id": "710901",
			"pid": "710900",
			"name": "东区",
			"y": "d"
		}, {
			"id": "710902",
			"pid": "710900",
			"name": "西区",
			"y": "x"
		}]
	}, {
		"id": "711100",
		"pid": "710000",
		"name": "新北",
		"y": "x",
		"child": [{
			"id": "711130",
			"pid": "711100",
			"name": "万里",
			"y": "w"
		}, {
			"id": "711131",
			"pid": "711100",
			"name": "金山",
			"y": "j"
		}, {
			"id": "711132",
			"pid": "711100",
			"name": "板桥",
			"y": "b"
		}, {
			"id": "711133",
			"pid": "711100",
			"name": "汐止",
			"y": "x"
		}, {
			"id": "711134",
			"pid": "711100",
			"name": "深坑",
			"y": "s"
		}, {
			"id": "711135",
			"pid": "711100",
			"name": "石碇",
			"y": "s"
		}, {
			"id": "711136",
			"pid": "711100",
			"name": "瑞芳",
			"y": "r"
		}, {
			"id": "711137",
			"pid": "711100",
			"name": "平溪",
			"y": "p"
		}, {
			"id": "711138",
			"pid": "711100",
			"name": "双溪",
			"y": "s"
		}, {
			"id": "711139",
			"pid": "711100",
			"name": "贡寮",
			"y": "g"
		}, {
			"id": "711140",
			"pid": "711100",
			"name": "新店",
			"y": "x"
		}, {
			"id": "711141",
			"pid": "711100",
			"name": "坪林",
			"y": "p"
		}, {
			"id": "711142",
			"pid": "711100",
			"name": "乌来",
			"y": "w"
		}, {
			"id": "711143",
			"pid": "711100",
			"name": "永和",
			"y": "y"
		}, {
			"id": "711144",
			"pid": "711100",
			"name": "中和",
			"y": "z"
		}, {
			"id": "711145",
			"pid": "711100",
			"name": "土城",
			"y": "t"
		}, {
			"id": "711146",
			"pid": "711100",
			"name": "三峡",
			"y": "s"
		}, {
			"id": "711147",
			"pid": "711100",
			"name": "树林",
			"y": "s"
		}, {
			"id": "711148",
			"pid": "711100",
			"name": "莺歌",
			"y": "y"
		}, {
			"id": "711149",
			"pid": "711100",
			"name": "三重",
			"y": "s"
		}, {
			"id": "711150",
			"pid": "711100",
			"name": "新庄",
			"y": "x"
		}, {
			"id": "711151",
			"pid": "711100",
			"name": "泰山",
			"y": "t"
		}, {
			"id": "711152",
			"pid": "711100",
			"name": "林口",
			"y": "l"
		}, {
			"id": "711153",
			"pid": "711100",
			"name": "芦洲",
			"y": "l"
		}, {
			"id": "711154",
			"pid": "711100",
			"name": "五股",
			"y": "w"
		}, {
			"id": "711155",
			"pid": "711100",
			"name": "八里",
			"y": "b"
		}, {
			"id": "711156",
			"pid": "711100",
			"name": "淡水",
			"y": "d"
		}, {
			"id": "711157",
			"pid": "711100",
			"name": "三芝",
			"y": "s"
		}, {
			"id": "711158",
			"pid": "711100",
			"name": "石门",
			"y": "s"
		}]
	}, {
		"id": "711200",
		"pid": "710000",
		"name": "宜兰",
		"y": "y",
		"child": [{
			"id": "711214",
			"pid": "711200",
			"name": "宜兰市",
			"y": "y"
		}, {
			"id": "711215",
			"pid": "711200",
			"name": "头城",
			"y": "t"
		}, {
			"id": "711216",
			"pid": "711200",
			"name": "礁溪",
			"y": "j"
		}, {
			"id": "711217",
			"pid": "711200",
			"name": "壮围",
			"y": "z"
		}, {
			"id": "711218",
			"pid": "711200",
			"name": "员山",
			"y": "y"
		}, {
			"id": "711219",
			"pid": "711200",
			"name": "罗东",
			"y": "l"
		}, {
			"id": "711220",
			"pid": "711200",
			"name": "三星",
			"y": "s"
		}, {
			"id": "711221",
			"pid": "711200",
			"name": "大同",
			"y": "d"
		}, {
			"id": "711222",
			"pid": "711200",
			"name": "五结",
			"y": "w"
		}, {
			"id": "711223",
			"pid": "711200",
			"name": "冬山",
			"y": "d"
		}, {
			"id": "711224",
			"pid": "711200",
			"name": "苏澳",
			"y": "s"
		}, {
			"id": "711225",
			"pid": "711200",
			"name": "南澳",
			"y": "n"
		}]
	}, {
		"id": "711300",
		"pid": "710000",
		"name": "新竹县",
		"y": "x",
		"child": [{
			"id": "711314",
			"pid": "711300",
			"name": "竹北",
			"y": "z"
		}, {
			"id": "711315",
			"pid": "711300",
			"name": "湖口",
			"y": "h"
		}, {
			"id": "711316",
			"pid": "711300",
			"name": "新丰",
			"y": "x"
		}, {
			"id": "711317",
			"pid": "711300",
			"name": "新埔",
			"y": "x"
		}, {
			"id": "711318",
			"pid": "711300",
			"name": "关西",
			"y": "g"
		}, {
			"id": "711319",
			"pid": "711300",
			"name": "芎林",
			"y": "x"
		}, {
			"id": "711320",
			"pid": "711300",
			"name": "宝山",
			"y": "b"
		}, {
			"id": "711321",
			"pid": "711300",
			"name": "竹东",
			"y": "z"
		}, {
			"id": "711322",
			"pid": "711300",
			"name": "五峰",
			"y": "w"
		}, {
			"id": "711323",
			"pid": "711300",
			"name": "横山",
			"y": "h"
		}, {
			"id": "711324",
			"pid": "711300",
			"name": "尖石",
			"y": "j"
		}, {
			"id": "711325",
			"pid": "711300",
			"name": "北埔",
			"y": "b"
		}, {
			"id": "711326",
			"pid": "711300",
			"name": "峨眉",
			"y": "e"
		}]
	}, {
		"id": "711400",
		"pid": "710000",
		"name": "桃园",
		"y": "t",
		"child": [{
			"id": "711414",
			"pid": "711400",
			"name": "中坜",
			"y": "z"
		}, {
			"id": "711415",
			"pid": "711400",
			"name": "平镇",
			"y": "p"
		}, {
			"id": "711416",
			"pid": "711400",
			"name": "龙潭",
			"y": "l"
		}, {
			"id": "711417",
			"pid": "711400",
			"name": "杨梅",
			"y": "y"
		}, {
			"id": "711418",
			"pid": "711400",
			"name": "新屋",
			"y": "x"
		}, {
			"id": "711419",
			"pid": "711400",
			"name": "观音",
			"y": "g"
		}, {
			"id": "711420",
			"pid": "711400",
			"name": "桃园区",
			"y": "t"
		}, {
			"id": "711421",
			"pid": "711400",
			"name": "龟山",
			"y": "g"
		}, {
			"id": "711422",
			"pid": "711400",
			"name": "八德",
			"y": "b"
		}, {
			"id": "711423",
			"pid": "711400",
			"name": "大溪",
			"y": "d"
		}, {
			"id": "711424",
			"pid": "711400",
			"name": "复兴",
			"y": "f"
		}, {
			"id": "711425",
			"pid": "711400",
			"name": "大园",
			"y": "d"
		}, {
			"id": "711426",
			"pid": "711400",
			"name": "芦竹",
			"y": "l"
		}]
	}, {
		"id": "711500",
		"pid": "710000",
		"name": "苗栗",
		"y": "m",
		"child": [{
			"id": "711519",
			"pid": "711500",
			"name": "竹南",
			"y": "z"
		}, {
			"id": "711520",
			"pid": "711500",
			"name": "头份",
			"y": "t"
		}, {
			"id": "711521",
			"pid": "711500",
			"name": "三湾",
			"y": "s"
		}, {
			"id": "711522",
			"pid": "711500",
			"name": "南庄",
			"y": "n"
		}, {
			"id": "711523",
			"pid": "711500",
			"name": "狮潭",
			"y": "s"
		}, {
			"id": "711524",
			"pid": "711500",
			"name": "后龙",
			"y": "h"
		}, {
			"id": "711525",
			"pid": "711500",
			"name": "通霄",
			"y": "t"
		}, {
			"id": "711526",
			"pid": "711500",
			"name": "苑里",
			"y": "y"
		}, {
			"id": "711527",
			"pid": "711500",
			"name": "苗栗市",
			"y": "m"
		}, {
			"id": "711528",
			"pid": "711500",
			"name": "造桥",
			"y": "z"
		}, {
			"id": "711529",
			"pid": "711500",
			"name": "头屋",
			"y": "t"
		}, {
			"id": "711530",
			"pid": "711500",
			"name": "公馆",
			"y": "g"
		}, {
			"id": "711531",
			"pid": "711500",
			"name": "大湖",
			"y": "d"
		}, {
			"id": "711532",
			"pid": "711500",
			"name": "泰安",
			"y": "t"
		}, {
			"id": "711533",
			"pid": "711500",
			"name": "铜锣",
			"y": "t"
		}, {
			"id": "711534",
			"pid": "711500",
			"name": "三义",
			"y": "s"
		}, {
			"id": "711535",
			"pid": "711500",
			"name": "西湖",
			"y": "x"
		}, {
			"id": "711536",
			"pid": "711500",
			"name": "卓兰",
			"y": "z"
		}]
	}, {
		"id": "711700",
		"pid": "710000",
		"name": "彰化",
		"y": "z",
		"child": [{
			"id": "711727",
			"pid": "711700",
			"name": "彰化市",
			"y": "z"
		}, {
			"id": "711728",
			"pid": "711700",
			"name": "芬园",
			"y": "f"
		}, {
			"id": "711729",
			"pid": "711700",
			"name": "花坛",
			"y": "h"
		}, {
			"id": "711730",
			"pid": "711700",
			"name": "秀水",
			"y": "x"
		}, {
			"id": "711731",
			"pid": "711700",
			"name": "鹿港",
			"y": "l"
		}, {
			"id": "711732",
			"pid": "711700",
			"name": "福兴",
			"y": "f"
		}, {
			"id": "711733",
			"pid": "711700",
			"name": "线西",
			"y": "x"
		}, {
			"id": "711734",
			"pid": "711700",
			"name": "和美",
			"y": "h"
		}, {
			"id": "711735",
			"pid": "711700",
			"name": "伸港",
			"y": "s"
		}, {
			"id": "711736",
			"pid": "711700",
			"name": "员林",
			"y": "y"
		}, {
			"id": "711737",
			"pid": "711700",
			"name": "社头",
			"y": "s"
		}, {
			"id": "711738",
			"pid": "711700",
			"name": "永靖",
			"y": "y"
		}, {
			"id": "711739",
			"pid": "711700",
			"name": "埔心",
			"y": "b"
		}, {
			"id": "711740",
			"pid": "711700",
			"name": "溪湖",
			"y": "x"
		}, {
			"id": "711741",
			"pid": "711700",
			"name": "大村",
			"y": "d"
		}, {
			"id": "711742",
			"pid": "711700",
			"name": "埔盐",
			"y": "b"
		}, {
			"id": "711743",
			"pid": "711700",
			"name": "田中",
			"y": "t"
		}, {
			"id": "711744",
			"pid": "711700",
			"name": "北斗",
			"y": "b"
		}, {
			"id": "711745",
			"pid": "711700",
			"name": "田尾",
			"y": "t"
		}, {
			"id": "711746",
			"pid": "711700",
			"name": "埤头",
			"y": "p"
		}, {
			"id": "711747",
			"pid": "711700",
			"name": "溪州",
			"y": "x"
		}, {
			"id": "711748",
			"pid": "711700",
			"name": "竹塘",
			"y": "z"
		}, {
			"id": "711749",
			"pid": "711700",
			"name": "二林",
			"y": "e"
		}, {
			"id": "711750",
			"pid": "711700",
			"name": "大城",
			"y": "d"
		}, {
			"id": "711751",
			"pid": "711700",
			"name": "芳苑",
			"y": "f"
		}, {
			"id": "711752",
			"pid": "711700",
			"name": "二水",
			"y": "e"
		}]
	}, {
		"id": "711900",
		"pid": "710000",
		"name": "嘉义县",
		"y": "j",
		"child": [{
			"id": "711919",
			"pid": "711900",
			"name": "番路",
			"y": "f"
		}, {
			"id": "711920",
			"pid": "711900",
			"name": "梅山",
			"y": "m"
		}, {
			"id": "711921",
			"pid": "711900",
			"name": "竹崎",
			"y": "z"
		}, {
			"id": "711922",
			"pid": "711900",
			"name": "阿里山",
			"y": "a"
		}, {
			"id": "711923",
			"pid": "711900",
			"name": "中埔",
			"y": "z"
		}, {
			"id": "711924",
			"pid": "711900",
			"name": "大埔",
			"y": "d"
		}, {
			"id": "711925",
			"pid": "711900",
			"name": "水上",
			"y": "s"
		}, {
			"id": "711926",
			"pid": "711900",
			"name": "鹿草",
			"y": "l"
		}, {
			"id": "711927",
			"pid": "711900",
			"name": "太保",
			"y": "t"
		}, {
			"id": "711928",
			"pid": "711900",
			"name": "朴子",
			"y": "p"
		}, {
			"id": "711929",
			"pid": "711900",
			"name": "东石",
			"y": "d"
		}, {
			"id": "711930",
			"pid": "711900",
			"name": "六脚",
			"y": "l"
		}, {
			"id": "711931",
			"pid": "711900",
			"name": "新港",
			"y": "x"
		}, {
			"id": "711932",
			"pid": "711900",
			"name": "民雄",
			"y": "m"
		}, {
			"id": "711933",
			"pid": "711900",
			"name": "大林",
			"y": "d"
		}, {
			"id": "711934",
			"pid": "711900",
			"name": "溪口",
			"y": "x"
		}, {
			"id": "711935",
			"pid": "711900",
			"name": "义竹",
			"y": "y"
		}, {
			"id": "711936",
			"pid": "711900",
			"name": "布袋",
			"y": "b"
		}]
	}, {
		"id": "712100",
		"pid": "710000",
		"name": "云林",
		"y": "y",
		"child": [{
			"id": "712121",
			"pid": "712100",
			"name": "斗南",
			"y": "d"
		}, {
			"id": "712122",
			"pid": "712100",
			"name": "大埤",
			"y": "d"
		}, {
			"id": "712123",
			"pid": "712100",
			"name": "虎尾",
			"y": "h"
		}, {
			"id": "712124",
			"pid": "712100",
			"name": "土库",
			"y": "t"
		}, {
			"id": "712125",
			"pid": "712100",
			"name": "褒忠",
			"y": "b"
		}, {
			"id": "712126",
			"pid": "712100",
			"name": "东势",
			"y": "d"
		}, {
			"id": "712127",
			"pid": "712100",
			"name": "台西",
			"y": "t"
		}, {
			"id": "712128",
			"pid": "712100",
			"name": "仑背",
			"y": "l"
		}, {
			"id": "712129",
			"pid": "712100",
			"name": "麦寮",
			"y": "m"
		}, {
			"id": "712130",
			"pid": "712100",
			"name": "斗六",
			"y": "d"
		}, {
			"id": "712131",
			"pid": "712100",
			"name": "林内",
			"y": "l"
		}, {
			"id": "712132",
			"pid": "712100",
			"name": "古坑",
			"y": "g"
		}, {
			"id": "712133",
			"pid": "712100",
			"name": "莿桐",
			"y": "c"
		}, {
			"id": "712134",
			"pid": "712100",
			"name": "西螺",
			"y": "x"
		}, {
			"id": "712135",
			"pid": "712100",
			"name": "二仑",
			"y": "e"
		}, {
			"id": "712136",
			"pid": "712100",
			"name": "北港",
			"y": "b"
		}, {
			"id": "712137",
			"pid": "712100",
			"name": "水林",
			"y": "s"
		}, {
			"id": "712138",
			"pid": "712100",
			"name": "口湖",
			"y": "k"
		}, {
			"id": "712139",
			"pid": "712100",
			"name": "四湖",
			"y": "s"
		}, {
			"id": "712140",
			"pid": "712100",
			"name": "元长",
			"y": "y"
		}]
	}, {
		"id": "712400",
		"pid": "710000",
		"name": "屏东",
		"y": "p",
		"child": [{
			"id": "712434",
			"pid": "712400",
			"name": "屏东市",
			"y": "p"
		}, {
			"id": "712435",
			"pid": "712400",
			"name": "三地门",
			"y": "s"
		}, {
			"id": "712436",
			"pid": "712400",
			"name": "雾台",
			"y": "w"
		}, {
			"id": "712437",
			"pid": "712400",
			"name": "玛家",
			"y": "m"
		}, {
			"id": "712438",
			"pid": "712400",
			"name": "九如",
			"y": "j"
		}, {
			"id": "712439",
			"pid": "712400",
			"name": "里港",
			"y": "l"
		}, {
			"id": "712440",
			"pid": "712400",
			"name": "高树",
			"y": "g"
		}, {
			"id": "712441",
			"pid": "712400",
			"name": "盐埔",
			"y": "y"
		}, {
			"id": "712442",
			"pid": "712400",
			"name": "长治",
			"y": "c"
		}, {
			"id": "712443",
			"pid": "712400",
			"name": "麟洛",
			"y": "l"
		}, {
			"id": "712444",
			"pid": "712400",
			"name": "竹田",
			"y": "z"
		}, {
			"id": "712445",
			"pid": "712400",
			"name": "内埔",
			"y": "n"
		}, {
			"id": "712446",
			"pid": "712400",
			"name": "万丹",
			"y": "w"
		}, {
			"id": "712447",
			"pid": "712400",
			"name": "潮州",
			"y": "c"
		}, {
			"id": "712448",
			"pid": "712400",
			"name": "泰武",
			"y": "t"
		}, {
			"id": "712449",
			"pid": "712400",
			"name": "来义",
			"y": "l"
		}, {
			"id": "712450",
			"pid": "712400",
			"name": "万峦",
			"y": "w"
		}, {
			"id": "712451",
			"pid": "712400",
			"name": "崁顶",
			"y": "k"
		}, {
			"id": "712452",
			"pid": "712400",
			"name": "新埤",
			"y": "x"
		}, {
			"id": "712453",
			"pid": "712400",
			"name": "南州",
			"y": "n"
		}, {
			"id": "712454",
			"pid": "712400",
			"name": "林边",
			"y": "l"
		}, {
			"id": "712455",
			"pid": "712400",
			"name": "东港",
			"y": "d"
		}, {
			"id": "712456",
			"pid": "712400",
			"name": "琉球",
			"y": "l"
		}, {
			"id": "712457",
			"pid": "712400",
			"name": "佳冬",
			"y": "j"
		}, {
			"id": "712458",
			"pid": "712400",
			"name": "新园",
			"y": "x"
		}, {
			"id": "712459",
			"pid": "712400",
			"name": "枋寮",
			"y": "f"
		}, {
			"id": "712460",
			"pid": "712400",
			"name": "枋山",
			"y": "f"
		}, {
			"id": "712461",
			"pid": "712400",
			"name": "春日",
			"y": "c"
		}, {
			"id": "712462",
			"pid": "712400",
			"name": "狮子",
			"y": "s"
		}, {
			"id": "712463",
			"pid": "712400",
			"name": "车城",
			"y": "c"
		}, {
			"id": "712464",
			"pid": "712400",
			"name": "牡丹",
			"y": "m"
		}, {
			"id": "712465",
			"pid": "712400",
			"name": "恒春",
			"y": "h"
		}, {
			"id": "712466",
			"pid": "712400",
			"name": "满州",
			"y": "m"
		}]
	}, {
		"id": "712500",
		"pid": "710000",
		"name": "台东",
		"y": "t",
		"child": [{
			"id": "712517",
			"pid": "712500",
			"name": "台东市",
			"y": "t"
		}, {
			"id": "712518",
			"pid": "712500",
			"name": "绿岛",
			"y": "l"
		}, {
			"id": "712519",
			"pid": "712500",
			"name": "兰屿",
			"y": "l"
		}, {
			"id": "712520",
			"pid": "712500",
			"name": "延平",
			"y": "y"
		}, {
			"id": "712521",
			"pid": "712500",
			"name": "卑南",
			"y": "b"
		}, {
			"id": "712522",
			"pid": "712500",
			"name": "鹿野",
			"y": "l"
		}, {
			"id": "712523",
			"pid": "712500",
			"name": "关山",
			"y": "g"
		}, {
			"id": "712524",
			"pid": "712500",
			"name": "海端",
			"y": "h"
		}, {
			"id": "712525",
			"pid": "712500",
			"name": "池上",
			"y": "c"
		}, {
			"id": "712526",
			"pid": "712500",
			"name": "东河",
			"y": "d"
		}, {
			"id": "712527",
			"pid": "712500",
			"name": "成功",
			"y": "c"
		}, {
			"id": "712528",
			"pid": "712500",
			"name": "长滨",
			"y": "c"
		}, {
			"id": "712529",
			"pid": "712500",
			"name": "金峰",
			"y": "j"
		}, {
			"id": "712530",
			"pid": "712500",
			"name": "大武",
			"y": "d"
		}, {
			"id": "712531",
			"pid": "712500",
			"name": "达仁",
			"y": "d"
		}, {
			"id": "712532",
			"pid": "712500",
			"name": "太麻里",
			"y": "t"
		}]
	}, {
		"id": "712600",
		"pid": "710000",
		"name": "花莲",
		"y": "h",
		"child": [{
			"id": "712615",
			"pid": "712600",
			"name": "花莲市",
			"y": "h"
		}, {
			"id": "712616",
			"pid": "712600",
			"name": "新城",
			"y": "x"
		}, {
			"id": "712618",
			"pid": "712600",
			"name": "秀林",
			"y": "x"
		}, {
			"id": "712619",
			"pid": "712600",
			"name": "吉安",
			"y": "j"
		}, {
			"id": "712620",
			"pid": "712600",
			"name": "寿丰",
			"y": "s"
		}, {
			"id": "712621",
			"pid": "712600",
			"name": "凤林",
			"y": "f"
		}, {
			"id": "712622",
			"pid": "712600",
			"name": "光复",
			"y": "g"
		}, {
			"id": "712623",
			"pid": "712600",
			"name": "丰滨",
			"y": "f"
		}, {
			"id": "712624",
			"pid": "712600",
			"name": "瑞穗",
			"y": "r"
		}, {
			"id": "712625",
			"pid": "712600",
			"name": "万荣",
			"y": "w"
		}, {
			"id": "712626",
			"pid": "712600",
			"name": "玉里",
			"y": "y"
		}, {
			"id": "712627",
			"pid": "712600",
			"name": "卓溪",
			"y": "z"
		}, {
			"id": "712628",
			"pid": "712600",
			"name": "富里",
			"y": "f"
		}]
	}, {
		"id": "712700",
		"pid": "710000",
		"name": "澎湖",
		"y": "p",
		"child": [{
			"id": "712707",
			"pid": "712700",
			"name": "马公",
			"y": "m"
		}, {
			"id": "712708",
			"pid": "712700",
			"name": "西屿",
			"y": "x"
		}, {
			"id": "712709",
			"pid": "712700",
			"name": "望安",
			"y": "w"
		}, {
			"id": "712710",
			"pid": "712700",
			"name": "七美",
			"y": "q"
		}, {
			"id": "712711",
			"pid": "712700",
			"name": "白沙",
			"y": "b"
		}, {
			"id": "712712",
			"pid": "712700",
			"name": "湖西",
			"y": "h"
		}]
	}]
}, {
	"id": "810000",
	"pid": "0",
	"name": "香港",
	"y": "~1",
	"child": [{
		"id": "810000",
		"pid": "810000",
		"name": "香港",
		"y": "x",
		"child": [{
			"id": "810000",
			"pid": "810000",
			"name": "香港",
			"y": "x"
		}]
	}]
}, {
	"id": "820000",
	"pid": "0",
	"name": "澳门",
	"y": "~2",
	"child": [{
		"id": "820000",
		"pid": "820000",
		"name": "澳门",
		"y": "a",
		"child": [{
			"id": "820000",
			"pid": "820000",
			"name": "澳门",
			"y": "a"
		}]
	}]
}, {
	"id": "910000",
	"pid": "0",
	"name": "国外",
	"y": "~4",
	"child": [{
		"id": "910000",
		"pid": "910000",
		"name": "国外",
		"y": "g",
		"child": [{
			"id": "910000",
			"pid": "910000",
			"name": "国外",
			"y": "g"
		}]
	}]
}]



// WEBPACK FOOTER //
// ./src/common/region-data.js